(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":22}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
},{"core-js/library/fn/json/stringify":23}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };
},{"core-js/library/fn/map":24}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/number/is-integer"), __esModule: true };
},{"core-js/library/fn/number/is-integer":25}],5:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":26}],6:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":27}],7:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":28}],8:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/get-prototype-of":29}],9:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":30}],10:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/set-prototype-of":31}],11:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":32}],12:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":33}],13:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":34}],14:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _promise = require("../core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
},{"../core-js/promise":11}],15:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],16:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":7}],17:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
},{"../core-js/object/define-property":7}],18:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require("../core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require("../core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
},{"../core-js/object/create":6,"../core-js/object/set-prototype-of":10,"../helpers/typeof":20}],19:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
},{"../helpers/typeof":20}],20:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":12,"../core-js/symbol/iterator":13}],21:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":164}],22:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":49,"../../modules/es6.array.from":121,"../../modules/es6.string.iterator":133}],23:[function(require,module,exports){
var core = require('../../modules/_core');
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

},{"../../modules/_core":49}],24:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
require('../modules/es7.map.to-json');
require('../modules/es7.map.of');
require('../modules/es7.map.from');
module.exports = require('../modules/_core').Map;

},{"../modules/_core":49,"../modules/es6.map":123,"../modules/es6.object.to-string":131,"../modules/es6.string.iterator":133,"../modules/es7.map.from":135,"../modules/es7.map.of":136,"../modules/es7.map.to-json":137,"../modules/web.dom.iterable":142}],25:[function(require,module,exports){
require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;

},{"../../modules/_core":49,"../../modules/es6.number.is-integer":124}],26:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":49,"../../modules/es6.object.assign":125}],27:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

},{"../../modules/_core":49,"../../modules/es6.object.create":126}],28:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

},{"../../modules/_core":49,"../../modules/es6.object.define-property":127}],29:[function(require,module,exports){
require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;

},{"../../modules/_core":49,"../../modules/es6.object.get-prototype-of":128}],30:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;

},{"../../modules/_core":49,"../../modules/es6.object.keys":129}],31:[function(require,module,exports){
require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;

},{"../../modules/_core":49,"../../modules/es6.object.set-prototype-of":130}],32:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.promise.finally');
require('../modules/es7.promise.try');
module.exports = require('../modules/_core').Promise;

},{"../modules/_core":49,"../modules/es6.object.to-string":131,"../modules/es6.promise":132,"../modules/es6.string.iterator":133,"../modules/es7.promise.finally":138,"../modules/es7.promise.try":139,"../modules/web.dom.iterable":142}],33:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":49,"../../modules/es6.object.to-string":131,"../../modules/es6.symbol":134,"../../modules/es7.symbol.async-iterator":140,"../../modules/es7.symbol.observable":141}],34:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":118,"../../modules/es6.string.iterator":133,"../../modules/web.dom.iterable":142}],35:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],36:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],37:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],38:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":70}],39:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":59}],40:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":109,"./_to-iobject":111,"./_to-length":112}],41:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":43,"./_ctx":51,"./_iobject":66,"./_to-length":112,"./_to-object":113}],42:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":68,"./_is-object":70,"./_wks":119}],43:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":42}],44:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":45,"./_wks":119}],45:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],46:[function(require,module,exports){
'use strict';
var dP = require('./_object-dp').f;
var create = require('./_object-create');
var redefineAll = require('./_redefine-all');
var ctx = require('./_ctx');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var $iterDefine = require('./_iter-define');
var step = require('./_iter-step');
var setSpecies = require('./_set-species');
var DESCRIPTORS = require('./_descriptors');
var fastKey = require('./_meta').fastKey;
var validate = require('./_validate-collection');
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"./_an-instance":37,"./_ctx":51,"./_descriptors":53,"./_for-of":59,"./_iter-define":73,"./_iter-step":75,"./_meta":78,"./_object-create":82,"./_object-dp":83,"./_redefine-all":97,"./_set-species":102,"./_validate-collection":116}],47:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof');
var from = require('./_array-from-iterable');
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

},{"./_array-from-iterable":39,"./_classof":44}],48:[function(require,module,exports){
'use strict';
var global = require('./_global');
var $export = require('./_export');
var meta = require('./_meta');
var fails = require('./_fails');
var hide = require('./_hide');
var redefineAll = require('./_redefine-all');
var forOf = require('./_for-of');
var anInstance = require('./_an-instance');
var isObject = require('./_is-object');
var setToStringTag = require('./_set-to-string-tag');
var dP = require('./_object-dp').f;
var each = require('./_array-methods')(0);
var DESCRIPTORS = require('./_descriptors');

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"./_an-instance":37,"./_array-methods":41,"./_descriptors":53,"./_export":57,"./_fails":58,"./_for-of":59,"./_global":60,"./_hide":62,"./_is-object":70,"./_meta":78,"./_object-dp":83,"./_redefine-all":97,"./_set-to-string-tag":103}],49:[function(require,module,exports){
var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],50:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":83,"./_property-desc":96}],51:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":35}],52:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],53:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":58}],54:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":60,"./_is-object":70}],55:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],56:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":88,"./_object-keys":91,"./_object-pie":92}],57:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":49,"./_ctx":51,"./_global":60,"./_hide":62}],58:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],59:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":38,"./_ctx":51,"./_is-array-iter":67,"./_iter-call":71,"./_to-length":112,"./core.get-iterator-method":120}],60:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],61:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],62:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":53,"./_object-dp":83,"./_property-desc":96}],63:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":60}],64:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":53,"./_dom-create":54,"./_fails":58}],65:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],66:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":45}],67:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":76,"./_wks":119}],68:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":45}],69:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"./_is-object":70}],70:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],71:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":38}],72:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":62,"./_object-create":82,"./_property-desc":96,"./_set-to-string-tag":103,"./_wks":119}],73:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var has = require('./_has');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":57,"./_has":61,"./_hide":62,"./_iter-create":72,"./_iterators":76,"./_library":77,"./_object-gpo":89,"./_redefine":98,"./_set-to-string-tag":103,"./_wks":119}],74:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":119}],75:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],76:[function(require,module,exports){
module.exports = {};

},{}],77:[function(require,module,exports){
module.exports = true;

},{}],78:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":58,"./_has":61,"./_is-object":70,"./_object-dp":83,"./_uid":115}],79:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":45,"./_global":60,"./_task":108}],80:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":35}],81:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

},{"./_fails":58,"./_iobject":66,"./_object-gops":88,"./_object-keys":91,"./_object-pie":92,"./_to-object":113}],82:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":38,"./_dom-create":54,"./_enum-bug-keys":55,"./_html":63,"./_object-dps":84,"./_shared-key":104}],83:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":38,"./_descriptors":53,"./_ie8-dom-define":64,"./_to-primitive":114}],84:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":38,"./_descriptors":53,"./_object-dp":83,"./_object-keys":91}],85:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":53,"./_has":61,"./_ie8-dom-define":64,"./_object-pie":92,"./_property-desc":96,"./_to-iobject":111,"./_to-primitive":114}],86:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":87,"./_to-iobject":111}],87:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":55,"./_object-keys-internal":90}],88:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],89:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":61,"./_shared-key":104,"./_to-object":113}],90:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":40,"./_has":61,"./_shared-key":104,"./_to-iobject":111}],91:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":55,"./_object-keys-internal":90}],92:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],93:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":49,"./_export":57,"./_fails":58}],94:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],95:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":38,"./_is-object":70,"./_new-promise-capability":80}],96:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],97:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

},{"./_hide":62}],98:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":62}],99:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');
var aFunction = require('./_a-function');
var ctx = require('./_ctx');
var forOf = require('./_for-of');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

},{"./_a-function":35,"./_ctx":51,"./_export":57,"./_for-of":59}],100:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

},{"./_export":57}],101:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":38,"./_ctx":51,"./_is-object":70,"./_object-gopd":85}],102:[function(require,module,exports){
'use strict';
var global = require('./_global');
var core = require('./_core');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_core":49,"./_descriptors":53,"./_global":60,"./_object-dp":83,"./_wks":119}],103:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":61,"./_object-dp":83,"./_wks":119}],104:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":105,"./_uid":115}],105:[function(require,module,exports){
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

},{"./_global":60}],106:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":35,"./_an-object":38,"./_wks":119}],107:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":52,"./_to-integer":110}],108:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":45,"./_ctx":51,"./_dom-create":54,"./_global":60,"./_html":63,"./_invoke":65}],109:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":110}],110:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],111:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":52,"./_iobject":66}],112:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":110}],113:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":52}],114:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":70}],115:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],116:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"./_is-object":70}],117:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":49,"./_global":60,"./_library":77,"./_object-dp":83,"./_wks-ext":118}],118:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":119}],119:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":60,"./_shared":105,"./_uid":115}],120:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":44,"./_core":49,"./_iterators":76,"./_wks":119}],121:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":50,"./_ctx":51,"./_export":57,"./_is-array-iter":67,"./_iter-call":71,"./_iter-detect":74,"./_to-length":112,"./_to-object":113,"./core.get-iterator-method":120}],122:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":36,"./_iter-define":73,"./_iter-step":75,"./_iterators":76,"./_to-iobject":111}],123:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var MAP = 'Map';

// 23.1 Map Objects
module.exports = require('./_collection')(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"./_collection":48,"./_collection-strong":46,"./_validate-collection":116}],124:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });

},{"./_export":57,"./_is-integer":69}],125:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":57,"./_object-assign":81}],126:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":57,"./_object-create":82}],127:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":53,"./_export":57,"./_object-dp":83}],128:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":89,"./_object-sap":93,"./_to-object":113}],129:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":91,"./_object-sap":93,"./_to-object":113}],130:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":57,"./_set-proto":101}],131:[function(require,module,exports){

},{}],132:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":35,"./_an-instance":37,"./_classof":44,"./_core":49,"./_ctx":51,"./_export":57,"./_for-of":59,"./_global":60,"./_is-object":70,"./_iter-detect":74,"./_library":77,"./_microtask":79,"./_new-promise-capability":80,"./_perform":94,"./_promise-resolve":95,"./_redefine-all":97,"./_set-species":102,"./_set-to-string-tag":103,"./_species-constructor":106,"./_task":108,"./_wks":119}],133:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":73,"./_string-at":107}],134:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":38,"./_descriptors":53,"./_enum-keys":56,"./_export":57,"./_fails":58,"./_global":60,"./_has":61,"./_hide":62,"./_is-array":68,"./_is-object":70,"./_library":77,"./_meta":78,"./_object-create":82,"./_object-dp":83,"./_object-gopd":85,"./_object-gopn":87,"./_object-gopn-ext":86,"./_object-gops":88,"./_object-keys":91,"./_object-pie":92,"./_property-desc":96,"./_redefine":98,"./_set-to-string-tag":103,"./_shared":105,"./_to-iobject":111,"./_to-primitive":114,"./_uid":115,"./_wks":119,"./_wks-define":117,"./_wks-ext":118}],135:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

},{"./_set-collection-from":99}],136:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

},{"./_set-collection-of":100}],137:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });

},{"./_collection-to-json":47,"./_export":57}],138:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":49,"./_export":57,"./_global":60,"./_promise-resolve":95,"./_species-constructor":106}],139:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":57,"./_new-promise-capability":80,"./_perform":94}],140:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":117}],141:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":117}],142:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":60,"./_hide":62,"./_iterators":76,"./_wks":119,"./es6.array.iterator":122}],143:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_VALUES = {
    emitDelay: 10,
    strictMode: false
};

/**
 * @typedef {object} EventEmitterListenerFunc
 * @property {boolean} once
 * @property {function} fn
 */

/**
 * @class EventEmitter
 *
 * @private
 * @property {Object.<string, EventEmitterListenerFunc[]>} _listeners
 * @property {string[]} events
 */

var EventEmitter = function () {

    /**
     * @constructor
     * @param {{}}      [opts]
     * @param {number}  [opts.emitDelay = 10] - Number in ms. Specifies whether emit will be sync or async. By default - 10ms. If 0 - fires sync
     * @param {boolean} [opts.strictMode = false] - is true, Emitter throws error on emit error with no listeners
     */

    function EventEmitter() {
        var opts = arguments.length <= 0 || arguments[0] === undefined ? DEFAULT_VALUES : arguments[0];

        _classCallCheck(this, EventEmitter);

        var emitDelay = void 0,
            strictMode = void 0;

        if (opts.hasOwnProperty('emitDelay')) {
            emitDelay = opts.emitDelay;
        } else {
            emitDelay = DEFAULT_VALUES.emitDelay;
        }
        this._emitDelay = emitDelay;

        if (opts.hasOwnProperty('strictMode')) {
            strictMode = opts.strictMode;
        } else {
            strictMode = DEFAULT_VALUES.strictMode;
        }
        this._strictMode = strictMode;

        this._listeners = {};
        this.events = [];
    }

    /**
     * @protected
     * @param {string} type
     * @param {function} listener
     * @param {boolean} [once = false]
     */


    _createClass(EventEmitter, [{
        key: '_addListenner',
        value: function _addListenner(type, listener, once) {
            if (typeof listener !== 'function') {
                throw TypeError('listener must be a function');
            }

            if (this.events.indexOf(type) === -1) {
                this._listeners[type] = [{
                    once: once,
                    fn: listener
                }];
                this.events.push(type);
            } else {
                this._listeners[type].push({
                    once: once,
                    fn: listener
                });
            }
        }

        /**
         * Subscribes on event type specified function
         * @param {string} type
         * @param {function} listener
         */

    }, {
        key: 'on',
        value: function on(type, listener) {
            this._addListenner(type, listener, false);
        }

        /**
         * Subscribes on event type specified function to fire only once
         * @param {string} type
         * @param {function} listener
         */

    }, {
        key: 'once',
        value: function once(type, listener) {
            this._addListenner(type, listener, true);
        }

        /**
         * Removes event with specified type. If specified listenerFunc - deletes only one listener of specified type
         * @param {string} eventType
         * @param {function} [listenerFunc]
         */

    }, {
        key: 'off',
        value: function off(eventType, listenerFunc) {
            var _this = this;

            var typeIndex = this.events.indexOf(eventType);
            var hasType = eventType && typeIndex !== -1;

            if (hasType) {
                if (!listenerFunc) {
                    delete this._listeners[eventType];
                    this.events.splice(typeIndex, 1);
                } else {
                    (function () {
                        var removedEvents = [];
                        var typeListeners = _this._listeners[eventType];

                        typeListeners.forEach(
                        /**
                         * @param {EventEmitterListenerFunc} fn
                         * @param {number} idx
                         */
                        function (fn, idx) {
                            if (fn.fn === listenerFunc) {
                                removedEvents.unshift(idx);
                            }
                        });

                        removedEvents.forEach(function (idx) {
                            typeListeners.splice(idx, 1);
                        });

                        if (!typeListeners.length) {
                            _this.events.splice(typeIndex, 1);
                            delete _this._listeners[eventType];
                        }
                    })();
                }
            }
        }

        /**
         * Applies arguments to specified event type
         * @param {string} eventType
         * @param {*[]} eventArguments
         * @protected
         */

    }, {
        key: '_applyEvents',
        value: function _applyEvents(eventType, eventArguments) {
            var typeListeners = this._listeners[eventType];

            if (!typeListeners || !typeListeners.length) {
                if (this._strictMode) {
                    throw 'No listeners specified for event: ' + eventType;
                } else {
                    return;
                }
            }

            var removableListeners = [];
            typeListeners.forEach(function (eeListener, idx) {
                eeListener.fn.apply(null, eventArguments);
                if (eeListener.once) {
                    removableListeners.unshift(idx);
                }
            });

            removableListeners.forEach(function (idx) {
                typeListeners.splice(idx, 1);
            });
        }

        /**
         * Emits event with specified type and params.
         * @param {string} type
         * @param eventArgs
         */

    }, {
        key: 'emit',
        value: function emit(type) {
            var _this2 = this;

            for (var _len = arguments.length, eventArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                eventArgs[_key - 1] = arguments[_key];
            }

            if (this._emitDelay) {
                setTimeout(function () {
                    _this2._applyEvents.call(_this2, type, eventArgs);
                }, this._emitDelay);
            } else {
                this._applyEvents(type, eventArgs);
            }
        }

        /**
         * Emits event with specified type and params synchronously.
         * @param {string} type
         * @param eventArgs
         */

    }, {
        key: 'emitSync',
        value: function emitSync(type) {
            for (var _len2 = arguments.length, eventArgs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                eventArgs[_key2 - 1] = arguments[_key2];
            }

            this._applyEvents(type, eventArgs);
        }

        /**
         * Destroys EventEmitter
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this._listeners = {};
            this.events = [];
        }
    }]);

    return EventEmitter;
}();

module.exports = EventEmitter;

},{}],144:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _handlebarsBase = require('./handlebars/base');

var base = _interopRequireWildcard(_handlebarsBase);

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)

var _handlebarsSafeString = require('./handlebars/safe-string');

var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

var _handlebarsException = require('./handlebars/exception');

var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

var _handlebarsUtils = require('./handlebars/utils');

var Utils = _interopRequireWildcard(_handlebarsUtils);

var _handlebarsRuntime = require('./handlebars/runtime');

var runtime = _interopRequireWildcard(_handlebarsRuntime);

var _handlebarsNoConflict = require('./handlebars/no-conflict');

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function create() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = _handlebarsSafeString2['default'];
  hb.Exception = _handlebarsException2['default'];
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function (spec) {
    return runtime.template(spec, hb);
  };

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];


},{"./handlebars/base":145,"./handlebars/exception":148,"./handlebars/no-conflict":158,"./handlebars/runtime":159,"./handlebars/safe-string":160,"./handlebars/utils":161}],145:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.HandlebarsEnvironment = HandlebarsEnvironment;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = require('./utils');

var _exception = require('./exception');

var _exception2 = _interopRequireDefault(_exception);

var _helpers = require('./helpers');

var _decorators = require('./decorators');

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

var VERSION = '4.0.5';
exports.VERSION = VERSION;
var COMPILER_REVISION = 7;

exports.COMPILER_REVISION = COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0'
};

exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};

  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}

HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: _logger2['default'],
  log: _logger2['default'].log,

  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },

  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },

  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  }
};

var log = _logger2['default'].log;

exports.log = log;
exports.createFrame = _utils.createFrame;
exports.logger = _logger2['default'];


},{"./decorators":146,"./exception":148,"./helpers":149,"./logger":157,"./utils":161}],146:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _decoratorsInline = require('./decorators/inline');

var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}


},{"./decorators/inline":147}],147:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _utils = require('../utils');

exports['default'] = function (instance) {
  instance.registerDecorator('inline', function (fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function (context, options) {
        // Create a new partials stack frame prior to exec.
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret = fn(context, options);
        container.partials = original;
        return ret;
      };
    }

    props.partials[options.args[0]] = options.fn;

    return ret;
  });
};

module.exports = exports['default'];


},{"../utils":161}],148:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var loc = node && node.loc,
      line = undefined,
      column = undefined;
  if (loc) {
    line = loc.start.line;
    column = loc.start.column;

    message += ' - ' + line + ':' + column;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  /* istanbul ignore else */
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, Exception);
  }

  if (loc) {
    this.lineNumber = line;
    this.column = column;
  }
}

Exception.prototype = new Error();

exports['default'] = Exception;
module.exports = exports['default'];


},{}],149:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.registerDefaultHelpers = registerDefaultHelpers;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _helpersBlockHelperMissing = require('./helpers/block-helper-missing');

var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

var _helpersEach = require('./helpers/each');

var _helpersEach2 = _interopRequireDefault(_helpersEach);

var _helpersHelperMissing = require('./helpers/helper-missing');

var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

var _helpersIf = require('./helpers/if');

var _helpersIf2 = _interopRequireDefault(_helpersIf);

var _helpersLog = require('./helpers/log');

var _helpersLog2 = _interopRequireDefault(_helpersLog);

var _helpersLookup = require('./helpers/lookup');

var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

var _helpersWith = require('./helpers/with');

var _helpersWith2 = _interopRequireDefault(_helpersWith);

function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}


},{"./helpers/block-helper-missing":150,"./helpers/each":151,"./helpers/helper-missing":152,"./helpers/if":153,"./helpers/log":154,"./helpers/lookup":155,"./helpers/with":156}],150:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _utils = require('../utils');

exports['default'] = function (instance) {
  instance.registerHelper('blockHelperMissing', function (context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if (context === true) {
      return fn(this);
    } else if (context === false || context == null) {
      return inverse(this);
    } else if (_utils.isArray(context)) {
      if (context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
        options = { data: data };
      }

      return fn(context, options);
    }
  });
};

module.exports = exports['default'];


},{"../utils":161}],151:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = require('../utils');

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('each', function (context, options) {
    if (!options) {
      throw new _exception2['default']('Must pass iterator to #each');
    }

    var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;

    if (options.data && options.ids) {
      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    if (options.data) {
      data = _utils.createFrame(options.data);
    }

    function execIteration(field, index, last) {
      if (data) {
        data.key = field;
        data.index = index;
        data.first = index === 0;
        data.last = !!last;

        if (contextPath) {
          data.contextPath = contextPath + field;
        }
      }

      ret = ret + fn(context[field], {
        data: data,
        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
      });
    }

    if (context && typeof context === 'object') {
      if (_utils.isArray(context)) {
        for (var j = context.length; i < j; i++) {
          if (i in context) {
            execIteration(i, i, i === context.length - 1);
          }
        }
      } else {
        var priorKey = undefined;

        for (var key in context) {
          if (context.hasOwnProperty(key)) {
            // We're running the iterations one step out of sync so we can detect
            // the last iteration without have to scan the object twice and create
            // an itermediate keys array.
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1);
            }
            priorKey = key;
            i++;
          }
        }
        if (priorKey !== undefined) {
          execIteration(priorKey, i - 1, true);
        }
      }
    }

    if (i === 0) {
      ret = inverse(this);
    }

    return ret;
  });
};

module.exports = exports['default'];


},{"../exception":148,"../utils":161}],152:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('helperMissing', function () /* [args, ]options */{
    if (arguments.length === 1) {
      // A missing field in a {{foo}} construct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    }
  });
};

module.exports = exports['default'];


},{"../exception":148}],153:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _utils = require('../utils');

exports['default'] = function (instance) {
  instance.registerHelper('if', function (conditional, options) {
    if (_utils.isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function (conditional, options) {
    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
  });
};

module.exports = exports['default'];


},{"../utils":161}],154:[function(require,module,exports){
'use strict';

exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('log', function () /* message, options */{
    var args = [undefined],
        options = arguments[arguments.length - 1];
    for (var i = 0; i < arguments.length - 1; i++) {
      args.push(arguments[i]);
    }

    var level = 1;
    if (options.hash.level != null) {
      level = options.hash.level;
    } else if (options.data && options.data.level != null) {
      level = options.data.level;
    }
    args[0] = level;

    instance.log.apply(instance, args);
  });
};

module.exports = exports['default'];


},{}],155:[function(require,module,exports){
'use strict';

exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('lookup', function (obj, field) {
    return obj && obj[field];
  });
};

module.exports = exports['default'];


},{}],156:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _utils = require('../utils');

exports['default'] = function (instance) {
  instance.registerHelper('with', function (context, options) {
    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    var fn = options.fn;

    if (!_utils.isEmpty(context)) {
      var data = options.data;
      if (options.data && options.ids) {
        data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
      }

      return fn(context, {
        data: data,
        blockParams: _utils.blockParams([context], [data && data.contextPath])
      });
    } else {
      return options.inverse(this);
    }
  });
};

module.exports = exports['default'];


},{"../utils":161}],157:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _utils = require('./utils');

var logger = {
  methodMap: ['debug', 'info', 'warn', 'error'],
  level: 'info',

  // Maps a given level value to the `methodMap` indexes above.
  lookupLevel: function lookupLevel(level) {
    if (typeof level === 'string') {
      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
      if (levelMap >= 0) {
        level = levelMap;
      } else {
        level = parseInt(level, 10);
      }
    }

    return level;
  },

  // Can be overridden in the host environment
  log: function log(level) {
    level = logger.lookupLevel(level);

    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
      var method = logger.methodMap[level];
      if (!console[method]) {
        // eslint-disable-line no-console
        method = 'log';
      }

      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      console[method].apply(console, message); // eslint-disable-line no-console
    }
  }
};

exports['default'] = logger;
module.exports = exports['default'];


},{"./utils":161}],158:[function(require,module,exports){
(function (global){(function (){
/* global window */
'use strict';

exports.__esModule = true;

exports['default'] = function (Handlebars) {
  /* istanbul ignore next */
  var root = typeof global !== 'undefined' ? global : window,
      $Handlebars = root.Handlebars;
  /* istanbul ignore next */
  Handlebars.noConflict = function () {
    if (root.Handlebars === Handlebars) {
      root.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};

module.exports = exports['default'];


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],159:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.checkRevision = checkRevision;
exports.template = template;
exports.wrapProgram = wrapProgram;
exports.resolvePartial = resolvePartial;
exports.invokePartial = invokePartial;
exports.noop = noop;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _utils = require('./utils');

var Utils = _interopRequireWildcard(_utils);

var _exception = require('./exception');

var _exception2 = _interopRequireDefault(_exception);

var _base = require('./base');

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = _base.COMPILER_REVISION;

  if (compilerRevision !== currentRevision) {
    if (compilerRevision < currentRevision) {
      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
    } else {
      // Use the embedded version info since the runtime doesn't know about this revision yet
      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
    }
  }
}

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }

  templateSpec.main.decorator = templateSpec.main_d;

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as psuedo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }

    partial = env.VM.resolvePartial.call(this, partial, context, options);
    var result = env.VM.invokePartial.call(this, partial, context, options);

    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, options);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  }

  // Just add water
  var container = {
    strict: function strict(obj, name) {
      if (!(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
      }
      return obj[name];
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        if (depths[i] && depths[i][name] != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },

    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },

    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    merge: function merge(param, common) {
      var obj = param || common;

      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }

      return obj;
    },

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
        blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context !== options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }

    function main(context /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }
    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }
  ret.isTop = true;

  ret._setup = function (options) {
    if (!options.partial) {
      container.helpers = container.merge(options.helpers, env.helpers);

      if (templateSpec.usePartial) {
        container.partials = container.merge(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = container.merge(options.decorators, env.decorators);
      }
    } else {
      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
    }
  };

  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }

    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}

function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var currentDepths = depths;
    if (depths && context !== depths[0]) {
      currentDepths = [context].concat(depths);
    }

    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }

  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      partial = options.data['partial-block'];
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}

function invokePartial(partial, context, options) {
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }

  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    options.data = _base.createFrame(options.data);
    partialBlock = options.data['partial-block'] = options.fn;

    if (partialBlock.partials) {
      options.partials = Utils.extend({}, options.partials, partialBlock.partials);
    }
  }

  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }

  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}

function noop() {
  return '';
}

function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}

function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}


},{"./base":145,"./exception":148,"./utils":161}],160:[function(require,module,exports){
// Build out our basic SafeString type
'use strict';

exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];


},{}],161:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.extend = extend;
exports.indexOf = indexOf;
exports.escapeExpression = escapeExpression;
exports.isEmpty = isEmpty;
exports.createFrame = createFrame;
exports.blockParams = blockParams;
exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

var badChars = /[&<>"'`=]/g,
    possible = /[&<>"'`=]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

var toString = Object.prototype.toString;

exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
exports.isFunction = isFunction;

/* eslint-enable func-style */

/* istanbul ignore next */
var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};

exports.isArray = isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}

function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = '' + string;
  }

  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}

function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}

function blockParams(params, ids) {
  params.path = ids;
  return params;
}

function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}


},{}],162:[function(require,module,exports){
// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.
module.exports = require('./dist/cjs/handlebars.runtime')['default'];

},{"./dist/cjs/handlebars.runtime":144}],163:[function(require,module,exports){
module.exports = require("handlebars/runtime")["default"];

},{"handlebars/runtime":162}],164:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

},{"./runtime":165}],165:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);

},{}],166:[function(require,module,exports){
(function (global){(function (){
/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

(function(self) {
    'use strict';

    var nativeURLSearchParams = self.URLSearchParams ? self.URLSearchParams : null,
        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
        __URLSearchParams__ = "__URLSearchParams__",
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly) {
        return;
    }


    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }

        this [__URLSearchParams__] = parseToDict(search);
    }


    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function(name, value) {
        appendTo(this [__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype.delete = function(name) {
        delete this [__URLSearchParams__] [name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict [name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function(name) {
        return name in this [__URLSearchParams__];
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this [__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };

    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy)
    /*
     * Apply polifill to global object and append other prototype into it
     */
    self.URLSearchParams = useProxy ?
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        new Proxy(nativeURLSearchParams, {
            construct: function(target, args) {
                return new target((new URLSearchParamsPolyfill(args[0]).toString()));
            }
        }) :
        URLSearchParamsPolyfill;


    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this.delete(keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i], values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name]);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push([item]);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };


    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }


    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }

    function decode(str) {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    }

    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {done: value === undefined, value: value};
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function() {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            for (var i in search) {
                if (search.hasOwnProperty(i)) {
                    var str = typeof search [i] === 'string' ? search [i] : JSON.stringify(search [i]);
                    appendTo(dict, i, str);
                }
            }

        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs [j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        if (name in dict) {
            dict[name].push('' + value);
        } else {
            dict[name] = ['' + value];
        }
    }

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],167:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _SELECTORS;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _parsleyjs = require('parsleyjs');

var _parsleyjs2 = _interopRequireDefault(_parsleyjs);

var _FormValidationView = require('./views/FormValidationView');

var _FormValidationView2 = _interopRequireDefault(_FormValidationView);

var _BaseController = require('./core/BaseController');

var _ToggleView = require('./views/ToggleView');

var _ToggleView2 = _interopRequireDefault(_ToggleView);

var _ModalView = require('./views/ModalView');

var _ModalView2 = _interopRequireDefault(_ModalView);

var _NavigationView = require('./views/NavigationView');

var _NavigationView2 = _interopRequireDefault(_NavigationView);

var _FormStepperView = require('./views/FormStepperView');

var _FormStepperView2 = _interopRequireDefault(_FormStepperView);

var _CarouselView = require('./views/CarouselView');

var _CarouselView2 = _interopRequireDefault(_CarouselView);

var _CustomCheckBoxView = require('./views/CustomCheckBoxView');

var _CustomCheckBoxView2 = _interopRequireDefault(_CustomCheckBoxView);

var _ProductDetailView = require('./views/ProductDetailView');

var _ProductDetailView2 = _interopRequireDefault(_ProductDetailView);

var _ProductSeriesView = require('./views/ProductSeriesView');

var _ProductSeriesView2 = _interopRequireDefault(_ProductSeriesView);

var _OrderHistoryView = require('./views/OrderHistoryView');

var _OrderHistoryView2 = _interopRequireDefault(_OrderHistoryView);

var _CheckoutInfoView = require('./views/CheckoutInfoView');

var _CheckoutInfoView2 = _interopRequireDefault(_CheckoutInfoView);

var _CartController = require('./controllers/CartController');

var _CartController2 = _interopRequireDefault(_CartController);

var _CheckboxDependenciesView = require('./views/CheckboxDependenciesView');

var _CheckboxDependenciesView2 = _interopRequireDefault(_CheckboxDependenciesView);

var _ChooseAddressView = require('./views/ChooseAddressView');

var _ChooseAddressView2 = _interopRequireDefault(_ChooseAddressView);

var _eventEmitter = require('./global/eventEmitter');

var _ParsleyHelper = require('./util/ParsleyHelper');

var _ParsleyHelper2 = _interopRequireDefault(_ParsleyHelper);

var _ProductCarouselView = require('./views/ProductCarouselView');

var _ProductCarouselView2 = _interopRequireDefault(_ProductCarouselView);

var _ReorderView = require('./views/ReorderView');

var _ReorderView2 = _interopRequireDefault(_ReorderView);

var _Sortable = require('./util/Sortable');

var _Sortable2 = _interopRequireDefault(_Sortable);

var _CheckoutTracking = require('./views/CheckoutTracking');

var _CheckoutTracking2 = _interopRequireDefault(_CheckoutTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('picturefill');

window.$ = _jquery2.default;


/**
 * Application setup
 *
 * @class App
 */

var SELECTORS = (_SELECTORS = {
    BODY: 'body',
    FORM_VALIDATION: '.js-form-validation',
    FORM_STEPPER: '.js-stepper',
    TOGGLE: '.js-toggleView',
    NAVIGATION_VIEW: '.js-navigationView',
    TEST_MODAL: '.js-testModal',
    CART_CONTROLLER: '.js-cartController',
    PRODUCT_CAROUSEL: '[data-carousel]',

    CUSTOM_CHECKBOX: '.js-customCheckbox',
    PRODUCTDETAIL_VIEW: '.js-productDetailView',
    PRODUCTSERIES_VIEW: '.js-productSeries',
    CHECKBOX_DEPENDENCIES_VIEW: '.js-checkBoxDependencies',
    CHOOSE_ADDRESS_VIEW: '.js-chooseAddressView'
}, (0, _defineProperty3.default)(_SELECTORS, 'CUSTOM_CHECKBOX', '.js-customCheckbox'), (0, _defineProperty3.default)(_SELECTORS, 'PRODUCTCAROUSEL_VIEW', '.js-productCarousel'), (0, _defineProperty3.default)(_SELECTORS, 'ORDER_HISTORY_VIEW', '.js-order-history'), (0, _defineProperty3.default)(_SELECTORS, 'REORDER_VIEW', '.js-reorderView'), (0, _defineProperty3.default)(_SELECTORS, 'CHECKOUT_INFO_VIEW', '.js-checkout-info'), (0, _defineProperty3.default)(_SELECTORS, 'CHECKOUT_STEPS_VIEW', '.js-checkoutSteps'), _SELECTORS);

var instanceMap = new _map2.default();

var App = function () {
    function App() {
        (0, _classCallCheck3.default)(this, App);

        this.init();
    }

    (0, _createClass3.default)(App, [{
        key: 'init',
        value: function init() {
            this.createChildren().enable();

            return this;
        }

        /**
         * All constructor functions
         * are gathered under createChildren.
         *
         * @method createChildren
         * @public
         * @chainable
         * @returns {Object}
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {
            // global
            this.eventEmitter = _eventEmitter.eventEmitter;
            _ParsleyHelper2.default.addValidators();

            // Controllers
            this.getInstance(_CartController2.default, (0, _jquery2.default)(SELECTORS.CART_CONTROLLER));

            // Views
            this.getInstance(_FormStepperView2.default, (0, _jquery2.default)(SELECTORS.FORM_STEPPER));
            this.getInstance(_ToggleView2.default, (0, _jquery2.default)(SELECTORS.TOGGLE));
            this.getInstance(_ModalView2.default, (0, _jquery2.default)(SELECTORS.TEST_MODAL));
            this.getInstance(_NavigationView2.default, (0, _jquery2.default)(SELECTORS.NAVIGATION_VIEW));
            this.getInstance(_CheckoutTracking2.default, (0, _jquery2.default)(SELECTORS.CHECKOUT_STEPS_VIEW));
            this.getInstance(_CustomCheckBoxView2.default, (0, _jquery2.default)(SELECTORS.CUSTOM_CHECKBOX));
            this.getInstance(_ProductDetailView2.default, (0, _jquery2.default)(SELECTORS.PRODUCTDETAIL_VIEW));
            this.getInstance(_ProductSeriesView2.default, (0, _jquery2.default)(SELECTORS.PRODUCTSERIES_VIEW));
            this.getInstance(_FormValidationView2.default, (0, _jquery2.default)(SELECTORS.FORM_VALIDATION));
            this.getInstance(_CheckboxDependenciesView2.default, (0, _jquery2.default)(SELECTORS.CHECKBOX_DEPENDENCIES_VIEW));
            this.getInstance(_ChooseAddressView2.default, (0, _jquery2.default)(SELECTORS.CHOOSE_ADDRESS_VIEW));
            this.getInstance(_OrderHistoryView2.default, (0, _jquery2.default)(SELECTORS.ORDER_HISTORY_VIEW));
            this.getInstance(_ProductCarouselView2.default, (0, _jquery2.default)(SELECTORS.PRODUCTCAROUSEL_VIEW));
            this.getInstance(_CheckoutInfoView2.default, (0, _jquery2.default)(SELECTORS.CHECKOUT_INFO_VIEW));
            this.getInstance(_ReorderView2.default, (0, _jquery2.default)(SELECTORS.REORDER_VIEW));
            new _Sortable2.default();

            return this;
        }
    }, {
        key: 'getInstance',
        value: function getInstance(ClassRef, container) {
            if (!instanceMap[ClassRef]) {
                // fixes previous line            
                container.each(function (i, val) {
                    instanceMap.set(ClassRef, new ClassRef((0, _jquery2.default)(val))); // fixes previous line
                });

                return this[ClassRef];
            }
            return this[ClassRef];
        }
    }, {
        key: 'enable',
        value: function enable() {
            var _this = this;

            this.eventEmitter.on('modal-open', function () {
                _this.modalOpen();
            });
        }

        /**
        * Method modalOpen reattaches form validation to new forms created inside a modal
        *
        * @method modalOpen
        * @chainable
        * @public
        */

    }, {
        key: 'modalOpen',
        value: function modalOpen() {
            var $newForm = (0, _jquery2.default)('.js-modal .js-form-validation');
            new _FormValidationView2.default($newForm);
        }
    }]);
    return App;
}();

exports.default = App;

},{"./controllers/CartController":172,"./core/BaseController":173,"./global/eventEmitter":175,"./util/ParsleyHelper":187,"./util/Sortable":188,"./views/CarouselView":190,"./views/CheckboxDependenciesView":192,"./views/CheckoutInfoView":193,"./views/CheckoutTracking":194,"./views/ChooseAddressView":195,"./views/CustomCheckBoxView":196,"./views/FormStepperView":197,"./views/FormValidationView":198,"./views/ModalView":199,"./views/NavigationView":200,"./views/OrderHistoryView":201,"./views/ProductCarouselView":202,"./views/ProductDetailView":203,"./views/ProductSeriesView":204,"./views/ReorderView":205,"./views/ToggleView":206,"babel-runtime/core-js/map":3,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"babel-runtime/helpers/defineProperty":17,"jquery":"jquery","parsleyjs":"parsleyjs","picturefill":"picturefill"}],168:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* Establishing the strings associated with our breakpoints.
   IMPORTANT NOTE: These are established in our styles! Any
   changes there must be reflected here */

var BREAKPOINTS = exports.BREAKPOINTS = {
    SCREEN: 'BP_SCREEN',
    SMALL: 'BP_SMALL',
    MEDIUM: 'BP_MEDIUM',
    LARGE: 'BP_LARGE',
    XLARGE: 'BP_XLARGE'
};

},{}],169:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * # Storage
 */

// Generic Active class
var IS_ACTIVE_CLASS = exports.IS_ACTIVE_CLASS = 'isActive';
var IS_FOCUS_ACTIVE_CLASS = exports.IS_FOCUS_ACTIVE_CLASS = 'isFocusActive';
var IS_HIDDEN = exports.IS_HIDDEN = 'isHidden';
var INFO_MESSAGE_CLASS = exports.INFO_MESSAGE_CLASS = 'siteMessage_info';
var ALERT_MESSAGE_CLASS = exports.ALERT_MESSAGE_CLASS = 'siteMessage_alert';
var ERROR_MESSAGE_CLASS = exports.ERROR_MESSAGE_CLASS = 'siteMessage_error';
var SUCCESS_MESSAGE_CLASS = exports.SUCCESS_MESSAGE_CLASS = 'siteMessage_success';
var LOADING_CLASS = exports.LOADING_CLASS = 'loading';

var CHECKED = exports.CHECKED = 'checked';
var CHECK_CART = exports.CHECK_CART = 'js-check-cart';
var DISABLED_CHECKBOX = exports.DISABLED_CHECKBOX = 'disabled-checkbox';
var INPUTERROR = exports.INPUTERROR = 'qty-inp-err';
var TEXTCOLLAPSED = exports.TEXTCOLLAPSED = 'textCollapsed';

},{}],170:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Events
 */

// Fired when someone clicks on a state
var EV_BREAKPOINT_CHANGE = exports.EV_BREAKPOINT_CHANGE = 'breakpoint.change';

},{}],171:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createContext = createContext;

var _eventEmitterEs = require('event-emitter-es6');

var _eventEmitterEs2 = _interopRequireDefault(_eventEmitterEs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = {
    getInstance: function getInstance(Name) {
        if (!this[Name]) {
            this[Name] = new Name(container);
            return this[Name];
        }
        return this[Name];
    },

    get eventEmitter() {
        return this.getInstance(_eventEmitterEs2.default);
    }
};

function createContext() {
    return container;
}

},{"event-emitter-es6":143}],172:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _BaseController2 = require('../core/BaseController');

var _CartView = require('../views/CartView');

var _CartView2 = _interopRequireDefault(_CartView);

var _CartService = require('../services/CartService');

var _CartService2 = _interopRequireDefault(_CartService);

var _CartModel = require('../models/CartModel');

var _CartModel2 = _interopRequireDefault(_CartModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {};

/**
 * Cart Controller
 *
 * @class CartController
 * @constructor
 */

var CartController = function (_BaseController) {
    (0, _inherits3.default)(CartController, _BaseController);

    function CartController($element) {
        (0, _classCallCheck3.default)(this, CartController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartController.__proto__ || (0, _getPrototypeOf2.default)(CartController)).call(this));

        _this.init($element);
        return _this;
    }

    /**
     * Initializes methods
     *
     * @method init
     * @public
     * @chainable
     */


    (0, _createClass3.default)(CartController, [{
        key: 'init',
        value: function init($element) {
            /**
             * A reference to the containing DOM $element
             *
             * @property $element
             * @type {type}
             * @public
             */
            this.$element = $element;

            return this.setupHandlers().createChildren().layout().enable();
        }

        /**
         * SetupHandlers
         *
         * @method setupHandlers
         * @public
         * @chainable
         */

    }, {
        key: 'setupHandlers',
        value: function setupHandlers() {

            return this;
        }

        /**
         * createChildren
         *
         * @method createChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.cartModel = new _CartModel2.default();
            this.cartService = new _CartService2.default();
            this.view = new _CartView2.default(this.$element, this);
            return this;
        }

        /**
         * Layout
         *
         * @method layout
         * @public
         * @chainable
         */

    }, {
        key: 'layout',
        value: function layout() {

            return this;
        }

        /**
         * Enable
         *
         * @method enable
         * @public
         * @chainable
         */

    }, {
        key: 'enable',
        value: function enable() {

            return this;
        }

        /**
         * Disable
         *
         * @method disable
         * @public
         * @chainable
         */

    }, {
        key: 'disable',
        value: function disable() {

            return this;
        }
    }]);
    return CartController;
}(_BaseController2.BaseController);

exports.default = CartController;

},{"../core/BaseController":173,"../models/CartModel":178,"../services/CartService":181,"../views/CartView":191,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"babel-runtime/helpers/inherits":18,"babel-runtime/helpers/possibleConstructorReturn":19,"jquery":"jquery"}],173:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseController = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _context = require('../context');

var _eventEmitter = require('../global/eventEmitter');

var _dom = require('../util/dom');

var _events = require('../constants/events');

var _breakpoints = require('../constants/breakpoints');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base Controller
 *
 * @class BaseController
 */
var BaseController = exports.BaseController = function () {
    function BaseController() {
        (0, _classCallCheck3.default)(this, BaseController);

        this.eventEmitter = _eventEmitter.eventEmitter;
        /**
         * A reference to the window
         *
         * @property $window
         * @type {jQuery}
         * @public
         */
        this.$window = null;

        /**
         * currentSize
         *
         * @property currentSize
         * @type {string}
         * @public
         */
        this.currentSize = null;

        /**
         * previousSize
         *
         * @property previousSize
         * @type {string}
         * @public
         */
        this.previousSize = null;

        /**
         * Duration of debounce to use for firing resize events in the app
         *
         * @property resizeDebounceDuration
         * @type {int}
         */
        this.resizeDebounceDuration = 250;

        /**
         * A reference to the body
         *
         * @property $body
         * @type {jQuery}
         * @public
         */
        this.$body = null;

        /**
         * Is the base enabled
         *
         * @property isBaseEnabled
         * @type {Boolean}
         * @default false
         * @public
         */
        this.isBaseEnabled = false;

        this.baseInit();
    }

    /**
     * Initializes the UI Component View
     * Runs setupHandlers, createChildren, and enable
     *
     * @method baseInit
     * @public
     * @chainable
     */


    (0, _createClass3.default)(BaseController, [{
        key: 'baseInit',
        value: function baseInit() {
            this.$window = (0, _jquery2.default)(window);
            this.$body = (0, _jquery2.default)('body');

            this.baseEnable().getCurrentSize();

            return this;
        }

        /**
         * Enables the base controller
         *
         * @method baseEnable
         * @returns {BaseController}
         */

    }, {
        key: 'baseEnable',
        value: function baseEnable() {
            if (this.isBaseEnabled) {
                return this;
            }

            this.$window.on('resize orientationchange', (0, _dom.debounce)(this.onResize.bind(this), this.resizeDebounceDuration));

            this.isBaseEnabled = false;

            return this;
        }

        /**
         * Disables the base controller
         *
         * @method baseDisable
         * @returns {BaseController}
         */

    }, {
        key: 'baseDisable',
        value: function baseDisable() {
            if (!this.isBaseEnabled) {
                return this;
            }

            this.$window.off('resize orientationchange', (0, _dom.debounce)(this.onResize.bind(this), this.resizeDebounceDuration));

            this.isBaseEnabled = false;

            return this;
        }

        /**
         * Get Current Size
         *
         * @method getCurrentSize
         * @public
         * @chainable
         */

    }, {
        key: 'getCurrentSize',
        value: function getCurrentSize() {
            return this.currentSize = window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/"/g, '');
        }

        /**
         * Checking current size for
         * breakpoint change
         *
         * @method checkSize
         * @public
         * @chainable
         */

    }, {
        key: 'checkSize',
        value: function checkSize(currentSize) {
            this.getCurrentSize();
            if (this.currentSize !== currentSize) {
                this.previousSize = currentSize;
                this.currentSize = this.currentSize;

                var bp = { previousSize: this.previousSize, currentSize: this.currentSize };
                this.onBreakpointChange(bp);
            }

            return this;
        }

        /**
         * Destroy the controller
         *
         * @method destroy
         * @returns {BaseController}
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            var key = void 0;

            this.baseDisable().onDestroy();

            for (key in this) {
                if (this.hasOwnProperty(key)) {
                    this[key] = null;
                }
            }
        }

        /**
         * Returns boolean value of whether
         * breakpoint is mobile or not.
         *
         * @method isMobile
         * @public
         * @chainable
         */

    }, {
        key: 'isMobile',
        value: function isMobile() {
            /* Perform necessary actions depending on which breakpoint we're on*/
            if (this.currentSize === _breakpoints.BREAKPOINTS.SCREEN || this.currentSize === _breakpoints.BREAKPOINTS.SMALL) {
                return true;
            } else {
                return false;
            }
        }

        /**
         * Returns boolean value of whether
         * breakpoint is desktop or not.
         *
         * @method isDesktop
         * @public
         * @chainable
         */

    }, {
        key: 'isDesktop',
        value: function isDesktop() {
            /* Perform necessary actions depending on which breakpoint we're on*/
            if (this.currentSize === _breakpoints.BREAKPOINTS.LARGE || this.currentSize === _breakpoints.BREAKPOINTS.XLARGE) {
                return true;
            } else {
                return false;
            }
        }

        /**
         * onResize
         *
         * @method onResize
         * @public
         * @chainable
         */

    }, {
        key: 'onResize',
        value: function onResize() {
            this.checkSize(this.currentSize);
            this.onWindowResize();

            return this;
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            // noop
        }
    }, {
        key: 'onUpdated',
        value: function onUpdated() {
            // noop
        }
    }, {
        key: 'onWindowResize',
        value: function onWindowResize() {
            // noop
        }
    }, {
        key: 'onBreakpointChange',
        value: function onBreakpointChange() {
            // noop
        }
    }]);
    return BaseController;
}();

},{"../constants/breakpoints":168,"../constants/events":170,"../context":171,"../global/eventEmitter":175,"../util/dom":189,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],174:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _classes = require('../constants/classes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {
    SITE_MESSAGE_CONTAINER: '.js-siteMessage',
    SITE_MESSAGE: '.js-siteMessage-inner-message'
};

/**
 * Global Notifications class
 *
 * @class Notifications
 * @constructor
 */

var Notifications = function () {
    function Notifications() {
        (0, _classCallCheck3.default)(this, Notifications);

        this.createChildren();
    }

    (0, _createClass3.default)(Notifications, [{
        key: 'createChildren',
        value: function createChildren() {
            this.$siteMessage = (0, _jquery2.default)(SELECTORS.SITE_MESSAGE);
            this.$siteMessageContainer = (0, _jquery2.default)(SELECTORS.SITE_MESSAGE_CONTAINER);
            return this;
        }

        /**
         * Displays message at top of page
         * for server errors when a fetch
         * fails
         *
         * @method showErrorNotification
         * @public
         * @chainable
         */

    }, {
        key: 'showErrorNotification',
        value: function showErrorNotification(messageOrTemplate, messageTypeClass) {
            this.resetMessages();
            this.$siteMessageContainer.addClass(messageTypeClass).addClass(_classes.IS_ACTIVE_CLASS);
            this.$siteMessage.html(messageOrTemplate);
            this.$siteMessageContainer.focus();
        }

        /**
         * Resets notifications container
         * before it's used for a specific message
         * purpose
         *
         * @method resetMessages
         * @public
         * @chainable
         */

    }, {
        key: 'resetMessages',
        value: function resetMessages() {
            this.$siteMessageContainer.removeClass(_classes.IS_ACTIVE_CLASS).removeClass(_classes.ALERT_MESSAGE_CLASS).removeClass(_classes.ERROR_MESSAGE_CLASS);
            this.$siteMessage.text('');
        }
    }]);
    return Notifications;
}();

exports.default = Notifications;

},{"../constants/classes":169,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],175:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventEmitter = undefined;

var _eventEmitterEs = require('event-emitter-es6');

var _eventEmitterEs2 = _interopRequireDefault(_eventEmitterEs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventEmitter = exports.eventEmitter = new _eventEmitterEs2.default();

},{"event-emitter-es6":143}],176:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.localData = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocalData = function () {
    function LocalData() {
        (0, _classCallCheck3.default)(this, LocalData);
    }

    (0, _createClass3.default)(LocalData, [{
        key: 'setItem',
        value: function setItem(name, data) {
            var storageData = (0, _stringify2.default)({
                timestamp: Date.now(),
                data: data
            });

            localStorage.setItem(name, storageData);
        }
    }, {
        key: 'getItem',
        value: function getItem(name) {
            var storageData = JSON.parse(localStorage.getItem(name));

            if (!storageData) {
                return false;
            }

            return storageData.data;
        }
    }, {
        key: 'removeItem',
        value: function removeItem(name) {
            localStorage.removeItem(name);
        }
    }]);
    return LocalData;
}();

var localData = exports.localData = new LocalData();

},{"babel-runtime/core-js/json/stringify":2,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],177:[function(require,module,exports){
'use strict';

require('babel-polyfill');

var _App = require('App');

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _App2.default();

},{"App":167,"babel-polyfill":"babel-polyfill"}],178:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTORS = {
    ITEM_QTY_INPUT: '.js-cartController-qty'
};

var CartModel = function () {
    function CartModel() {
        (0, _classCallCheck3.default)(this, CartModel);

        this.cartArray = [];
        this.removedItemArray = [];
        this.changeTrackingArray = [];

        this.setupHandlers();
    }

    (0, _createClass3.default)(CartModel, [{
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.createCartArray = this._createCartArray.bind(this);
            this.locateAndRemoveUndoItem = this._locateAndRemoveUndoItem.bind(this);
            this.addToRemovedItemArray = this._addToRemovedItemArray.bind(this);
            this.updateTrackingArray = this._updateTrackingArray.bind(this);
        }
    }, {
        key: '_createCartArray',
        value: function _createCartArray($productRows) {
            var _this = this;

            $productRows.each(function (i, val) {
                var item = {};
                item.id = (0, _jquery2.default)(val).find(SELECTORS.ITEM_QTY_INPUT)[0].dataset.productId;
                item.qty = parseInt((0, _jquery2.default)(val).find(SELECTORS.ITEM_QTY_INPUT)[0].value);
                item.entryGroupNumber = (0, _jquery2.default)(val).find(SELECTORS.ITEM_QTY_INPUT)[0].dataset.entryGroupNumber;
                item.inStock = parseInt((0, _jquery2.default)(val).find(SELECTORS.ITEM_QTY_INPUT)[0].dataset.qtyInStock);
                item.isOutOfStock = (0, _jquery2.default)(val).find(SELECTORS.ITEM_QTY_INPUT)[0].dataset.isOutOfStock.toLowerCase() === 'true';
                _this.cartArray.push(item);
            });

            /* Clone of array for tracking differences */
            this.changeTrackingArray = JSON.parse((0, _stringify2.default)(this.cartArray));
        }
    }, {
        key: '_addToRemovedItemArray',
        value: function _addToRemovedItemArray(prevObject) {
            this.removedItemArray.push(prevObject);
        }
    }, {
        key: '_locateAndRemoveUndoItem',
        value: function _locateAndRemoveUndoItem(updateObject) {
            var indexToRemove = this.removedItemArray.findIndex(function (obj) {
                return obj.id === updateObject.productId;
            });

            if (indexToRemove > -1) {
                this.removedItemArray.splice(indexToRemove, 1);
            }

            for (var i = 0; i < this.changeTrackingArray.length; i++) {
                if (this.changeTrackingArray[i].id == updateObject.productId) {
                    this.changeTrackingArray[i].qty = updateObject.qty;
                    this.changeTrackingArray[i].entryGroupNumber = updateObject.entryGroupNumber;
                }
            }
        }
    }, {
        key: 'updateCartArray',
        value: function updateCartArray(params) {
            var id = params.productId.toString();
            for (var i = 0; i < this.cartArray.length; i++) {
                if (this.cartArray[i].id === id) {
                    this.cartArray[i].qty = parseInt(params.qty);
                    this.cartArray[i].entryGroupNumber = parseInt(params.entryGroupNumber);
                }
            }
            return this;
        }
    }, {
        key: '_updateTrackingArray',
        value: function _updateTrackingArray(id, qty) {
            id = id.toString();
            qty = parseInt(qty);

            for (var j = 0; j < this.changeTrackingArray.length; j++) {
                if (this.changeTrackingArray[j].id === id) {
                    this.changeTrackingArray[j].qty = qty;
                }
            }

            return this;
        }
    }]);
    return CartModel;
}();

exports.default = CartModel;

},{"babel-runtime/core-js/json/stringify":2,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],179:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BasePortalService = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseService2 = require('./BaseService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PORTAL_DEFAULTS = {
    ERROR_TEXT: 'There was an error with your request.',
    BASE_API_URL: window.location.origin
};

var BasePortalService = exports.BasePortalService = function (_BaseService) {
    (0, _inherits3.default)(BasePortalService, _BaseService);

    function BasePortalService() {
        (0, _classCallCheck3.default)(this, BasePortalService);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BasePortalService.__proto__ || (0, _getPrototypeOf2.default)(BasePortalService)).call(this));

        _this.options = (0, _assign2.default)({}, _this.options, PORTAL_DEFAULTS);

        return _this;
    }

    return BasePortalService;
}(_BaseService2.BaseService);

},{"./BaseService":180,"babel-runtime/core-js/object/assign":5,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/inherits":18,"babel-runtime/helpers/possibleConstructorReturn":19}],180:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseService = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _isInteger = require('babel-runtime/core-js/number/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

require('whatwg-fetch');

require('url-search-params-polyfill');

require('url-polyfill');

var _LocalData = require('../lib/LocalData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULTS = {
    ERROR_TEXT: 'There was an error with your request.',
    BASE_API_URL: window.location.origin

    /**
     * @class BaseService
     */
};
var BaseService = exports.BaseService = function () {
    function BaseService() {
        (0, _classCallCheck3.default)(this, BaseService);

        this.options = DEFAULTS;
    }
    /**
     * Takes query object and include array and builds URL
     *
     * @method readResponse
     * @private
     * @param {Object} response
     * @async
     * @return {Promise.<JSON>} response data
     */


    (0, _createClass3.default)(BaseService, [{
        key: 'readResponse',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt('return', response.json());

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function readResponse(_x) {
                return _ref.apply(this, arguments);
            }

            return readResponse;
        }()

        /**
         * Take the body response from a request
         *
         * @method readTextResponse
         * @private
         * @param {Object} response
         * @async
         * @return {Promise.<String>} response data
         */

    }, {
        key: 'readTextResponse',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(response) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', response.text());

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function readTextResponse(_x2) {
                return _ref2.apply(this, arguments);
            }

            return readTextResponse;
        }()

        /**
         * Handle http errors
         *
         * @method handleNetworkErrors
         * @chainable
         * @public
         */

    }, {
        key: 'handleNetworkErrors',
        value: function handleNetworkErrors(response) {
            if (!response.ok) {
                throw Error('Error with network: ' + response.statusText);
            }
            return response;
        }

        /**
         * @method buildUrlAndQuery
         * @private
         * @param {String} url pathname
         * @param {Object} query params
         * @return {String} fullUrl with query string
         */

    }, {
        key: 'buildUrlWithQuery',
        value: function buildUrlWithQuery(url, query) {
            if (!query) {
                return url;
            }

            var fullUrl = new URL(url, window.location.origin);
            var params = new URLSearchParams(fullUrl.search);

            (0, _keys2.default)(query).forEach(function (key) {
                var value = query[key];

                if (Array.isArray(value) && (0, _isInteger2.default)(value[0])) {
                    value.forEach(function (item) {
                        params.append(key, item);
                    });
                } else {
                    params.append(key, query[key]);
                }
            });

            return fullUrl + '?' + params.toString();
        }

        /**
         * @method get
         * @param {String} url pathname
         * @param {Object} query params
         * @return {Promise.<JSON>}
         */

    }, {
        key: 'get',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(url) {
                var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var response, body, errorBody;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return fetch(this.buildUrlWithQuery(this.options.BASE_API_URL + url, query), {
                                    mode: 'cors',
                                    method: method,
                                    credentials: 'same-origin'
                                });

                            case 2:
                                response = _context3.sent;

                                if (!(response.status === 400)) {
                                    _context3.next = 7;
                                    break;
                                }

                                _context3.next = 6;
                                return this.readResponse(response);

                            case 6:
                                return _context3.abrupt('return', _context3.sent);

                            case 7:
                                if (!(response.status >= 200 && response.status < 300)) {
                                    _context3.next = 17;
                                    break;
                                }

                                if (!(response.headers.get('content-type').indexOf('application/json') !== -1)) {
                                    _context3.next = 12;
                                    break;
                                }

                                _context3.next = 11;
                                return this.readResponse(response);

                            case 11:
                                return _context3.abrupt('return', _context3.sent);

                            case 12:
                                _context3.next = 14;
                                return this.readTextResponse(response);

                            case 14:
                                body = _context3.sent;

                                if (!body) {
                                    _context3.next = 17;
                                    break;
                                }

                                return _context3.abrupt('return', _promise2.default.resolve(body));

                            case 17:
                                _context3.next = 19;
                                return this.readTextResponse(response);

                            case 19:
                                errorBody = _context3.sent;

                                if (!errorBody) {
                                    _context3.next = 22;
                                    break;
                                }

                                return _context3.abrupt('return', errorBody);

                            case 22:
                                return _context3.abrupt('return', _promise2.default.reject());

                            case 23:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function get(_x3) {
                return _ref3.apply(this, arguments);
            }

            return get;
        }()

        /**
         * @method post
         * @param {String} url pathname
         * @param {Object} param params
         * @return {Promise}
         */

    }, {
        key: 'post',
        value: function () {
            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(url) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var headers, response, body;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                headers = new Headers();

                                headers.append('Content-Type', 'application/json');

                                _context4.next = 4;
                                return fetch(this.options.BASE_API_URL + url, {
                                    method: 'POST',
                                    headers: headers,
                                    mode: 'cors',
                                    body: (0, _stringify2.default)(params),
                                    credentials: 'same-origin'
                                });

                            case 4:
                                response = _context4.sent;

                                if (!(response.status === 400)) {
                                    _context4.next = 7;
                                    break;
                                }

                                return _context4.abrupt('return', _promise2.default.reject(this.options.ERROR_TEXT));

                            case 7:
                                if (!(response.status >= 200 && response.status < 300)) {
                                    _context4.next = 18;
                                    break;
                                }

                                if (!(response.headers.get('content-type') && response.headers.get('content-type').indexOf('application/json') !== -1)) {
                                    _context4.next = 12;
                                    break;
                                }

                                _context4.next = 11;
                                return this.readResponse(response);

                            case 11:
                                return _context4.abrupt('return', _context4.sent);

                            case 12:
                                _context4.next = 14;
                                return this.readTextResponse(response);

                            case 14:
                                body = _context4.sent;

                                if (!body) {
                                    _context4.next = 17;
                                    break;
                                }

                                return _context4.abrupt('return', _promise2.default.resolve(body));

                            case 17:
                                return _context4.abrupt('return', _promise2.default.resolve());

                            case 18:
                                return _context4.abrupt('return', _promise2.default.reject());

                            case 19:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function post(_x6) {
                return _ref4.apply(this, arguments);
            }

            return post;
        }()

        /**
         * @method PATCH
         * @param {String} url pathname
         * @param {Object} param params
         * @return {Promise}
         */

    }, {
        key: 'patch',
        value: function () {
            var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(url) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var headers, response, body;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                headers = new Headers();

                                headers.append('Content-Type', 'application/json');

                                console.log('(Base service) BASE_API_URL: ' + this.options.BASE_API_URL);
                                console.log('(Base service) url: ' + url);
                                console.log('(Base Service) params: ', params);

                                _context5.next = 7;
                                return fetch(this.options.BASE_API_URL + url, {
                                    method: 'PATCH',
                                    headers: headers,
                                    mode: 'cors',
                                    body: (0, _stringify2.default)(params),
                                    credentials: 'same-origin'
                                });

                            case 7:
                                response = _context5.sent;

                                if (!(response.status === 400)) {
                                    _context5.next = 10;
                                    break;
                                }

                                return _context5.abrupt('return', _promise2.default.reject(this.options.ERROR_TEXT));

                            case 10:
                                if (!(response.status >= 200 && response.status < 300)) {
                                    _context5.next = 21;
                                    break;
                                }

                                if (!(response.headers.get('content-type') && response.headers.get('content-type').indexOf('application/json') !== -1)) {
                                    _context5.next = 15;
                                    break;
                                }

                                _context5.next = 14;
                                return this.readResponse(response);

                            case 14:
                                return _context5.abrupt('return', _context5.sent);

                            case 15:
                                _context5.next = 17;
                                return this.readTextResponse(response);

                            case 17:
                                body = _context5.sent;

                                if (!body) {
                                    _context5.next = 20;
                                    break;
                                }

                                return _context5.abrupt('return', _promise2.default.resolve(body));

                            case 20:
                                return _context5.abrupt('return', _promise2.default.resolve());

                            case 21:
                                return _context5.abrupt('return', _promise2.default.reject());

                            case 22:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function patch(_x8) {
                return _ref5.apply(this, arguments);
            }

            return patch;
        }()

        /**
         * Get the data from local storage
         *
         * @method getLocal
         * @param {String} name
         * @return {Promise.<JSON>}
         */

    }, {
        key: 'getLocal',
        value: function () {
            var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(name) {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                return _context6.abrupt('return', _LocalData.localData.getItem(name));

                            case 1:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function getLocal(_x10) {
                return _ref6.apply(this, arguments);
            }

            return getLocal;
        }()

        /**
         * Save the data to local storage
         *
         * @method setLocal
         * @param {String} name
         * @param {Object} data
         * @return {Promise.<JSON>}
         */

    }, {
        key: 'setLocal',
        value: function () {
            var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(name, data) {
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _LocalData.localData.setItem(name, data);

                                return _context7.abrupt('return', true);

                            case 2:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function setLocal(_x11, _x12) {
                return _ref7.apply(this, arguments);
            }

            return setLocal;
        }()

        /**
         * Delete an item from local storage
         *
         * @method deleteLocal
         * @param {String} name
         * @return {Promise.<JSON>}
         */

    }, {
        key: 'deleteLocal',
        value: function () {
            var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(name) {
                return _regenerator2.default.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _LocalData.localData.removeItem(name);

                                return _context8.abrupt('return', true);

                            case 2:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function deleteLocal(_x13) {
                return _ref8.apply(this, arguments);
            }

            return deleteLocal;
        }()
    }]);
    return BaseService;
}();

},{"../lib/LocalData":176,"babel-runtime/core-js/json/stringify":2,"babel-runtime/core-js/number/is-integer":4,"babel-runtime/core-js/object/keys":9,"babel-runtime/core-js/promise":11,"babel-runtime/helpers/asyncToGenerator":14,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"babel-runtime/regenerator":21,"url-polyfill":"url-polyfill","url-search-params-polyfill":166,"whatwg-fetch":"whatwg-fetch"}],181:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _BasePortalService2 = require('./BasePortalService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartService = function (_BasePortalService) {
    (0, _inherits3.default)(CartService, _BasePortalService);

    function CartService() {
        (0, _classCallCheck3.default)(this, CartService);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartService.__proto__ || (0, _getPrototypeOf2.default)(CartService)).call(this));

        _this.updateQuantityEndpoint = '/cart/updatequantity';
        _this.addItemEndpoint = '/cart/addtocart';
        _this.sharedCartEmailEndpoint = '/cart/sendsharedcartemail', _this.sharedCartUrlEndpoint = '/cart/sharedcarturl';
        return _this;
    }

    (0, _createClass3.default)(CartService, [{
        key: 'updateCart',
        value: function updateCart(params) {
            return this.patch(this.updateQuantityEndpoint, params);
        }
    }, {
        key: 'addToCart',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(params) {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.post(this.addItemEndpoint, params);

                            case 2:
                                response = _context.sent;
                                return _context.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function addToCart(_x) {
                return _ref.apply(this, arguments);
            }

            return addToCart;
        }()
    }, {
        key: 'getSharedCartUrl',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var response;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.get(this.sharedCartUrlEndpoint);

                            case 2:
                                response = _context2.sent;
                                return _context2.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getSharedCartUrl() {
                return _ref2.apply(this, arguments);
            }

            return getSharedCartUrl;
        }()
    }, {
        key: 'sendSharedCartEmail',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(params) {
                var response;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.post(this.sharedCartEmailEndpoint, params);

                            case 2:
                                response = _context3.sent;
                                return _context3.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function sendSharedCartEmail(_x2) {
                return _ref3.apply(this, arguments);
            }

            return sendSharedCartEmail;
        }()
    }]);
    return CartService;
}(_BasePortalService2.BasePortalService);

exports.default = CartService;

},{"./BasePortalService":179,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/asyncToGenerator":14,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"babel-runtime/helpers/inherits":18,"babel-runtime/helpers/possibleConstructorReturn":19,"babel-runtime/regenerator":21}],182:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _isInteger = require("babel-runtime/core-js/number/is-integer");

var _isInteger2 = _interopRequireDefault(_isInteger);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SERVICE_CONSTANTS = {
    EVENT_ADD_PAYMENT_INFO: "add_payment_info",
    EVENT_ADD_SHIPPING_INFO: "add_shipping_info",
    EVENT_ADD_TO_CART: "add_to_cart",
    EVENT_BEGIN_CHECKOUT: "begin_checkout",
    EVENT_PURCHASE: "purchase",
    EVENT_REMOVE_FROM_CART: "remove_from_cart",
    EVENT_SELECT_LIST_ITEM: "select_item",
    EVENT_VIEW_CART: "view_cart",
    EVENT_VIEW_ITEM: "view_item",
    EVENT_VIEW_ITEM_LIST: "view_item_list"
};

var TrackingService = function () {
    function TrackingService() {
        (0, _classCallCheck3.default)(this, TrackingService);

        this.options = (0, _assign2.default)({}, this.options, SERVICE_CONSTANTS);
    }

    (0, _createClass3.default)(TrackingService, [{
        key: "_mapItemProperties",
        value: function _mapItemProperties(item, dataLayerItem) {
            dataLayerItem["item_id"] = item.ProductCode;
            dataLayerItem["item_name"] = item.ProductName;
            dataLayerItem["item_brand"] = "Raymond";
            dataLayerItem["item_category"] = item.ProductCategory;
            dataLayerItem["item_category2"] = item.ProductSeries;
            dataLayerItem["price"] = item.PriceValue;
            // It's possible that the ProductCategory is not set, but the ProductSeries is
            // In that situation, move the ProductSeries value to item_category as the top-level category
            if (dataLayerItem["item_category"] == "" && dataLayerItem["item_category2"] != "") {
                dataLayerItem["item_category"] = item.ProductSeries;
                dataLayerItem["item_category2"] = "";
            }
        }
    }, {
        key: "_buildEcommerceItems",
        value: function _buildEcommerceItems(cartEntries) {
            var _this = this;

            var dataItems = [];
            var listIndex = 0;

            if (!cartEntries) return dataItems;

            cartEntries.forEach(function (item) {
                if (item.Product.ProductQuantity == 0) return;
                // skip Accessory entry here, we will add via ProductReference
                if (item.IsProductAnAccessory) return;

                var dataItem = {
                    index: listIndex,
                    quantity: item.Product.ProductQuantity
                };

                _this._mapItemProperties(item.Product, dataItem);

                dataItems.push(dataItem);
                listIndex++;

                if (item.Product.hasOwnProperty("ProductReference") && item.Product.ProductReference != null && item.Product.ProductReference.ProductName != null) {
                    var accessoryItem = {
                        index: 1,
                        quantity: item.Product.ProductQuantity,
                        item_id: item.Product.ProductReference.ProductCode,
                        item_name: item.Product.ProductReference.ProductName,
                        item_brand: "Raymond",
                        price: item.Product.ProductReference.PriceValue
                    };
                    dataItems.push(accessoryItem);
                    listIndex++;
                }
            });

            return dataItems;
        }
    }, {
        key: "_convertPrice",
        value: function _convertPrice(priceVal) {
            if (priceVal == null || priceVal == "") return 0;
            if ((0, _isInteger2.default)(priceVal)) return priceVal;
            return parseFloat(priceVal.replace(/[^0-9.]/g, ''));
        }

        /**
         * @method addPaymentInfo
         * @param {Object} cart current cart data
         */

    }, {
        key: "addPaymentInfo",
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(cart) {
                var dataItems, ecommerce, data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                dataItems = this._buildEcommerceItems(cart.Entries);
                                ecommerce = {
                                    currency: "USD",
                                    value: this._convertPrice(cart.SubTotal),
                                    payment_type: "Credit Card",
                                    items: dataItems
                                };
                                data = { event: this.options.EVENT_ADD_PAYMENT_INFO, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);
                                return _context.abrupt("return");

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function addPaymentInfo(_x) {
                return _ref.apply(this, arguments);
            }

            return addPaymentInfo;
        }()

        /**
         * @method addShippingInfo
         * @param {Object} cart current cart data
         */

    }, {
        key: "addShippingInfo",
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(cart) {
                var dataItems, ecommerce, data;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                dataItems = this._buildEcommerceItems(cart.Entries);
                                ecommerce = {
                                    currency: "USD",
                                    value: this._convertPrice(cart.SubTotal),
                                    items: dataItems
                                };
                                data = { event: this.options.EVENT_ADD_SHIPPING_INFO, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);
                                return _context2.abrupt("return");

                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function addShippingInfo(_x2) {
                return _ref2.apply(this, arguments);
            }

            return addShippingInfo;
        }()

        /**
         * @method addToCart
         * @param {Object} item item being added
         */

    }, {
        key: "addToCart",
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(item) {
                var dataItem, item_list, accessoryValue, accessoryItem, finalPrice, ecommerce, data;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                dataItem = {
                                    index: 0,
                                    quantity: item.ProductQuantity
                                };


                                this._mapItemProperties(item, dataItem);
                                item_list = [dataItem];

                                // Check for accessory reference

                                accessoryValue = 0;

                                if (item.hasOwnProperty("ProductReference") && item.ProductReference && item.ProductReference.ProductName != null) {
                                    accessoryItem = {
                                        index: 1,
                                        quantity: item.ProductQuantity,
                                        item_id: item.ProductReference.ProductCode,
                                        item_name: item.ProductReference.ProductName,
                                        item_brand: "Raymond",
                                        price: item.ProductReference.PriceValue
                                    };

                                    item_list.push(accessoryItem);
                                    accessoryValue = this._convertPrice(accessoryItem.price) * this._convertPrice(item.ProductQuantity);
                                }

                                finalPrice = this._convertPrice(item.PriceValue) * this._convertPrice(item.ProductQuantity) + accessoryValue;
                                ecommerce = {
                                    currency: "USD",
                                    value: finalPrice,
                                    items: item_list
                                };
                                data = { event: this.options.EVENT_ADD_TO_CART, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);

                                return _context3.abrupt("return");

                            case 11:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function addToCart(_x3) {
                return _ref3.apply(this, arguments);
            }

            return addToCart;
        }()

        /**
         * @method beginCheckout
         * @param {Object} cart current cart data
         */

    }, {
        key: "beginCheckout",
        value: function () {
            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(cart) {
                var dataItems, ecommerce, data;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                dataItems = this._buildEcommerceItems(cart.Entries);
                                ecommerce = {
                                    currency: "USD",
                                    value: this._convertPrice(cart.SubTotal),
                                    items: dataItems
                                };
                                data = { event: this.options.EVENT_BEGIN_CHECKOUT, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);
                                return _context4.abrupt("return");

                            case 6:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function beginCheckout(_x4) {
                return _ref4.apply(this, arguments);
            }

            return beginCheckout;
        }()

        /**
         * @method purchase
         * @param {Object} order order data
         */

    }, {
        key: "purchase",
        value: function () {
            var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(order) {
                var dataItems, ecommerce, data;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                dataItems = this._buildEcommerceItems(order.Entries);
                                ecommerce = {
                                    currency: "USD",
                                    transaction_id: order.OrderId,
                                    value: this._convertPrice(order.TotalWithTax),
                                    shipping: this._convertPrice(order.DeliveryTotal),
                                    tax: this._convertPrice(order.TotalTax),
                                    items: dataItems
                                };
                                data = { event: this.options.EVENT_PURCHASE, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);
                                return _context5.abrupt("return");

                            case 6:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function purchase(_x5) {
                return _ref5.apply(this, arguments);
            }

            return purchase;
        }()

        /**
         * @method removeFromCart
         * @param {Object} items items being removed
         */

    }, {
        key: "removeFromCart",
        value: function () {
            var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(item) {
                var dataItem, item_list, accessoryValue, accessoryItem, finalPrice, ecommerce, data;
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                dataItem = {
                                    index: 0,
                                    quantity: item.ProductQuantity
                                };


                                this._mapItemProperties(item, dataItem);
                                item_list = [dataItem];

                                // Check for accessory reference

                                accessoryValue = 0;

                                if (item.hasOwnProperty("ProductReference") && item.ProductReference && item.ProductReference.ProductName != null) {
                                    accessoryItem = {
                                        index: 1,
                                        quantity: item.ProductQuantity,
                                        item_id: item.ProductReference.ProductCode,
                                        item_name: item.ProductReference.ProductName,
                                        item_brand: "Lift-Rite",
                                        price: item.ProductReference.PriceValue
                                    };

                                    item_list.push(accessoryItem);
                                    accessoryValue = this._convertPrice(accessoryItem.price) * this._convertPrice(item.ProductQuantity);
                                }

                                finalPrice = this._convertPrice(item.PriceValue) * this._convertPrice(item.ProductQuantity) + accessoryValue;
                                ecommerce = {
                                    currency: "USD",
                                    value: finalPrice,
                                    items: item_list
                                };
                                data = { event: this.options.EVENT_REMOVE_FROM_CART, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);

                                return _context6.abrupt("return");

                            case 11:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function removeFromCart(_x6) {
                return _ref6.apply(this, arguments);
            }

            return removeFromCart;
        }()

        /**
         * @method removeFromCart
         * @param {Object} cart current cart data
         */

    }, {
        key: "removeAllFromCart",
        value: function () {
            var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(cart) {
                var dataItems, ecommerce, data;
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                dataItems = this._buildEcommerceItems(cart.Entries);
                                ecommerce = {
                                    currency: "USD",
                                    value: this._convertPrice(cart.SubTotal),
                                    items: dataItems
                                };
                                data = { event: this.options.EVENT_REMOVE_FROM_CART, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);

                                return _context7.abrupt("return");

                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function removeAllFromCart(_x7) {
                return _ref7.apply(this, arguments);
            }

            return removeAllFromCart;
        }()

        /**
         * @method selectItem
         * @param {string} list_id id of list where selection was made
         * @param {string} list_name name of list where selection was made
         * @param {Object} item selected item
         */

    }, {
        key: "selectItem",
        value: function () {
            var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(list_id, list_name, item) {
                var dataItem, ecommerceObject, data;
                return _regenerator2.default.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                dataItem = {
                                    index: 0
                                };


                                this._mapItemProperties(item, dataItem);

                                ecommerceObject = {
                                    item_list_id: list_id,
                                    item_list_name: list_name,
                                    items: [dataItem]
                                };
                                data = { event: this.options.EVENT_SELECT_LIST_ITEM, ecommerce: ecommerceObject };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);

                                return _context8.abrupt("return");

                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function selectItem(_x8, _x9, _x10) {
                return _ref8.apply(this, arguments);
            }

            return selectItem;
        }()

        /**
         * @method viewItem
         * @param {Object} item viewed item
         */

    }, {
        key: "viewItem",
        value: function () {
            var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(item) {
                var dataItem, ecommerce, data;
                return _regenerator2.default.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                dataItem = {
                                    index: 0
                                };


                                this._mapItemProperties(item, dataItem);

                                ecommerce = {
                                    currency: "USD",
                                    value: item.PriceValue,
                                    items: [dataItem]
                                };
                                data = { event: this.options.EVENT_VIEW_ITEM, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);
                                return _context9.abrupt("return");

                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function viewItem(_x11) {
                return _ref9.apply(this, arguments);
            }

            return viewItem;
        }()

        /**
         * @method viewItemList
         * @param {String} list_id id of viewed list 
         * @param {String} list_name name of viewed list
         * @param {[Object]} items list items
         */

    }, {
        key: "viewItemList",
        value: function () {
            var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(item_list_id, item_list_name, items) {
                var _this2 = this;

                var dataItems, listIndex, ecommerce, data;
                return _regenerator2.default.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                dataItems = [];
                                listIndex = 0;


                                items.forEach(function (item) {
                                    var dataItem = {
                                        index: listIndex
                                    };

                                    _this2._mapItemProperties(item, dataItem);

                                    dataItems.push(dataItem);
                                    listIndex++;
                                });

                                ecommerce = {
                                    item_list_id: item_list_id,
                                    item_list_name: item_list_name,
                                    items: dataItems
                                };
                                data = { event: this.options.EVENT_VIEW_ITEM_LIST, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);
                                return _context10.abrupt("return");

                            case 8:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function viewItemList(_x12, _x13, _x14) {
                return _ref10.apply(this, arguments);
            }

            return viewItemList;
        }()

        /**
         * @method viewCart
         * @param {Object} cart current cart data
         */

    }, {
        key: "viewCart",
        value: function () {
            var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(cart) {
                var dataItems, ecommerce, data;
                return _regenerator2.default.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                dataItems = this._buildEcommerceItems(cart.Entries);
                                ecommerce = {
                                    currency: "USD",
                                    value: this._convertPrice(cart.SubTotal),
                                    items: dataItems
                                };
                                data = { event: this.options.EVENT_VIEW_CART, ecommerce: ecommerce };


                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(data);
                                return _context11.abrupt("return");

                            case 6:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function viewCart(_x15) {
                return _ref11.apply(this, arguments);
            }

            return viewCart;
        }()

        /***
         * GOOGLE ADS
         */

        /**
         * @method purchase
         * @param {Object} order order data
         */

    }, {
        key: "adsConversion",
        value: function () {
            var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(order, property) {
                var config;
                return _regenerator2.default.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                config = {
                                    send_to: property,
                                    value: this._convertPrice(order.TotalWithTax),
                                    currency: "USD",
                                    transaction_id: order.OrderId
                                };


                                window.dataLayer.push({ ecommerce: null });
                                gtag("event", "conversion", config);
                                return _context12.abrupt("return");

                            case 4:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function adsConversion(_x16, _x17) {
                return _ref12.apply(this, arguments);
            }

            return adsConversion;
        }()
    }]);
    return TrackingService;
}();

exports.default = TrackingService;

},{"babel-runtime/core-js/number/is-integer":4,"babel-runtime/core-js/object/assign":5,"babel-runtime/helpers/asyncToGenerator":14,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"babel-runtime/regenerator":21}],183:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _BasePortalService2 = require('./BasePortalService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderService = function (_BasePortalService) {
    (0, _inherits3.default)(OrderService, _BasePortalService);

    function OrderService() {
        (0, _classCallCheck3.default)(this, OrderService);

        var _this = (0, _possibleConstructorReturn3.default)(this, (OrderService.__proto__ || (0, _getPrototypeOf2.default)(OrderService)).call(this));

        _this.reorderEndpoint = '/orderhistory/reorder';
        return _this;
    }

    (0, _createClass3.default)(OrderService, [{
        key: 'reorder',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(params) {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.post(this.reorderEndpoint, params);

                            case 2:
                                response = _context.sent;
                                return _context.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function reorder(_x) {
                return _ref.apply(this, arguments);
            }

            return reorder;
        }()
    }]);
    return OrderService;
}(_BasePortalService2.BasePortalService);

exports.default = OrderService;

},{"./BasePortalService":179,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/asyncToGenerator":14,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"babel-runtime/helpers/inherits":18,"babel-runtime/helpers/possibleConstructorReturn":19,"babel-runtime/regenerator":21}],184:[function(require,module,exports){
// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "    <li><a href=\"#"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" class=\"u-link\">- "
    + alias2(alias1((depth0 != null ? depth0.title : depth0), depth0))
    + "</a></li>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : {};

  return "<div class=\"vr_x3\">\r\n    <div class=\"u-textFontWeightBold\">"
    + container.escapeExpression(((helper = (helper = helpers.notificationMessage || (depth0 != null ? depth0.notificationMessage : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"notificationMessage","hash":{},"data":data}) : helper)))
    + "</div>\r\n</div>\r\n<ul>\r\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.product : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</ul>";
},"useData":true});

},{"hbsfy/runtime":163}],185:[function(require,module,exports){
// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "\r\n<div class=\"modal js-modal "
    + container.escapeExpression(alias1((depth0 != null ? depth0.classExtension : depth0), depth0))
    + "\" role=\"dialog\" aria-label=\"Pop up window\"><!-- default modal container/ creates overlay -->\r\n    <div class=\"modal-inner\"><!-- manages positioning of content -->\r\n        <div class=\"modal-inner-content js-modal-content\">\r\n            "
    + ((stack1 = alias1((depth0 != null ? depth0.content : depth0), depth0)) != null ? stack1 : "")
    + "\r\n        </div>\r\n    </div>\r\n</div>  ";
},"useData":true});

},{"hbsfy/runtime":163}],186:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ParsleyCreditCardValidator = exports.ParsleyCreditCardValidator = function () {
    /* Taken from https://github.com/gpassarelli/parsley.js-credit-card-validator and modified for our use. */
    var SELECTORS = {
        CARD_TYPE: '#PaymentTypeId',
        CARD_NUMBER: '#CardNumber'

        /**
         * Helper function to get credit card brand name from credit card number.
         * @param  string number        The credit card number
         * @param  boolean check_length Should it check for length
         * @return mixed                The card brand name or null
         */
    };window.getCreditCardBrand = function (number, check_length) {
        var _j,
            _len1,
            card_name = [],
            number = number.replace(/[ -]/g, '');

        if (!number.length) {
            return;
        }

        var check_length = typeof check_length !== 'undefined' ? check_length : false,
            card_types = [{
            name: 'AMEX',
            pattern: /^3[47][0-9]{13}$/,
            valid_length: [15]
        }, {
            name: 'DinersClub',
            pattern: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
            valid_length: [14]
        }, {
            name: 'Discover',
            pattern: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
            valid_length: [16]
        }, {
            name: 'JCB',
            pattern: /^(?:2131|1800|35\d{3})\d{11}$/,
            valid_length: [16]
        }, {
            name: 'MasterCard',
            pattern: /^5[1-5][0-9]{14}$/,
            valid_length: [16]
        }, {
            name: 'Visa',
            pattern: /^4[0-9]{12}(?:[0-9]{3})?$/,
            valid_length: [16]
        }];

        for (_j = 0, _len1 = card_types.length; _j < _len1; _j++) {
            var card = card_types[_j];

            if (card.pattern.test(number)) {
                if (check_length) {
                    if (card.valid_length.indexOf(number.length) > -1) {
                        card_name.push(card.name);
                    }
                } else {
                    card_name.push(card.name);
                }
            }
        }

        if (card_name.length) {
            return card_name.join(' ');
        }

        return null;
    };

    //---------------------------------------
    // CreditCard Number Verification
    //---------------------------------------
    window.Parsley.addValidator('creditcard', function (value, requirement) {
        var digit,
            n,
            _ref2,
            valid,
            _j,
            _len1,
            sum = 0;
        window.creditCardNumberFieldValue = value;
        var cardTypeDropdown = $(SELECTORS.CARD_TYPE);
        window.cardTypeDropdown = cardTypeDropdown.parsley();
        value = value.replace(/[ -]/g, '');
        _ref2 = value.split('').reverse();

        for (n = _j = 0, _len1 = _ref2.length; _j < _len1; n = ++_j) {
            digit = _ref2[n];
            digit = +digit;

            if (n % 2) {
                digit *= 2;

                if (digit < 10) {
                    sum += digit;
                } else {
                    sum += digit - 9;
                }
            } else {
                sum += digit;
            }
        }

        valid = sum % 10 === 0;
        // Checks for specific brands
        if (valid && requirement.length) {
            window.creditCardBrand = window.getCreditCardBrand(window.creditCardNumberFieldValue, true);
            if (window.creditCardBrand === undefined || window.creditCardBrand === null) {
                valid = false;
                return valid;
            }
            var valid_cards = requirement.split(','),
                valid = false,
                card = window.creditCardBrand.split(' ');
            for (var c in card) {
                if (requirement.indexOf(card[c]) > -1) {
                    valid = true;
                }
            }
        }

        if (window.creditCardTypeFieldValue !== window.creditCardBrand) {
            valid = false;
        }
        if (window.creditCardTypeFieldValue == window.creditCardBrand) {
            valid = true;
        }

        return valid;
    }, 32);
    //---------------------------------------
    // CVV Verification
    //---------------------------------------
    window.Parsley.addValidator('cardType', function (value, requirements) {
        window.creditCardTypeFieldValue = value;
        window.cardNumberField = $(SELECTORS.CARD_NUMBER).parsley();
        window.creditCardBrand = window.getCreditCardBrand(window.creditCardTypeFieldValue, true);
        window.cardNumberField.validate();

        if (window.creditCardTypeFieldValue !== window.creditCardBrand) {
            return false;
        }
        if (window.creditCardTypeFieldValue == window.creditCardBrand) {
            return true;
        }
    }, 32);

    //---------------------------------------
    // CVV Verification
    //---------------------------------------
    window.Parsley.addValidator('cvv', function (value) {
        return (/^[0-9]{3,4}$/.test(value)
        );
    }, 32);
}();

},{}],187:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ParsleyCreditCardValidator = require('./ParsleyCreditCardValidator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class Parsley helper
 * 
 * Add custom validator for passwords
 */

var ParsleyHelper = function () {
    function ParsleyHelper() {
        (0, _classCallCheck3.default)(this, ParsleyHelper);
    }

    (0, _createClass3.default)(ParsleyHelper, null, [{
        key: 'addValidators',


        /**
         * Method call custom validators
         *
         * @method addValidators
         * @chainable
         * @public
         */
        value: function addValidators() {

            this.addCustomPasswordValidator().addCustomDateValidatorMM().addCustomDateValidatorYY().addCustomDateValidatorYYYY().addCustomPhoneValidator().addCustomPostalCodeValidator().addCustomFullNameValidator();
            return this;
        }

        /**
         * Method attaches custom password checking to form instance
         *
         * @method  addCustomPasswordValidator 
         * @chainable
         * @public
         */

    }, {
        key: 'addCustomPasswordValidator',
        value: function addCustomPasswordValidator() {
            // create password strength 
            var expression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#\$%\^&\*])(?=.{8,})/;
            var regex = new RegExp(expression);

            // add password validation
            window.Parsley.addValidator('checkPassword', {
                validateString: function validateString(value) {
                    return regex.test(value);
                }
            });

            return this;
        }

        /**
         * Method attatches custom MM input checker
         *
         * @method addCustomDateValidatorMM
         * @chainable
         * @public
         */

    }, {
        key: 'addCustomDateValidatorMM',
        value: function addCustomDateValidatorMM() {
            var expression = /(^0[1-9]|^(10)|^(11)|^(12)){1}$/;
            var regex = new RegExp(expression);

            window.Parsley.addValidator('checkMonth', {
                validateString: function validateString(value) {
                    return regex.test(value);
                }
            });

            return this;
        }

        /**
         * Method attatches custom YY input checker
         *
         * @method addCustomDateValidatorYY
         * @chainable
         * @public
         */

    }, {
        key: 'addCustomDateValidatorYY',
        value: function addCustomDateValidatorYY() {
            var expression = /^([1-9])([0-9])$/;
            var regex = new RegExp(expression);

            window.Parsley.addValidator('checkYear', {
                validateString: function validateString(value) {
                    return regex.test(value);
                }
            });

            return this;
        }
    }, {
        key: 'addCustomDateValidatorYYYY',
        value: function addCustomDateValidatorYYYY() {
            var expression = /^20([1-9])([0-9])$/;
            var regex = new RegExp(expression);
            var date = new Date();
            var currentFullYear = date.getFullYear();

            window.Parsley.addValidator('checkYearFull', {
                validateString: function validateString(value) {
                    return regex.test(value) && parseInt(value) >= currentFullYear;
                }
            });

            return this;
        }

        /**
         * Method attatches custom phone input checker
         *
         * @method addCustomPhoneValidator
         * @chainable
         * @public
         */

    }, {
        key: 'addCustomPhoneValidator',
        value: function addCustomPhoneValidator() {
            var expression = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            var regex = new RegExp(expression);

            window.Parsley.addValidator('checkPhone', {
                validateString: function validateString(value) {
                    return regex.test(value);
                }
            });

            return this;
        }

        /**
         * Method checks for a full name
         *
         * @method addCustomFullNameValidator
         * @chainable
         * @public
         */

    }, {
        key: 'addCustomFullNameValidator',
        value: function addCustomFullNameValidator() {
            var expression = /^(\s){0,}([a-zA-Z]){1,}((\s){1,}([a-zA-Z]){1,}){1,}(\s){0,}$/;
            var regex = new RegExp(expression);

            window.Parsley.addValidator('fullName', {
                validateString: function validateString(value) {
                    return regex.test(value);
                }
            });

            return this;
        }

        /**
         * Method attatches custom postal code input checker
         *
         * @method addCustomPosalCodeValidator
         * @chainable
         * @public
         */

    }, {
        key: 'addCustomPostalCodeValidator',
        value: function addCustomPostalCodeValidator() {

            //US format
            var zipCodeExpression = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
            var zipCodeRegex = new RegExp(zipCodeExpression);
            //outside of the US format
            var postalCodeExpression = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/i;
            var postalCodeRegex = new RegExp(postalCodeExpression);

            window.Parsley.addValidator('checkPostalCode', {
                validateString: function validateString(value) {
                    return zipCodeRegex.test(value) || postalCodeRegex.test(value);
                }
            });
            return this;
        }
    }]);
    return ParsleyHelper;
}();

exports.default = ParsleyHelper;

},{"./ParsleyCreditCardValidator":186,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16}],188:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTORS = {
  SORT_TABLE: 'table[data-sortable]'
};

var Sortable = function () {
  function Sortable() {
    (0, _classCallCheck3.default)(this, Sortable);


    var tables = document.querySelectorAll(SELECTORS.SORT_TABLE);
    if (!tables.length) {
      return;
    }

    this.numberRegExp = /^-?[£$¤]?[\d,.]+%?$/;
    this.trimRegExp = /^\s+|\s+$/g;
    this.clickEvents = ['click', 'manualTrigger'];
    if ('ontouchstart' in document.documentElement) {
      this.clickEvents = ['touchstart', 'manualTrigger'];
    }
    this.setupTypes([{
      name: 'numeric',
      defaultSortDirection: 'descending',
      match: function match(a) {
        return a.match(this.numberRegExp);
      },
      comparator: function comparator(a) {
        return parseFloat(a.replace(/[^0-9.-]/g, ''), 10) || 0;
      }
    }, {
      name: 'date',
      defaultSortDirection: 'ascending',
      reverse: true,
      match: function match(a) {
        return !isNaN(Date.parse(a));
      },
      comparator: function comparator(a) {
        return Date.parse(a) || 0;
      }
    }, {
      name: 'alpha',
      defaultSortDirection: 'ascending',
      match: function match() {
        return true;
      },
      compare: function compare(a, b) {
        return a.localeCompare(b);
      }
    }]);
    this.init();
  }

  (0, _createClass3.default)(Sortable, [{
    key: 'addEventListener',
    value: function addEventListener(el, event, handler) {
      if (el.addEventListener != null) {
        return el.addEventListener(event, handler, false);
      } else {
        return el.attachEvent("on" + event, handler);
      }
    }
  }, {
    key: 'init',
    value: function init(options) {
      var table, tables, _i, _len, _results;
      if (options == null) {
        options = {};
      }
      if (options.selector == null) {
        options.selector = SELECTORS.SORT_TABLE;
      }
      tables = document.querySelectorAll(options.selector);
      _results = [];
      for (_i = 0, _len = tables.length; _i < _len; _i++) {
        table = tables[_i];
        _results.push(this.initTable(table));
      }
      return _results;
    }
  }, {
    key: 'initTable',
    value: function initTable(table) {
      var i, th, ths, _i, _len, _ref;
      if (((_ref = table.tHead) != null ? _ref.rows.length : void 0) !== 1) {
        return;
      }
      if (table.getAttribute('data-sortable-initialized') === 'true') {
        return;
      }
      table.setAttribute('data-sortable-initialized', 'true');
      ths = table.querySelectorAll('th');
      for (i = _i = 0, _len = ths.length; _i < _len; i = ++_i) {
        th = ths[i];
        if (th.getAttribute('data-sortable') !== 'false') {
          this.setupClickableTH(table, th, i);
        }
        if (th.getAttribute('data-sort-default') === 'true') {
          th.dispatchEvent(new Event("manualTrigger"));
          th.dispatchEvent(new Event("manualTrigger"));
        }
      }
      return table;
    }
  }, {
    key: 'setupClickableTH',
    value: function setupClickableTH(table, th, i) {
      var eventName, onClick, type, _i, _len, _results;
      var sortable = this;
      type = sortable.getColumnType(table, i);
      onClick = function onClick(e) {
        var compare, item, newSortedDirection, position, row, rowArray, canSort, sorted, sortedDirection, tBody, ths, value, _compare, _i, _j, _k, _l, _len, _len1, _len2, _len3, _len4, _m, _ref, _ref1;
        if (e.handled !== true) {
          e.handled = true;
        } else {
          return false;
        }

        canSort = this.getAttribute('data-sort-enable') !== null;
        if (!canSort) return false;

        sorted = this.getAttribute('data-sorted') === 'true';
        sortedDirection = this.getAttribute('data-sorted-direction');
        if (sorted) {
          newSortedDirection = sortedDirection === 'ascending' ? 'descending' : 'ascending';
        } else {
          newSortedDirection = type.defaultSortDirection;
        }
        ths = this.parentNode.querySelectorAll('th');
        for (_i = 0, _len = ths.length; _i < _len; _i++) {
          th = ths[_i];
          th.setAttribute('data-sorted', 'false');
          th.removeAttribute('data-sorted-direction');
        }
        this.setAttribute('data-sorted', 'true');
        this.setAttribute('data-sorted-direction', newSortedDirection);
        tBody = table.tBodies[0];
        rowArray = [];
        if (!sorted) {
          if (type.compare != null) {
            _compare = type.compare;
          } else {
            _compare = function _compare(a, b) {
              return b - a;
            };
          }
          compare = function compare(a, b) {
            if (a[0] === b[0]) {
              return a[2] - b[2];
            }
            if (type.reverse) {
              return _compare(b[0], a[0]);
            } else {
              return _compare(a[0], b[0]);
            }
          };
          _ref = tBody.rows;
          for (position = _j = 0, _len1 = _ref.length; _j < _len1; position = ++_j) {
            row = _ref[position];
            value = sortable.getNodeValue(row.cells[i]);
            if (type.comparator != null) {
              value = type.comparator(value);
            }
            rowArray.push([value, row, position]);
          }
          rowArray.sort(compare);
          for (_k = 0, _len2 = rowArray.length; _k < _len2; _k++) {
            row = rowArray[_k];
            tBody.appendChild(row[1]);
          }
        } else {
          _ref1 = tBody.rows;
          for (_l = 0, _len3 = _ref1.length; _l < _len3; _l++) {
            item = _ref1[_l];
            rowArray.push(item);
          }
          rowArray.reverse();
          for (_m = 0, _len4 = rowArray.length; _m < _len4; _m++) {
            row = rowArray[_m];
            tBody.appendChild(row);
          }
        }
        if (typeof window['CustomEvent'] === 'function') {
          return typeof table.dispatchEvent === "function" ? table.dispatchEvent(new CustomEvent('Sortable.sorted', {
            bubbles: true
          })) : void 0;
        }
      };
      _results = [];
      for (_i = 0, _len = this.clickEvents.length; _i < _len; _i++) {
        eventName = this.clickEvents[_i];
        _results.push(this.addEventListener(th, eventName, onClick));
      }

      return _results;
    }
  }, {
    key: 'getColumnType',
    value: function getColumnType(table, i) {
      var row, specified, text, type, _i, _j, _len, _len1, _ref, _ref1, _ref2;
      specified = (_ref = table.querySelectorAll('th')[i]) != null ? _ref.getAttribute('data-sortable-type') : void 0;
      if (specified != null) {
        return this.typesObject[specified];
      }
      _ref1 = table.tBodies[0].rows;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        row = _ref1[_i];
        text = this.getNodeValue(row.cells[i]);
        _ref2 = this.types;
        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
          type = _ref2[_j];
          if (type.match(text)) {
            return type;
          }
        }
      }
      return this.typesObject.alpha;
    }
  }, {
    key: 'getNodeValue',
    value: function getNodeValue(node) {
      var dataValue;
      if (!node) {
        return '';
      }
      dataValue = node.getAttribute('data-value');
      if (dataValue !== null) {
        return dataValue;
      }
      if (typeof node.innerText !== 'undefined') {
        return node.innerText.replace(this.trimRegExp, '');
      }
      return node.textContent.replace(this.trimRegExp, '');
    }
  }, {
    key: 'setupTypes',
    value: function setupTypes(types) {
      var type, _i, _len, _results;
      this.types = types;
      this.typesObject = {};
      _results = [];
      for (_i = 0, _len = types.length; _i < _len; _i++) {
        type = types[_i];
        _results.push(this.typesObject[type.name] = type);
      }
      return _results;
    }
  }]);
  return Sortable;
}();

exports.default = Sortable;
;

},{"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16}],189:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildCustomEvent = buildCustomEvent;
exports.getPseudoContent = getPseudoContent;
exports.getCurrentBreakpoint = getCurrentBreakpoint;
exports.debounce = debounce;
exports.paramToObject = paramToObject;
function buildCustomEvent(event, detail) {
    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
    }

    var bubbles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return new CustomEvent(event, {
        bubbles: bubbles,
        detail: detail,
        args: args
    });
}

function getPseudoContent(el, pseudo) {
    return window.getComputedStyle(el, pseudo).getPropertyValue('content').replace(/"/g, '');
}

function getCurrentBreakpoint() {
    return getPseudoContent(document.body, ':after');
}

function debounce(fn, wait) {
    var _this = this;

    var timeout = void 0;
    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        clearTimeout(timeout);
        timeout = setTimeout(function () {
            return fn.apply(_this, args);
        }, wait || 1);
    };
}

/*  ParamToObject splits the return parameter string from propay
and creates a javascript object                             */
function paramToObject(string) {
    //remove line breaks
    string = string.replace(/(\r\n|\n|\r)/gm, "");

    var splitParams = string.split('&');

    var stringObject = {};
    splitParams.map(function (el) {
        var keyValue = el.split('=');
        stringObject[keyValue[0]] = keyValue[1];
    });

    return stringObject;
}

},{}],190:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * CarouselView
 *
 * @class CarouselView
 * @constructor
 */
var CarouselView = function () {
    function CarouselView($carousel) {
        (0, _classCallCheck3.default)(this, CarouselView);

        /**
         * A reference to the carousel container
         *
         * @property carousel
         * @type {type}
         * @public
         */
        if ($carousel instanceof _jquery2.default) {
            this.$carousel = $carousel;
        } else {
            throw '$carousel is not a jquery object!';
        }

        /**
        * Slide count
        *
        * @property totalSlides
        * @type int
        * @default false
        * @public
        */
        this.totalSlides = null;

        /**
        * Is Enabled?
        *
        * @property isEnabled
        * @type boolean
        * @default false
        * @public
        */
        this.isEnabled = false;

        this.init();
    }

    /**
     * Initializes methods
     *
     * @method init
     * @public
     * @chainable
     */


    (0, _createClass3.default)(CarouselView, [{
        key: 'init',
        value: function init() {

            this.setupHandlers().createChildren().enable();
        }

        /**
         * SetupHandlers
         *
         * @method setupHandlers
         * @public
         * @chainable
         */

    }, {
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.handleOnBulletClick = this.onBulletClick.bind(this);
            this.handlOnButtonClick = this.onButtonClick.bind(this);

            return this;
        }

        /**
         * createChildren
         *
         * @method createChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$slides = this.$carousel.find('[data-carousel-slide]');
            this.$bullets = this.$carousel.find('[data-carousel-bullet]');
            this.$buttons = this.$carousel.find('[data-carousel-button]');

            this.totalSlides = this.$slides.length;

            return this;
        }

        /**
        * Method goToSlide (indexed starting at 1)
        *
        * @method goToSlide
        * @chainable
        * @public
        */

    }, {
        key: 'goToSlide',
        value: function goToSlide(index) {

            index -= 1; //jquery is 0-indexed

            this.$slides.filter('.active').toggleClass('active');
            this.$slides.eq(index).toggleClass('active');

            this.$bullets.filter('.active').toggleClass('active');
            this.$bullets.eq(index).toggleClass('active');

            return this;
        }

        /**
        * Method go to next slide (direction +/- from current)
        * making sure to loop if at beginning or end of collection
        *
        * @method advanceSlide
        * @chainable
        * @public
        */

    }, {
        key: 'advanceSlide',
        value: function advanceSlide(direction) {
            var $activeElement = this.$slides.filter('.active');
            var currentIndex = this.$slides.index($activeElement) + 1;
            var nextIndex = currentIndex + direction;

            if (nextIndex > this.totalSlides) {
                this.goToSlide(1);
            } else if (nextIndex < 1) {
                this.goToSlide(this.totalSlides);
            } else {
                this.goToSlide(nextIndex);
            }

            return this;
        }

        /**
        * Method onBulletClick
        *   
        * @method onBulletClick
        * @chainable
        * @public
        */

    }, {
        key: 'onBulletClick',
        value: function onBulletClick(e) {
            var $clickTargetIndex = (0, _jquery2.default)(e.target).closest('[data-carousel-bullet]').data('carouselBullet');
            this.goToSlide($clickTargetIndex);
        }

        /**
        * Method onNextPreviousClick
        *
        * @method onNextPreviousClick
        * @chainable
        * @public
        */

    }, {
        key: 'onButtonClick',
        value: function onButtonClick(e) {
            var direction = (0, _jquery2.default)(e.target).closest('[data-carousel-button]').data('carousel-button');
            this.advanceSlide(direction);
        }

        /**
         * Enable
         *
         * @method enable
         * @public
         * @chainable
         */

    }, {
        key: 'enable',
        value: function enable() {

            if (this.isEnabled) {
                return this;
            }

            this.$bullets.on('click', this.handleOnBulletClick);
            this.$buttons.on('click', this.handlOnButtonClick);

            this.isEnabled = true;

            return this;
        }

        /**
         * Disable
         *
         * @method disable
         * @public
         * @chainable
         */

    }, {
        key: 'disable',
        value: function disable() {
            if (!this.isEnabled) {
                return this;
            }

            this.isEnabled = false;

            return this;
        }
    }]);
    return CarouselView;
}();

exports.default = CarouselView;

},{"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],191:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _cartItemErrors = require('../templates/cartItemErrors.hbs');

var _cartItemErrors2 = _interopRequireDefault(_cartItemErrors);

var _classes = require('../constants/classes');

var _Notifications = require('../global/Notifications');

var _Notifications2 = _interopRequireDefault(_Notifications);

var _TrackingService = require('../services/TrackingService');

var _TrackingService2 = _interopRequireDefault(_TrackingService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTORS = {
    CART_TABLE: '#cartTable',
    CART_ITEMS: '.js-cartController-item',
    ACTIVE_CART_ITEMS: '.js-cartController-item:not(.removed)',
    REMOVED_CART_ITEMS: '.js-cartController-item',
    PRODUCT_TITLE: '.js-cartController-item-productTitle',
    ITEM_QTY_INPUT: '.js-cartController-qty',
    ITEM_REMOVAL_LINK: '.js-cartController-remove',
    ITEM_UPDATE_LINK: '.js-cartController-update',
    ITEM_UNDO_REMOVAL_LINK: '.js-cartController-undoRemoval',
    ARIA_UPDATE: '.js-cartController-update-callout',
    SUBTOTAL: '.js-cartController-subtotal',
    DISCOUNT_TOTAL: '.js-cartController-discountTotal',
    CART_COUNT: '.js-cartCount',
    CART_COUNT_LABEL: '.js-cartCount-label',
    CART_CHECKOUT: '.js-cartController-checkout',
    DISCOUNTS_LABEL: '#DiscountTotal',
    SUBTOTAL_LABEL: '#Subtotal',
    MSG_DISPLAY: '.msg-display',
    CART_SHARE_LINK: '.js-cartController-share',
    CART_SHARE_MODAL: '.js-cartController-shareModal',
    CART_SHARE_COPY_URL: '.js-cartController-shareUrl',
    CART_SHARE_SEND_EMAIL: '.js-cartController-shareEmail',
    CART_SHARE_URL_MODAL: '.js-cartController-shareUrlModal',
    CART_SHARE_URL_INPUT: '.js-cartController-shareUrlInput',
    CART_SHARE_EMAIL_MODAL: '.js-cartController-shareEmailModal',
    CART_SHARE_EMAIL_CLOSE_BUTON: '.js-cartController-shareCartCloseButton',
    CART_SHARE_EMAIL_RECIPIENT_EMAIL: '.js-cartController-shareRecipientEmail',
    CART_SHARE_EMAIL_SENDER_NAME: '.js-cartController-shareSenderName',
    CART_SHARE_EMAIL_SENDER_EMAIL: '.js-cartController-shareSenderEmail',
    CART_SHARE_EMAIL_MESSAGE_BODY: '.js-cartController-shareMessageBody',
    CART_SHARE_EMAIL_SEND_BUTON: '.js-cartController-shareCartSendButton'
};

var CLASSES = {
    REMOVED_ITEM_CLASS: 'removed',
    ICON_LINK_ATTENTION: 'iconLink_attention'
};

var VALUES = {
    MAX_CART_ITEM_QTY: 250,
    CART_JS_VARIABLE: 'js_userCart'
};

var CartView = function () {
    function CartView($element, controller) {
        (0, _classCallCheck3.default)(this, CartView);

        this.cartController = controller;
        this.cartService = this.cartController.cartService;
        this.cartModel = this.cartController.cartModel;
        this.trackingService = new _TrackingService2.default();
        this.init($element);
    }

    (0, _createClass3.default)(CartView, [{
        key: 'init',
        value: function init($element) {
            this.$element = $element;

            return this.setupHandlers().createChildren().layout().enable().trackCartViewed();
        }
    }, {
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onQuantityChangeHandler = this.onQuantityChange.bind(this);
            this.onQuantityKeydownHandler = this.onQuantityKeydown.bind(this);
            this.onUpdateClickHandler = this.onUpdateClick.bind(this);
            this.onItemRemovalHandler = this.onItemRemoval.bind(this);
            this.onUndoRemovalHandler = this.onUndoRemoval.bind(this);
            this.onCheckoutClickHandler = this.onCheckoutClick.bind(this);
            this.onClickOutHandler = this.onClickOut.bind(this);
            this.onCartShareHandler = this.onCartShare.bind(this);
            this.onCartShareCopyLinkHandler = this.onCartShareCopyLink.bind(this);
            this.onCartShareSendEmailHandler = this.onCartShareSendEmail.bind(this);
            this.onCartShareSendEmailCloseHandler = this.onCartShareSendEmailClose.bind(this);
            this.onCartShareSendEmailSubmitHandler = this.onCartShareSendEmailSubmit.bind(this);
            return this;
        }
    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.createDynamicChildren();
            this.cartData = window[VALUES.CART_JS_VARIABLE];
            this.$cartTable = this.$element.find(SELECTORS.CART_TABLE);
            this.$cartItems = this.$element.find(SELECTORS.CART_ITEMS);
            this.$undoRemovalLinks = this.$cartItems.find(SELECTORS.ITEM_UNDO_REMOVAL_LINK);
            this.notifications = new _Notifications2.default();
            this.$subtotal = this.$element.find(SELECTORS.SUBTOTAL);
            this.$discountTotal = this.$element.find(SELECTORS.DISCOUNT_TOTAL);
            this.$discountsLabel = this.$element.find(SELECTORS.DISCOUNTS_LABEL);
            this.$subtotalLabel = this.$element.find(SELECTORS.SUBTOTAL_LABEL);
            this.$cartCount = (0, _jquery2.default)(SELECTORS.CART_COUNT);
            this.$cartCountLabel = this.$cartCount.find(SELECTORS.CART_COUNT_LABEL);
            this.$checkout = this.$element.find(SELECTORS.CART_CHECKOUT);
            this.cartModel.createCartArray(this.$activeCartItems);
            this.$ariaUpdate = this.$element.find(SELECTORS.ARIA_UPDATE);

            this.$cartShareLink = this.$element.find(SELECTORS.CART_SHARE_LINK);
            this.$cartShareModal = this.$element.find(SELECTORS.CART_SHARE_MODAL);
            this.$cartShareCopyUrlLink = this.$element.find(SELECTORS.CART_SHARE_COPY_URL);
            this.$cartShareSendEmailLink = this.$element.find(SELECTORS.CART_SHARE_SEND_EMAIL);
            this.$cartShareUrlModal = this.$element.find(SELECTORS.CART_SHARE_URL_MODAL);
            this.$cartShareUrlInput = this.$element.find(SELECTORS.CART_SHARE_URL_INPUT);
            this.$cartShareEmailModal = this.$element.find(SELECTORS.CART_SHARE_EMAIL_MODAL);
            this.$cartShareEmailCloseButton = this.$element.find(SELECTORS.CART_SHARE_EMAIL_CLOSE_BUTON);
            this.$cartShareEmailRecipientEmail = this.$element.find(SELECTORS.CART_SHARE_EMAIL_RECIPIENT_EMAIL);
            this.$cartShareEmailSenderName = this.$element.find(SELECTORS.CART_SHARE_EMAIL_SENDER_NAME);
            this.$cartShareEmalSenderEmail = this.$element.find(SELECTORS.CART_SHARE_EMAIL_SENDER_EMAIL);
            this.$cartShareEmailMessageBody = this.$element.find(SELECTORS.CART_SHARE_EMAIL_MESSAGE_BODY);
            this.$cartShareEmailSendButton = this.$element.find(SELECTORS.CART_SHARE_EMAIL_SEND_BUTON);

            return this;
        }
    }, {
        key: 'trackCartViewed',
        value: function trackCartViewed() {
            this.trackingService.viewCart(this.cartData);
            return this;
        }
    }, {
        key: 'createDynamicChildren',
        value: function createDynamicChildren() {
            this.$activeCartItems = this.$element.find(SELECTORS.ACTIVE_CART_ITEMS);
            this.$updateLinks = this.$activeCartItems.find(SELECTORS.ITEM_UPDATE_LINK);
            this.$itemRemovalLinks = this.$activeCartItems.find(SELECTORS.ITEM_REMOVAL_LINK);
            this.$quantityInputs = this.$activeCartItems.find(SELECTORS.ITEM_QTY_INPUT);
            this.$inactiveCartItems = this.$element.find(SELECTORS.INACTIVE_CART_ITEMS);
            return this;
        }
    }, {
        key: 'layout',
        value: function layout() {

            return this;
        }
    }, {
        key: 'onQuantityChange',
        value: function onQuantityChange(e) {
            var _this = this;

            var id = e.target.dataset.productId;
            var qty = this.$quantityInputs.filter('[data-product-id="' + id + '"]')[0].value;
            var updateLink = this.$updateLinks.filter('[data-product-id="' + id + '"]');
            this.cartModel.updateTrackingArray(id, qty);

            /* Adding active state change class to the updatelinks to show it's been changed */
            for (var i = 0; i < this.cartModel.cartArray.length; i++) {
                if (this.cartModel.cartArray[i].id === id) {
                    if (this.cartModel.cartArray[i].qty !== parseInt(qty)) {
                        updateLink.addClass(CLASSES.ICON_LINK_ATTENTION);
                        setTimeout(function () {
                            _this.$ariaUpdate.text(NOTIFICATIONS.UPDATE_QUANTITY_PROMPT);
                        }, 250);
                    } else {
                        updateLink.removeClass(CLASSES.ICON_LINK_ATTENTION);
                    }
                }
            }

            return this;
        }
    }, {
        key: 'onQuantityKeydown',
        value: function onQuantityKeydown(event) {
            if (event && event.originalEvent && event.originalEvent.key && event.originalEvent.key.toLowerCase() === "enter") {
                var id = event.target.dataset.productId;
                var updateLinks = this.$updateLinks.filter('[data-product-id="' + id + '"]');
                if (updateLinks && updateLinks.length > 0) {
                    /* set the event target to the update link element corresponding to the updated product 
                        to ensure proper update behavior */
                    event.target = updateLinks[0];
                    this.onUpdateClick(event);
                }
            }
        }
    }, {
        key: 'onUpdateClick',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
                var _this2 = this;

                var updateObject, $productTitle, inputValue, response, updateLink;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                /* Adds overlay and spins item refresh icon */
                                (0, _jquery2.default)(event.target).addClass(_classes.LOADING_CLASS);
                                setTimeout(function () {
                                    _this2.$ariaUpdate.text(NOTIFICATIONS.CART_BUSY);
                                }, 250);

                                updateObject = this._createUpdateObject(event);
                                $productTitle = this._getProductTitle(updateObject.productId);
                                inputValue = this.$quantityInputs.filter('[data-product-id="' + updateObject.productId + '"]')[0].value;

                                updateObject.qty = parseInt(inputValue);

                                if (!isNaN(updateObject.qty)) {
                                    _context.next = 9;
                                    break;
                                }

                                this._showInvalidQuantityError(event, updateObject.productId, $productTitle);
                                return _context.abrupt('return');

                            case 9:
                                if (!(updateObject.qty === 0)) {
                                    _context.next = 13;
                                    break;
                                }

                                this._clearLoadingMessages(event);
                                this.onItemRemovalHandler(event);
                                return _context.abrupt('return');

                            case 13:
                                if (!(updateObject.qty > VALUES.MAX_CART_ITEM_QTY)) {
                                    _context.next = 16;
                                    break;
                                }

                                this._showMaxQtyError(event, updateObject.productId, $productTitle);
                                return _context.abrupt('return');

                            case 16:

                                this.notifications.resetMessages();
                                _context.prev = 17;
                                _context.next = 20;
                                return this.cartService.updateCart(updateObject);

                            case 20:
                                response = _context.sent;

                                if (!(!response.success && response.statuscode == 500)) {
                                    _context.next = 23;
                                    break;
                                }

                                return _context.abrupt('return', this.notifications.showErrorNotification(response.error, _classes.ALERT_MESSAGE_CLASS));

                            case 23:
                                this.updateNavigationView(updateObject.productId, updateObject.qty);
                                this.cartModel.updateCartArray(updateObject);

                                this.updateSubtotal(response.updatedCart.SubTotal);
                                this.updateDiscountTotal(response.updatedCart.DiscountTotal);
                                this.updateCartTotal(response.updatedCart.TotalQty);

                                updateLink = this.$updateLinks.filter('[data-product-id="' + updateObject.productId + '"]');

                                updateLink.removeClass(CLASSES.ICON_LINK_ATTENTION);

                                this.hideExistingErrorOrNot();
                                if (!response.success) {
                                    /* for other 200 non-success states (example: only certain number of products available) */
                                    this.notifications.showErrorNotification(response.error, _classes.ERROR_MESSAGE_CLASS);
                                    this.$quantityInputs.filter('[data-product-id="' + updateObject.productId + '"]')[0].value = response.qtyAdded;
                                }
                                setTimeout(function () {
                                    _this2.$ariaUpdate.text($productTitle + ': ' + NOTIFICATIONS.QTY_UPDATED + ' ' + _this2._provideCartTotalsUpdate());
                                }, 500);

                                (0, _jquery2.default)(event.target).removeClass(_classes.LOADING_CLASS);
                                _context.next = 39;
                                break;

                            case 36:
                                _context.prev = 36;
                                _context.t0 = _context['catch'](17);

                                setTimeout(function () {
                                    _this2._clearLoadingMessages(event);
                                    _this2.notifications.showErrorNotification(NOTIFICATIONS.FETCH_FAILED, _classes.ALERT_MESSAGE_CLASS);
                                }, 500);

                            case 39:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[17, 36]]);
            }));

            function onUpdateClick(_x) {
                return _ref.apply(this, arguments);
            }

            return onUpdateClick;
        }()
    }, {
        key: '_createUpdateObject',
        value: function _createUpdateObject(event) {
            var id = event.target.dataset.productId;
            var $cartItem = this.$cartItems.filter('[id="' + id + '"]');
            var productCode = $cartItem.find(SELECTORS.ITEM_UNDO_REMOVAL_LINK)[0].dataset.productCode;
            // group number can change if item is removed & re-added to the cart, so we need to use the cart model value
            var entryGroupNumber = this.findPropById(id, this.cartModel.cartArray, 'entryGroupNumber');
            var updateObject = {
                productId: id,
                productCode: productCode,
                entryGroupNumber: entryGroupNumber
            };
            return updateObject;
        }
    }, {
        key: '_getProductTitle',
        value: function _getProductTitle(id) {
            var cartItems = this.$cartItems.filter('[id="' + id + '"]').find(SELECTORS.PRODUCT_TITLE);
            if (cartItems.length > 1) {
                var items = (0, _from2.default)(cartItems);
                var titles = items.map(function (item) {
                    return item.text;
                });
                return titles.join(' w/ ');
            }
            return cartItems.text();
        }
    }, {
        key: '_provideCartTotalsUpdate',
        value: function _provideCartTotalsUpdate() {
            var discountLabel = this.$discountsLabel.text();
            var discounts = this.ariaDiscounts;
            var subtotalLabel = this.$subtotalLabel.text();
            var subtotal = this.ariaSubtotal;
            var cartCountLabel = this.$cartCountLabel.text();
            var cartCount = this.ariaCartCount;
            var status = cartCountLabel + ' ' + cartCount + ', ' + subtotalLabel + ': ' + subtotal + ', ' + discountLabel + ': ' + discounts;

            return status;
        }
    }, {
        key: 'hideExistingErrorOrNot',
        value: function hideExistingErrorOrNot() {
            var arrayOfChangedItems = this.getUnsavedItemChanges();
            if (arrayOfChangedItems.length) {
                var templateData = {
                    notificationMessage: NOTIFICATIONS.FORGOT_TO_SAVE,
                    product: arrayOfChangedItems
                };
                this.notifications.showErrorNotification((0, _cartItemErrors2.default)(templateData));
                return;
            }

            this.notifications.resetMessages();
        }
    }, {
        key: '_showMaxQtyError',
        value: function _showMaxQtyError(event, id, $productTitle) {
            var errorItem = {};
            errorItem.id = id;
            errorItem.title = $productTitle;
            var errorsArray = [];
            errorsArray.push(errorItem);

            var templateData = {
                notificationMessage: NOTIFICATIONS.MAX_QTY_ERROR,
                product: errorsArray
            };

            this.notifications.showErrorNotification((0, _cartItemErrors2.default)(templateData), _classes.ERROR_MESSAGE_CLASS);
            this._clearLoadingMessages(event);
        }
    }, {
        key: '_showInvalidQuantityError',
        value: function _showInvalidQuantityError(event, id, $productTitle) {
            var _this3 = this;

            var errorItem = {};
            errorItem.id = id;
            errorItem.title = $productTitle;
            var errorsArray = [];
            errorsArray.push(errorItem);

            var templateData = {
                notificationMessage: NOTIFICATIONS.EMPTY_STRING,
                product: errorsArray
            };

            this.notifications.showErrorNotification((0, _cartItemErrors2.default)(templateData), _classes.ERROR_MESSAGE_CLASS);
            (0, _jquery2.default)(event.target).removeClass(_classes.LOADING_CLASS);
            setTimeout(function () {
                _this3.$ariaUpdate.text(NOTIFICATIONS.CART_BUSY);
            }, 250);
        }
    }, {
        key: '_clearLoadingMessages',
        value: function _clearLoadingMessages(event) {
            (0, _jquery2.default)(event.target).removeClass(_classes.LOADING_CLASS);
            this.$ariaUpdate.text('');
        }
    }, {
        key: 'onItemRemoval',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
                var _this4 = this;

                var updateObject, $productTitle, $cartItem, undoRemovalLink, updateLink, prevObject, response;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                updateObject = this._createUpdateObject(event);
                                $productTitle = this._getProductTitle(updateObject.productId);
                                $cartItem = this.$cartItems.filter('[id="' + updateObject.productId + '"]');
                                undoRemovalLink = $cartItem.find(SELECTORS.ITEM_UNDO_REMOVAL_LINK)[0];
                                updateLink = this.$updateLinks.filter('[data-product-id="' + updateObject.productId + '"]');
                                prevObject = {
                                    id: updateObject.productId,
                                    qty: this.findPropById(updateObject.productId, this.cartModel.cartArray, 'qty')
                                };

                                updateObject.qty = 0;

                                updateLink.addClass(_classes.LOADING_CLASS);
                                setTimeout(function () {
                                    _this4.$ariaUpdate.text(NOTIFICATIONS.CART_BUSY);
                                }, 250);

                                _context2.prev = 9;
                                _context2.next = 12;
                                return this.cartService.updateCart(updateObject);

                            case 12:
                                response = _context2.sent;

                                if (!(!response.success && response.statuscode == 500)) {
                                    _context2.next = 15;
                                    break;
                                }

                                return _context2.abrupt('return', this.notifications.showErrorNotification(response.error, _classes.ALERT_MESSAGE_CLASS));

                            case 15:

                                this.updateNavigationView(updateObject.productId, 0);
                                this.cartModel.updateCartArray(updateObject);

                                $cartItem.addClass(CLASSES.REMOVED_ITEM_CLASS);
                                $cartItem.find(SELECTORS.MSG_DISPLAY).addClass(_classes.IS_HIDDEN);

                                this.createDynamicChildren();
                                this.cartModel.addToRemovedItemArray(prevObject);

                                this.updateSubtotal(response.updatedCart.SubTotal);
                                this.updateDiscountTotal(response.updatedCart.DiscountTotal);
                                this.updateCartTotal(response.updatedCart.TotalQty);
                                updateLink.removeClass(CLASSES.ICON_LINK_ATTENTION);
                                this.hideExistingErrorOrNot();
                                updateLink.removeClass(_classes.LOADING_CLASS);
                                setTimeout(function () {
                                    undoRemovalLink.focus();
                                }, 500);
                                setTimeout(function () {
                                    _this4.$ariaUpdate.text($productTitle + ': ' + NOTIFICATIONS.ITEM_REMOVED + ' ' + _this4._provideCartTotalsUpdate());
                                }, 1000);
                                _context2.next = 34;
                                break;

                            case 31:
                                _context2.prev = 31;
                                _context2.t0 = _context2['catch'](9);

                                setTimeout(function () {
                                    _this4._clearLoadingMessages(event);
                                    _this4.notifications.showErrorNotification(NOTIFICATIONS.FETCH_FAILED, _classes.ALERT_MESSAGE_CLASS);
                                    _this4.createDynamicChildren();
                                }, 500);

                            case 34:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[9, 31]]);
            }));

            function onItemRemoval(_x2) {
                return _ref2.apply(this, arguments);
            }

            return onItemRemoval;
        }()
    }, {
        key: 'findPropById',
        value: function findPropById(id, array, prop) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].id == id) {
                    return array[i][prop];
                }
            }
        }
    }, {
        key: 'onUndoRemoval',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(event) {
                var _this5 = this;

                var updateObject, $productTitle, accessoryCode, response, updatedEntry, $cartItem, quantityInput;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                (0, _jquery2.default)(event.target).addClass(_classes.LOADING_CLASS);
                                setTimeout(function () {
                                    _this5.$ariaUpdate.text(NOTIFICATIONS.CART_BUSY);
                                }, 250);

                                updateObject = this._createUpdateObject(event);
                                $productTitle = this._getProductTitle(updateObject.productId);
                                accessoryCode = event.target.dataset.accessoryCode;

                                if (accessoryCode !== "") {
                                    updateObject.accessoryCode = accessoryCode;
                                }
                                updateObject.qty = this.findPropById(updateObject.productId, this.cartModel.removedItemArray, 'qty');

                                _context3.prev = 7;
                                _context3.next = 10;
                                return this.cartService.addToCart(updateObject);

                            case 10:
                                response = _context3.sent;

                                if (!(!response.success && response.statuscode == 500)) {
                                    _context3.next = 13;
                                    break;
                                }

                                return _context3.abrupt('return', this.notifications.showErrorNotification(response.error, _classes.ALERT_MESSAGE_CLASS));

                            case 13:

                                (0, _jquery2.default)(event.target).removeClass(_classes.LOADING_CLASS);

                                this.updateNavigationView(updateObject.productId, updateObject.qty);

                                // Capture the new entry group number to be used with subsequent updates
                                updatedEntry = response.response.Entries.find(function (entry) {
                                    if (entry.Product.ProductCode == updateObject.productCode && (accessoryCode && entry.HasProductReference && entry.Product.ProductReference.ProductCode == accessoryCode || !accessoryCode && !entry.HasProductReference)) return entry;
                                });

                                if (updatedEntry) {
                                    updateObject.entryGroupNumber = updatedEntry.EntryGroupNumbers[0];
                                }

                                this.cartModel.updateCartArray(updateObject);

                                $cartItem = this.$cartItems.filter('[id="' + updateObject.productId + '"]');

                                $cartItem.removeClass(CLASSES.REMOVED_ITEM_CLASS);
                                $cartItem.find(SELECTORS.MSG_DISPLAY).removeClass(_classes.IS_HIDDEN);
                                this.createDynamicChildren();

                                this.cartModel.locateAndRemoveUndoItem(updateObject);
                                this.cartModel.updateTrackingArray(updateObject.productId, updateObject.qty);

                                this.updateSubtotal(response.response.SubTotal);
                                this.updateDiscountTotal(response.response.DiscountTotal);
                                this.updateCartTotal(response.response.TotalQty);
                                this.hideExistingErrorOrNot();

                                quantityInput = this.$quantityInputs.filter('[data-product-id="' + updateObject.productId + '"]')[0];

                                if (!response.success) {
                                    /* partial success where quantity added is less than requested */
                                    this.notifications.showErrorNotification(response.error, _classes.ERROR_MESSAGE_CLASS);
                                    quantityInput.value = response.qtyAdded;
                                } else {
                                    quantityInput.value = updateObject.qty;
                                }

                                setTimeout(function () {
                                    _this5.$ariaUpdate.text($productTitle + ': ' + NOTIFICATIONS.ITEM_UNDO_REMOVAL + ' ' + _this5._provideCartTotalsUpdate());
                                }, 500);
                                _context3.next = 36;
                                break;

                            case 33:
                                _context3.prev = 33;
                                _context3.t0 = _context3['catch'](7);

                                setTimeout(function () {
                                    _this5.notifications.showErrorNotification(NOTIFICATIONS.FETCH_FAILED, _classes.ALERT_MESSAGE_CLASS);
                                    _this5._clearLoadingMessages(event);
                                    _this5.createDynamicChildren();
                                }, 500);

                            case 36:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[7, 33]]);
            }));

            function onUndoRemoval(_x3) {
                return _ref3.apply(this, arguments);
            }

            return onUndoRemoval;
        }()
    }, {
        key: 'onCheckoutClick',
        value: function onCheckoutClick(e) {
            /* Preventing default link behavior in order to do our cart checks before manually sending user to checkout */
            e.preventDefault();
            var href = e.target.href;
            if (this.cartIsEmpty()) {
                console.info('cart is empty');
                this.notifications.showErrorNotification(NOTIFICATIONS.EMPTY_CART);
                return;
            }

            var arrayOfChangedItems = this.getUnsavedItemChanges();
            if (arrayOfChangedItems.length) {
                var templateData = {
                    notificationMessage: NOTIFICATIONS.FORGOT_TO_SAVE,
                    product: arrayOfChangedItems
                };
                this.notifications.showErrorNotification((0, _cartItemErrors2.default)(templateData));
                console.info('there are changed items, ', arrayOfChangedItems);
                return;
            }
            (0, _jquery2.default)(e.currentTarget).addClass(_classes.LOADING_CLASS);
            this.cartData.SubTotal = this.$subtotal.text();
            this.trackingService.beginCheckout(this.cartData);
            window.location = href;
        }
    }, {
        key: 'getUnsavedItemChanges',
        value: function getUnsavedItemChanges() {
            var changedItems = [];
            for (var i = 0; i < this.cartModel.changeTrackingArray.length; i++) {
                var unsavedArray = this.cartModel.changeTrackingArray;
                var savedArray = this.cartModel.cartArray;

                if (this.cartModel.removedItemArray.length) {
                    /* Skip iteration if item was removed by user */
                    var skipThisLoop = false;
                    for (var j = 0; j < this.cartModel.removedItemArray.length; j++) {
                        if (this.cartModel.removedItemArray[j].id === unsavedArray[i].id) {
                            skipThisLoop = true;
                        }
                    }
                    if (skipThisLoop) {
                        continue;
                    }
                }

                if (unsavedArray[i].qty !== savedArray[i].qty) {
                    var prodTitle = this.$activeCartItems.filter('[id=' + savedArray[i].id + ']').find(SELECTORS.PRODUCT_TITLE).text();
                    var item = {};
                    item.id = savedArray[i].id;
                    item.title = prodTitle;
                    changedItems.push(item);
                }
            }
            return changedItems;
        }
    }, {
        key: 'updateSubtotal',
        value: function updateSubtotal(val) {
            this.$subtotal.text(val);
            this.ariaSubtotal = val;
            return this;
        }
    }, {
        key: 'updateDiscountTotal',
        value: function updateDiscountTotal(val) {
            this.$discountTotal.text(val);
            this.ariaDiscounts = val;
            return this;
        }
    }, {
        key: 'cartIsEmpty',
        value: function cartIsEmpty() {
            if (this.cartModel.cartArray.length === this.cartModel.removedItemArray.length) {
                return true;
            }
            return false;
        }
    }, {
        key: 'updateNavigationView',
        value: function updateNavigationView(id, newQuantity) {
            var cartDataObject = this.cartData.Entries.filter(function (entry) {
                return entry.CartItemId == id;
            })[0];

            if (cartDataObject) {
                var curQuantity = cartDataObject.Product.ProductQuantity;

                if (curQuantity < newQuantity) {
                    cartDataObject.Product.ProductQuantity = newQuantity - curQuantity;
                    this.trackingService.addToCart(cartDataObject.Product);
                }

                if (curQuantity > newQuantity) {
                    cartDataObject.Product.ProductQuantity = curQuantity - newQuantity;
                    this.trackingService.removeFromCart(cartDataObject.Product);
                }
                cartDataObject.Product.ProductQuantity = newQuantity;
            }
        }
    }, {
        key: 'updateCartTotal',
        value: function updateCartTotal(TotalQty) {
            this.$cartCount.text(TotalQty);
            this.ariaCartCount = TotalQty;
            return this;
        }
    }, {
        key: 'onCartShare',
        value: function onCartShare(e) {
            this.$cartShareModal.removeClass(_classes.IS_HIDDEN);
        }
    }, {
        key: 'onCartShareCopyLink',
        value: function () {
            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(e) {
                var response;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.$cartShareCopyUrlLink.addClass(_classes.LOADING_CLASS);

                                _context4.prev = 1;
                                _context4.next = 4;
                                return this.cartService.getSharedCartUrl();

                            case 4:
                                response = _context4.sent;

                                if (!response.success) {
                                    _context4.next = 11;
                                    break;
                                }

                                this.$cartShareUrlInput[0].value = response.url;
                                _context4.next = 9;
                                return this.copyShareLinkToClipboard(response.url);

                            case 9:
                                _context4.next = 12;
                                break;

                            case 11:
                                this.notifications.showErrorNotification(response.error, _classes.ALERT_MESSAGE_CLASS);

                            case 12:
                                _context4.prev = 12;

                                this.$cartShareCopyUrlLink.removeClass(_classes.LOADING_CLASS);
                                return _context4.finish(12);

                            case 15:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[1,, 12, 15]]);
            }));

            function onCartShareCopyLink(_x4) {
                return _ref4.apply(this, arguments);
            }

            return onCartShareCopyLink;
        }()
    }, {
        key: 'copyShareLinkToClipboard',
        value: function () {
            var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(url) {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!navigator.clipboard) {
                                    _context5.next = 13;
                                    break;
                                }

                                _context5.prev = 1;
                                _context5.next = 4;
                                return navigator.clipboard.writeText(url);

                            case 4:
                                this.notifications.showErrorNotification('Link copied to clipboard!', _classes.SUCCESS_MESSAGE_CLASS);
                                this.hideCartShareModal();
                                _context5.next = 11;
                                break;

                            case 8:
                                _context5.prev = 8;
                                _context5.t0 = _context5['catch'](1);

                                this.showCartShareUrl(_context5.t0);

                            case 11:
                                _context5.next = 14;
                                break;

                            case 13:
                                this.showCartShareUrl();

                            case 14:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[1, 8]]);
            }));

            function copyShareLinkToClipboard(_x5) {
                return _ref5.apply(this, arguments);
            }

            return copyShareLinkToClipboard;
        }()
    }, {
        key: 'hideCartShareModal',
        value: function hideCartShareModal() {
            this.$cartShareModal.addClass(_classes.IS_HIDDEN);
        }
    }, {
        key: 'showCartShareUrl',
        value: function showCartShareUrl(ex) {
            this.$cartShareUrlModal.removeClass(_classes.IS_HIDDEN);
            this.notifications.showErrorNotification('Could not copy link to clipboard.', _classes.ALERT_MESSAGE_CLASS);
        }
    }, {
        key: 'onCartShareSendEmail',
        value: function () {
            var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(e) {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                this.$cartShareEmailModal.removeClass(_classes.IS_HIDDEN);
                                this.hideCartShareModal();

                            case 2:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function onCartShareSendEmail(_x6) {
                return _ref6.apply(this, arguments);
            }

            return onCartShareSendEmail;
        }()
    }, {
        key: 'onCartShareSendEmailClose',
        value: function onCartShareSendEmailClose(e) {
            this.hideCartShareEmailModal();
        }
    }, {
        key: 'hideCartShareEmailModal',
        value: function hideCartShareEmailModal() {
            this.$cartShareEmailModal.addClass(_classes.IS_HIDDEN);
        }
    }, {
        key: 'onCartShareSendEmailSubmit',
        value: function () {
            var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(e) {
                var recipientEmail, senderName, senderEmail, messageBody, shareObject, response;
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                recipientEmail = this.$cartShareEmailRecipientEmail[0].value;
                                senderName = this.$cartShareEmailSenderName[0].value;
                                senderEmail = this.$cartShareEmalSenderEmail[0].value;
                                messageBody = this.$cartShareEmailMessageBody[0].value;

                                if (!(!recipientEmail || !senderName || !senderEmail)) {
                                    _context7.next = 7;
                                    break;
                                }

                                this.notifications.showErrorNotification('Please enter all required values.', _classes.ALERT_MESSAGE_CLASS);
                                return _context7.abrupt('return');

                            case 7:

                                this.$cartShareEmailSendButton.addClass(_classes.LOADING_CLASS);
                                shareObject = {
                                    recipientEmail: recipientEmail,
                                    senderName: senderName,
                                    senderEmail: senderEmail,
                                    messageBody: messageBody
                                };
                                _context7.prev = 9;
                                _context7.next = 12;
                                return this.cartService.sendSharedCartEmail(shareObject);

                            case 12:
                                response = _context7.sent;

                                if (response.success) {
                                    this.notifications.showErrorNotification('Email sent!', _classes.SUCCESS_MESSAGE_CLASS);
                                    this.hideCartShareEmailModal();
                                    this.$cartShareEmailRecipientEmail[0].value = '';
                                } else {
                                    this.notifications.showErrorNotification(response.error, _classes.ALERT_MESSAGE_CLASS);
                                }

                            case 14:
                                _context7.prev = 14;

                                this.$cartShareEmailSendButton.removeClass(_classes.LOADING_CLASS);
                                return _context7.finish(14);

                            case 17:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this, [[9,, 14, 17]]);
            }));

            function onCartShareSendEmailSubmit(_x7) {
                return _ref7.apply(this, arguments);
            }

            return onCartShareSendEmailSubmit;
        }()
    }, {
        key: 'onClickOut',
        value: function onClickOut(e) {
            if (!this.isClickTarget(e.target, SELECTORS.CART_SHARE_MODAL) && !this.isClickTarget(e.target, SELECTORS.CART_SHARE_LINK)) {
                this.hideCartShareModal(e);
            }

            if (!this.isClickTarget(e.target, SELECTORS.CART_SHARE_URL_MODAL) && !this.isClickTarget(e.target, SELECTORS.CART_SHARE_COPY_URL)) {
                this.$cartShareUrlModal.addClass(_classes.IS_HIDDEN);
            }

            if (!this.isClickTarget(e.target, SELECTORS.CART_SHARE_EMAIL_MODAL) && !this.isClickTarget(e.target, SELECTORS.CART_SHARE_SEND_EMAIL)) {
                this.hideCartShareEmailModal();
            }
        }
    }, {
        key: 'isClickTarget',
        value: function isClickTarget(target, selector) {
            return (0, _jquery2.default)(target).closest(selector).length;
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.$quantityInputs.on('change input', this.onQuantityChangeHandler);
            this.$quantityInputs.on('keydown', this.onQuantityKeydownHandler);
            this.$updateLinks.on('click', this.onUpdateClickHandler);
            this.$itemRemovalLinks.on('click', this.onItemRemovalHandler);
            this.$undoRemovalLinks.on('click', this.onUndoRemovalHandler);
            this.$checkout.on('click', this.onCheckoutClickHandler);
            this.$cartShareLink.on('click', this.onCartShareHandler);
            this.$cartShareCopyUrlLink.on('click', this.onCartShareCopyLinkHandler);
            this.$cartShareSendEmailLink.on('click', this.onCartShareSendEmailHandler);
            this.$cartShareEmailCloseButton.on('click', this.onCartShareSendEmailCloseHandler);
            this.$cartShareEmailSendButton.on('click', this.onCartShareSendEmailSubmitHandler);
            (0, _jquery2.default)('html').on('click', this.onClickOutHandler);
            return this;
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.$quantityInputs.off('change input', this.onQuantityChangeHandler);
            this.$quantityInputs.off('keydown', this.onQuantityKeydownHandler);
            this.$updateLinks.off('click', this.onUpdateClickHandler);
            this.$itemRemovalLinks.off('click', this.onItemRemovalHandler);
            this.$undoRemovalLinks.off('click', this.onUndoRemovalHandler);
            this.$checkout.off('click', this.onCheckoutClickHandler);
            this.$cartShareLink.off('click', this.onCartShareHandler);
            this.$cartShareCopyUrlLink.off('click', this.onCartShareCopyLinkHandler);
            this.$cartShareSendEmailLink.off('click', this.onCartShareSendEmailHandler);
            this.$cartShareEmailCloseButton.off('click', this.onCartShareSendEmailCloseHandler);
            this.$cartShareEmailSendButton.off('click', this.onCartShareSendEmailSubmitHandler);
            (0, _jquery2.default)('html').off('click', this.onClickOutHandler);
            return this;
        }
    }]);
    return CartView;
}();

exports.default = CartView;

},{"../constants/classes":169,"../global/Notifications":174,"../services/TrackingService":182,"../templates/cartItemErrors.hbs":184,"babel-runtime/core-js/array/from":1,"babel-runtime/helpers/asyncToGenerator":14,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"babel-runtime/regenerator":21,"jquery":"jquery"}],192:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {
    PARENT: '.js-checkBoxDependencies-parent',
    CHILD: '.js-checkBoxDependencies-child',
    MESSAGE_UPDATE: '.js-checkBoxDependencies-child-update'
};

// const MESSAGES = {
//     AUTO_CHECKING: ': checking this checkbox has automatically checked and disabled the following checkboxes: ',
//     AUTO_UNCHECKING: ': unchecking this checkbox has automatically re-enabled the following checkboxes: '
// }

/**
 * Checks and disables dependent checkbox 
 * fields when the parent is clicked.
 *
 * @class CheckboxDependenciesView
 * @constructor
 */

var CheckboxDependenciesView = function () {
    function CheckboxDependenciesView($element) {
        (0, _classCallCheck3.default)(this, CheckboxDependenciesView);

        this.$element = $element;
        return this.setupHandlers().createChildren().enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */


    (0, _createClass3.default)(CheckboxDependenciesView, [{
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onParentClickHandler = this.onParentClick.bind(this);
            return this;
        }

        /**
         * createChildren
         *
         * @method createChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$parent = this.$element.find(SELECTORS.PARENT);
            this.$children = this.$element.find(SELECTORS.CHILD);
            this.$screenReaderUpdate = this.$element.find(SELECTORS.MESSAGE_UPDATE);
            return this;
        }

        /**
         * Automatically checks child checkboxes
         * when a user clicks parent checkbox
         *
         * @method onParentClick
         * @public
         * @chainable
         */

    }, {
        key: 'onParentClick',
        value: function onParentClick(e) {
            var _this = this;

            var childFieldLabels = '';
            if (this.$parent[0].checked) {

                for (var i = 0; i < this.$children.length; i++) {
                    this.$children[i].checked = true;
                    this.$children[i].setAttribute('onclick', 'return false');
                    this.$children[i].setAttribute('readonly', '');
                    this.$children[i].setAttribute('aria-disabled', 'true');
                    childFieldLabels += this.$children[i].labels[0].innerText + ', ';
                }
                var updateText = this.$parent[0].labels[0].innerText + MESSAGES.AUTO_CHECKING + childFieldLabels;
                setTimeout(function () {
                    _this.$screenReaderUpdate.text(updateText);
                }, 500);
            } else {
                for (var _i = 0; _i < this.$children.length; _i++) {
                    this.$children[_i].removeAttribute('onclick');
                    this.$children[_i].removeAttribute('readonly');
                    this.$children[_i].removeAttribute('aria-disabled');
                    childFieldLabels += this.$children[_i].labels[0].innerText + ', ';
                }
                var _updateText = this.$parent[0].labels[0].innerText + MESSAGES.AUTO_UNCHECKING + childFieldLabels;
                setTimeout(function () {
                    _this.$screenReaderUpdate.text(_updateText);
                }, 500);
            }

            return this;
        }

        /**
         * Enable
         *
         * @method enable
         * @public
         * @chainable
         */

    }, {
        key: 'enable',
        value: function enable() {
            this.$parent.on('click', this.onParentClickHandler);
            return this;
        }

        /**
         * Disable
         *
         * @method disable
         * @public
         * @chainable
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.$parent.off('click', this.onParentClickHandler);
            return this;
        }
    }]);
    return CheckboxDependenciesView;
}();

exports.default = CheckboxDependenciesView;

},{"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],193:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTORS = {
    SITE_CONTACT_FORM: '.site-contact-details-form',
    LOADING_DOC_RADIOS: '.onsite-radio',
    UNLOADING_TEXTAREA: '.unloadingRequirement-block'
};

var CheckoutInfoView = function () {
    function CheckoutInfoView($element) {
        (0, _classCallCheck3.default)(this, CheckoutInfoView);

        console.log($element, 'checkout info loaded');
        this.$element = $element;
        return this.setupHandlers().createChildren().enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */


    (0, _createClass3.default)(CheckoutInfoView, [{
        key: 'setupHandlers',
        value: function setupHandlers() {
            // this.onPlaceOrderSubmitHandler = this.siteDetailsFormSubmit.bind(this);
            this.loadingDockHandler = this.loadingDockCheck.bind(this);
            return this;
        }

        /**
         * createChildren
         *
         * @method createChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$siteContactForm = this.$element.find(SELECTORS.SITE_CONTACT_FORM);
            this.$onsiteRadioButtons = this.$element.find(SELECTORS.LOADING_DOC_RADIOS);
            this.$unloadingInput = this.$element.find(SELECTORS.UNLOADING_TEXTAREA);
            return this;
        }
        /**
         * Enable
         *
         * @method enable
         * @public
         * @chainable
         */

    }, {
        key: 'enable',
        value: function enable() {
            var _this = this;

            this.$onsiteRadioButtons.on('click', function (e) {
                return _this.loadingDockHandler(e.target.value);
            });
            this.$onsiteRadioButtons.each(function (index, radio) {
                if (radio.checked) {
                    _this.loadingDockCheck(radio.value);
                }
            });
            return this;
        }
    }, {
        key: 'loadingDockCheck',
        value: function loadingDockCheck(dock) {
            console.log(dock);
            if (dock && dock === 'false') {
                this.$unloadingInput[0].classList.remove('u-displayNone');
                this.$unloadingInput[0].querySelector('textarea').setAttribute("required", "true");
            } else if (dock && dock === 'true') {
                this.$unloadingInput[0].querySelector('textarea').removeAttribute("required");
                this.$unloadingInput[0].classList.add('u-displayNone');
            }
        }
    }]);
    return CheckoutInfoView;
}();

exports.default = CheckoutInfoView;

},{"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],194:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _TrackingService = require('../services/TrackingService');

var _TrackingService2 = _interopRequireDefault(_TrackingService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {
    CART_DATA_VARIABLE: 'js_userCart',
    ORDER_DATA_VARIABLE: 'js_orderInformation',
    PRODUCT_DETAIL_LINK: 'js-orderConfirmation'
};

var PATHS = {
    ADD_PAYMENT_INFO: '/checkout/payment/add-payment',
    ADD_SHIPPING_INFO: '/checkout/delivery-address/add-address',
    ORDER_CONFIRMATION: '/checkout/summary'
};

/**
 * 
 * @constructor
 */

var CheckoutTracking = function () {
    function CheckoutTracking($element) {
        (0, _classCallCheck3.default)(this, CheckoutTracking);

        this.$element = $element;
        this.cartData = window[SELECTORS.CART_DATA_VARIABLE];
        this.orderData = window[SELECTORS.ORDER_DATA_VARIABLE];
        this.trackingService = new _TrackingService2.default();

        return this.checkPageTracking();
    }

    (0, _createClass3.default)(CheckoutTracking, [{
        key: 'checkPageTracking',
        value: function checkPageTracking() {
            // check page urls - need specific events for the following:
            // add_payment_info -> /checkout/payment/add-payment
            // add_shipping_info -> /checkout/delivery-address/add-address
            // purchase -> /checkout/summary (order-specific information)
            var curPagePath = window.location.pathname;
            if (curPagePath.indexOf(PATHS.ADD_PAYMENT_INFO) > -1) {
                this.trackingService.addPaymentInfo(this.cartData);
            }
            if (curPagePath.indexOf(PATHS.ADD_SHIPPING_INFO) > -1) {
                this.trackingService.addShippingInfo(this.cartData);
            }
            if (curPagePath.indexOf(PATHS.ORDER_CONFIRMATION) > -1) {
                this.trackingService.purchase(this.orderData);
                this.trackingService.adsConversion(this.orderData, "AW-830898396/ThLpCNeIk-sYENyBmowD");
            }
            return this;
        }
    }]);
    return CheckoutTracking;
}();

exports.default = CheckoutTracking;

},{"../services/TrackingService":182,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16}],195:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _classes = require('../constants/classes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {
    PAGE_CONTENT: '.site-bd',
    FORM: '.js-chooseAddressView-form',
    PROCEED_CTA: '.js-chooseAddressView-proceed',
    ADDRESS_OPTION_CHECKBOX: '.js-chooseAddressView-option',
    ADDRESS_OPTION_INFO: '.js-chooseAddressView-optionInfo',
    ADDRESS_OPTION_INFO_ADDRESS: '.js-chooseAddressView-optionInfo-address1',
    ADDRESS_OPTION_INFO_ADDRESS_2: '.js-chooseAddressView-optionInfo-address2',
    ADDRESS_OPTION_INFO_CITY: '.js-chooseAddressView-optionInfo-city',
    ADDRESS_OPTION_INFO_STATE: '.js-chooseAddressView-optionInfo-state',
    ADDRESS_OPTION_INFO_POSTAL_CODE: '.js-chooseAddressView-optionInfo-postalCode',

    /* The above are selectors that contain values which will populate the fields that are represented by these selectors below */
    ADDRESS_FIELD_ADDRESS_1: '.js-chooseAddressView-field-address1',
    ADDRESS_FIELD_ADDRESS_2: '.js-chooseAddressView-field-address2',
    ADDRESS_FIELD_CITY: '.js-chooseAddressView-field-city',
    ADDRESS_FIELD_STATE: '.js-chooseAddressView-field-state',
    ADDRESS_FIELD_POSTAL_CODE: '.js-chooseAddressView-field-postalCode'
};

/**
 * Queries address selections presented to the user
 * and then populates their form with the values within
 * the option they choose, then allowing them to submit
 * the form with those values.
 *
 * @class ChooseAddressView
 * @constructor
 */

var ChooseAddressView = function () {
    function ChooseAddressView($element) {
        (0, _classCallCheck3.default)(this, ChooseAddressView);

        this.$element = $element;
        return this.setupHandlers().createChildren().layout().enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */


    (0, _createClass3.default)(ChooseAddressView, [{
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onPickedAddressHandler = this.onPickedAddress.bind(this);
            this.onProceedClickHandler = this.onProceedClick.bind(this);
            return this;
        }

        /**
         * createChildren
         *
         * @method createChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$pageContent = (0, _jquery2.default)(SELECTORS.PAGE_CONTENT);
            this.$form = this.$pageContent.find(SELECTORS.FORM);
            this.$proceedCta = this.$pageContent.find(SELECTORS.PROCEED_CTA);
            this.$addressOptionCheckbox = this.$element.find(SELECTORS.ADDRESS_OPTION_CHECKBOX);
            this.$addressOptionInfo = this.$element.find(SELECTORS.ADDRESS_OPTION_INFO);
            this.$addressFieldName = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_NAME);
            this.$addressFieldAddress1 = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_ADDRESS_1);
            this.$addressFieldAddress2 = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_ADDRESS_2);
            this.$addressFieldCity = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_CITY);
            this.$addressFieldState = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_STATE);
            this.$addressFieldPostalCode = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_POSTAL_CODE);

            return this;
        }

        /**
         * Does any scripts on load
         *
         * @method layout()
         * @public
         * @chainable
         */

    }, {
        key: 'layout',
        value: function layout() {
            this.$element.focus();
            return this;
        }

        /**
         * Grabs the values from the presented
         * address options
         *
         * @method onPickedAddress
         * @public
         * @chainable
         */

    }, {
        key: 'onPickedAddress',
        value: function onPickedAddress(e) {
            var $target = e.currentTarget.nextElementSibling;
            /* Retrieves values from suggested address */
            var $address1 = (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_ADDRESS)[0] !== undefined ? (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_ADDRESS)[0].innerText : false;
            var $address2 = (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_ADDRESS_2)[0] !== undefined ? (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_ADDRESS_2)[0].innerText : false;
            var $city = (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_CITY)[0] !== undefined ? (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_CITY)[0].innerText : false;
            var $state = (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_STATE)[0] !== undefined ? (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_STATE)[0].innerText : false;
            var $postalCode = (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_POSTAL_CODE)[0] !== undefined ? (0, _jquery2.default)($target).find(SELECTORS.ADDRESS_OPTION_INFO_POSTAL_CODE)[0].innerText : false;

            this._updateAddressFields($address1, $address2, $city, $state, $postalCode);
            this.$proceedCta.show();
            return this;
        }

        /**
         * Updates address form fields if those
         * fields exist in the option and 
         * if they exist in the form itself
         *
         * @method updateAddressFields
         * @private
         * @chainable
         */

    }, {
        key: '_updateAddressFields',
        value: function _updateAddressFields($address1, $address2, $city, $state, $postalCode) {
            this.$addressFieldAddress1 = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_ADDRESS_1)[0];
            this.$addressFieldAddress2 = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_ADDRESS_2)[0];
            this.$addressFieldCity = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_CITY)[0];
            this.$addressFieldState = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_STATE)[0];
            this.$addressFieldPostalCode = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_POSTAL_CODE)[0];
            var fieldsToUpdate = [this.$addressFieldAddress1, this.$addressFieldAddress2, this.$addressFieldCity, this.$addressFieldState, this.$addressFieldPostalCode];
            for (var i = 0; i < arguments.length; i++) {
                if (fieldsToUpdate[i] !== undefined) {

                    fieldsToUpdate[i].value = arguments[i];
                    continue;
                }
                console.info('parameter at position ', [i], ' in updateAddressMethod()  couldnt find a corresponding address field to update');
            }
            return this;
        }

        /**
         * Submits the form 
         * that now has updated
         * Address field info
         *
         * @method onProceedClick
         * @public
         * @chainable
         */

    }, {
        key: 'onProceedClick',
        value: function onProceedClick(e) {
            this.$element.find(SELECTORS.PROCEED_CTA).addClass(_classes.LOADING_CLASS);
            this.$form.submit();
        }

        /**
         * Enable
         *
         * @method enable
         * @public
         * @chainable
         */

    }, {
        key: 'enable',
        value: function enable() {
            this.$addressOptionCheckbox.on('click input', this.onPickedAddressHandler);
            this.$proceedCta.on('click', this.onProceedClickHandler);
            return this;
        }

        /**
         * Disable
         *
         * @method disable
         * @public
         * @chainable
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.$addressOptionInfo.off('click input', this.onPickedAddressHandler);
            this.$proceedCta.off('click', this.onProceedClickHandler);
            return this;
        }
    }]);
    return ChooseAddressView;
}();

exports.default = ChooseAddressView;

},{"../constants/classes":169,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],196:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _classes = require('../constants/classes');

var _Notifications = require('../global/Notifications');

var _Notifications2 = _interopRequireDefault(_Notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {
    DEFAULT_CHECKBOX: '.js-default-checkbox',
    CUSTOM_CHECKBOX: '.js-custom-checkbox',
    PRODUCT_NAME: 'product-name',
    IN_STOCK_ATTR: 'data-in-stock'
};

/**
 * Hide Default browser checkbox
 * Control it using label and custom style
 * 
 *
 * @class CheckboxDependenciesView
 * @constructor
 */

var CustomCheckBoxView = function () {
    function CustomCheckBoxView($element) {
        (0, _classCallCheck3.default)(this, CustomCheckBoxView);

        console.log('Constructing');
        this.$element = $element;
        return this.setupHandlers().createChildren().enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */


    (0, _createClass3.default)(CustomCheckBoxView, [{
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onDefaultCheckBoxClickHandler = this.onDefaultCheckBoxClick.bind(this);
            this.onCustomCheckBoxClickHandler = this.onCustomCheckBoxClick.bind(this);
            this.qtyOutOfStockHandler = this.onQtyOutOfStock.bind(this);
            return this;
        }

        /**
         * createChildren
         *
         * @method createChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$defaultCheckbox = this.$element.find(SELECTORS.DEFAULT_CHECKBOX);
            this.$customCheckbox = this.$element.find(SELECTORS.CUSTOM_CHECKBOX);
            this.$productNameElement = document.getElementById(SELECTORS.PRODUCT_NAME);
            this.notifications = new _Notifications2.default();
            return this;
        }

        /**
         *
         * @method onParentClick
         * @public
         * @chainable
         */

    }, {
        key: 'onDefaultCheckBoxClick',
        value: function onDefaultCheckBoxClick(e) {
            return this;
        }

        /**
         * Toggles custom checkbox style
         * Triggers a click on default checkbox
         *
         * @method onParentClick
         * @public
         * @chainable
         */

    }, {
        key: 'onCustomCheckBoxClick',
        value: function onCustomCheckBoxClick(e) {
            if (this.$customCheckbox.hasClass(_classes.DISABLED_CHECKBOX)) {
                return false;
            }
            this.$defaultCheckbox.click();

            if (this.$customCheckbox.hasClass(_classes.CHECKED)) {
                this.$customCheckbox.removeClass(_classes.CHECKED);
                this.notifications.resetMessages();
            } else {
                this.$customCheckbox.addClass(_classes.CHECKED);
            }

            return this;
        }

        /**
         * 
         * Loads disabled checkbox
         * icon when qty out of stock
         *
         * @method onQtyOutOfStock
         * @public
         * @chainable
         */

    }, {
        key: 'onQtyOutOfStock',
        value: function onQtyOutOfStock() {
            var inStockQty = void 0;
            inStockQty = parseInt(this.$productNameElement.getAttribute(SELECTORS.IN_STOCK_ATTR));
            if (inStockQty === 0) {
                this.$customCheckbox.addClass(_classes.DISABLED_CHECKBOX);
            }
        }

        /**
         * Enable
         *
         * @method enable
         * @public
         * @chainable
         */

    }, {
        key: 'enable',
        value: function enable() {
            this.$defaultCheckbox.on('change', this.onDefaultCheckBoxClickHandler);
            this.$customCheckbox.on('click', this.onCustomCheckBoxClickHandler);
            this.qtyOutOfStockHandler();
            return this;
        }

        /**
         * Disable
         *
         * @method disable
         * @public
         * @chainable
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.$defaultCheckbox.off('change', this.onDefaultCheckBoxClickHandler);
            this.$customCheckbox.off('change', this.onCustomCheckBoxClickHandler);
            return this;
        }
    }]);
    return CustomCheckBoxView;
}();

exports.default = CustomCheckBoxView;

},{"../constants/classes":169,"../global/Notifications":174,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],197:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Increment steppers on steppers click
 * Stepper already has inline scripts to keep input to integer keys
 *
 * @class FormStepperView
 * @param {jQuery} [$trigger] Pass in containing dom element
 * @constructor
 */
var FormStepperView = function () {
    function FormStepperView($stepperContainer) {
        (0, _classCallCheck3.default)(this, FormStepperView);

        if (!$stepperContainer) {
            throw 'Required $stepperContainer configuration object not passed to ToggleView constructor';
        }

        if (!$stepperContainer instanceof _jquery2.default) {
            // jshint ignore:line
            throw 'Required $stepperContainer object passed to ToggleView constructor is the wrong type';
        }
        // If view element isn't on the page
        if (!$stepperContainer.length) {
            return;
        }
        /**
         * A reference to the containing DOM element
         *
         * @property $stepperContainer
         * @type {jQuery}
         * @public
         */
        this.$stepperContainer = $stepperContainer;

        /**
         * Tracks whether the view is enabled
         *
         * @default false
         * @property isEnabled
         * @type {Boolean}
         * @public
         */
        this.isEnabled = false;

        this.init();
    }

    (0, _createClass3.default)(FormStepperView, [{
        key: 'init',


        /**
         * Initializes the UI Component View
         *
         * @method init
         * @public
         * @chainable
         */
        value: function init() {
            this.setupHandlers().createChildren().enable();
            return this;
        }
    }, {
        key: 'setupHandlers',


        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @method setupHandlers
         * @public
         * @chainable
         */
        value: function setupHandlers() {

            this.handleonButtonClick = this.onButtonClick.bind(this);

            return this;
        }
    }, {
        key: 'createChildren',


        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @public
         * @chainable
         */
        value: function createChildren() {

            this.$decrement = this.$stepperContainer.find('.js-decrement');
            this.$increment = this.$stepperContainer.find('.js-increment');
            this.$stepperValue = this.$stepperContainer.find('.js-stepperValue');

            return this;
        }
    }, {
        key: 'enable',


        /**
         * Enables the component
         * Performs any event binding to handlers
         *
         * @method enable
         * @public
         * @chainable
         */
        value: function enable() {
            var _this = this;

            if (this.isEnabled) {
                return this;
            }

            this.$decrement.on('click', function (e) {
                return _this.handleonButtonClick(e, -1);
            });
            this.$increment.on('click', function (e) {
                return _this.handleonButtonClick(e, 1);
            });

            this.isEnabled = true;
            return this;
        }
    }, {
        key: 'disable',

        /**
         * Disables the component
         * Tears down any event binding to handlers
         *
         * @method disable
         * @public
         * @chainable
         */
        value: function disable() {
            if (!this.isEnabled) {
                return this;
            }

            this.$decrement.off('click');
            this.$increment.off('click');

            this.isEnabled = false;
            return this;
        }
    }, {
        key: 'onButtonClick',


        /**
         * Method onButtonClick
         *
         * @method onButtonClick 
         * @chainable
         * @public
         */
        value: function onButtonClick(e, increment) {
            e.preventDefault();

            var current = parseInt(this.$stepperValue.val());

            var newValue = current + increment;

            this.$stepperValue.val(newValue > -1 ? newValue : 0);

            return this;
        }
    }]);
    return FormStepperView;
}();

exports.default = FormStepperView;

},{"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],198:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ParsleyHelper = require('../util/ParsleyHelper');

var _ParsleyHelper2 = _interopRequireDefault(_ParsleyHelper);

var _classes = require('../constants/classes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class Parsley helper
 * 
 * Initiate Parsley and add custom validator for passwords
 */

var FormValidationView = function () {
    function FormValidationView(selector) {
        var _this = this;

        (0, _classCallCheck3.default)(this, FormValidationView);

        window.onload = function () {
            _this.init(selector).attachAria();
        };
    }

    /**
     * Method initialize parsley for a form instance
     *
     * @method init
     * @chainable
     * @public
     */


    (0, _createClass3.default)(FormValidationView, [{
        key: 'init',
        value: function init(selector) {
            var _this2 = this;

            this.$form = selector;
            this.$form.parsley();

            this.isRecaptchaValid = false;

            // finds cancel button that needs to be disabled once submit begins
            this.$disableOnSubmitEls = this.$form.find('[data-disable-on-submit]');

            // checks for recaptcha element
            this.$grecaptcha = this.$form.find('.js-recaptcha');

            if (this.$grecaptcha.length) {
                //need to wait for async script to load
                grecaptcha.render(this.$grecaptcha[0], {
                    sitekey: recaptchaKey,
                    size: 'invisible',
                    callback: function callback() {
                        _this2.isRecaptchaValid = true;
                        _this2.$form.submit();
                    },
                    'error-callback': function errorCallback() {
                        alert("A network error occured with recaptcha.  Please try again.");
                        _this2.removeLoadingClasses();
                    }
                });
            }

            this.setupHandlers().enable();

            return this;
        }

        /**
         * SetupHandlers
         *
         * @method setupHandlers
         * @chainable
         * @public
         */

    }, {
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onSubmitHandler = this.onSubmit.bind(this);
            return this;
        }

        /**
         * Attaches
         *
         * @method enable
         * @chainable
         * @public
         */

    }, {
        key: 'enable',
        value: function enable() {
            // onSubmit is called after validation succeeds and before the form is submitted
            this.$form.parsley().on('form:submit', this.onSubmitHandler);

            // //In the case of an error, remove the loading classes
            // this.$form.parsley().on('form:error', this.removeLoadingClasses);

            return this;
        }

        /**
         * Does any action on form submission event.
         *
         * @method enable
         * @chainable
         * @public
         */

    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {

            this.addLoadingClasses();

            if (this.$grecaptcha.length) {

                if (this.isRecaptchaValid) {
                    //if recaptcha was valid and we're submitting manually...
                    console.log('submitting form');
                    return true;
                }

                // else check recaptcha and suspend form
                console.log('executing grecaptcha');
                grecaptcha.execute();

                // return false to interrupt form submission
                return false;
            }
            return this;
        }

        /**
         * Method addLoadingClasses
         *
         * @method addLoadingClasses
         * @chainable
         * @public
         */

    }, {
        key: 'addLoadingClasses',
        value: function addLoadingClasses() {
            this.$disableOnSubmitEls.length ? this.$disableOnSubmitEls.attr('disabled', true) : null;
            this.$form.find('.btn[type=submit]').addClass(_classes.LOADING_CLASS);
        }

        /**
         * Method removeLoadingClasses
         *
         * @method removeLoadingClasses
         * @chainable
         * @public
         */

    }, {
        key: 'removeLoadingClasses',
        value: function removeLoadingClasses() {
            this.$disableOnSubmitEls.length ? this.$disableOnSubmitEls.attr('disabled', false) : null;
            this.$form.find('.btn[type=submit]').removeClass(_classes.LOADING_CLASS);
        }

        /**
         * Method attach events that control aria attributes
         *
         * @method attachAria
         * @chainable
         * @public
         */

    }, {
        key: 'attachAria',
        value: function attachAria() {
            window.Parsley.on('field:error', function () {
                this.$element.attr('aria-describedby', this._ui.errorsWrapperId).attr('aria-invalid', 'true');
                this._ui.$errorsWrapper.attr('aria-live', 'assertive');
            });

            window.Parsley.on('field:success', function () {
                if (this.$element.attr('aria-invalid')) {
                    this.$element.removeAttr('aria-invalid');
                }
            });
        }
    }]);
    return FormValidationView;
}();

exports.default = FormValidationView;

},{"../constants/classes":169,"../util/ParsleyHelper":187,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16}],199:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _eventEmitter = require('../global/eventEmitter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTemplate = require('../templates/modalTemplate.hbs');

/**
 * @fileOverview
 *
 * ModalView
 *
 * @author Jim Schofield
 */

/**
 * Creates a modal that takes either content on the page or a passed jQuery object as content
 * 
 *
 * @class ModalView
 * @param {jQuery} {object} pass in content and options object
 *
 * @constructor
 */

/**
 * 
 * data-modal-selector attribute will point to data already on page.
 * 
 * options structure:
 *  {
 *      classExtension: String (added to container to modify styles)
 *      template: String (path to handlbars template from project base directory)
 *      modalClickOut: String (no clickout is default behavior)
 *  }
 */

var ModalView = function () {
    function ModalView($trigger, $content, options) {
        (0, _classCallCheck3.default)(this, ModalView);


        /**
         * A reference to the trigger DOM element
         *
         * @property $trigger
         * @type {jQuery}
         * @public
         */
        if ($trigger instanceof _jquery2.default) {
            // jshint ignore:line
            this.$trigger = $trigger;
        } else {
            throw 'Trigger element is not a jquery element.  Defaulting to no trigger object on document.';
            this.$trigger = null;
        }

        /**
         * A reference to the content to be placed in the modal
         *   if a $ object, use that
         *   if not $ object try to access string selector from data attribute
         *   else throw error
         *
         * @property $content
         * @type {jQuery}
         * @public
         */
        if ($content instanceof _jquery2.default) {
            this.$content = $content;
        } else if (!$content) {
            var $inlineModalContent = (0, _jquery2.default)(this.$trigger.data('modal-selector'));

            if ($inlineModalContent.length) {
                this.$content = (0, _jquery2.default)($inlineModalContent);
            } else {
                throw 'ModalView: $content selector does not find content on the page';
            }
        } else {
            throw 'ModalView: $content is not a jquery object or valid selector';
        }

        /**
         * A reference to the config options
         *
         * @default options
         * @property isEnabled
         * @type {Boolean}
         * @public
         */
        this.options = options;

        /**
         * Tracks whether the view is enabled  
         *
         * @default false
         * @property isEnabled
         * @type {Boolean}
         * @public
         */
        this.isEnabled = false;

        /**
         * Tracks whether the modal is currently showing
         *
         * @default false
         * @property isVisible
         * @type {Boolean}
         * @public
         */
        this.isVisible = false;

        /**
         * A reference to the focused element before modal was opened
         *
         * @default null
         * @property oldFocus
         * @type {Boolean}
         * @public
         */
        this.oldFocus = null;

        /**
         * Screen position from when modal opens
         *
         * @default null
         * @property oldFocus
         * @type {Boolean}
         * @public
         */
        this.screenPosition = null;

        /**
         * A list of all possible focusable selectors for jquery
         *
         * @default A really long string
         * @property focusableSelectorList
         * @type {String}
         * @public
         */
        this.focusableSelectorList = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

        this.init();
    }

    (0, _createClass3.default)(ModalView, [{
        key: 'init',


        /**
         * Initializes the UI Component View
         *
         * @method init
         * @public
         * @chainable
         */
        value: function init() {

            this.parseOptions().createTemplate().setupHandlers().createChildren().enable();

            return this;
        }
    }, {
        key: 'parseOptions',


        /**
         *  Finds options from options object or data attributes and formats the options object
         *
         * @method parseOptions
         * @public
         * @chainable
         */
        value: function parseOptions() {

            if (typeof this.options === "undefined") {
                this.options = {};
            }

            // checks for data attributes and saves value to options object
            var checkForParam = function (name) {
                //convert to kebab case
                var kebabName = name.replace(/([a-z][A-Z])/g, function (g) {
                    return g[0] + '-' + g[1].toLowerCase();
                });

                // checking data attribute
                var tempValue = this.$trigger.attr('data-' + kebabName);
                if (typeof tempValue !== 'undefined') {

                    //coerce true or false strings into values
                    if (tempValue === "true" || tempValue === "false") {
                        this.options[name] = tempValue == 'true';
                    } else {
                        // else just store the string
                        this.options[name] = tempValue;
                    }
                }
            }.bind(this);
            // check for specific data attribute options parameters
            checkForParam('classExtension');
            checkForParam('template');
            checkForParam('modalClickOut');

            // merge any found keys in options or data attributes into class options object
            this.options = _jquery2.default.extend({
                classExtension: null,
                template: '../templates/modalTemplate.hbs',
                modalClickOut: null
            }, this.options);

            return this;
        }
    }, {
        key: 'createTemplate',


        /**
         *  Sets up container to receive content, pick content off the dom, or creates default container if no element is provided
         *
         * @method setupContainer
         * @public
         * @chainable
         */
        value: function createTemplate() {

            this.hbsTemplate = require(this.options.template);

            this.htmlTemplate = this.hbsTemplate({
                content: this.$content[0].outerHTML,
                classExtension: this.options.classExtension
            });
            this.$template = (0, _jquery2.default)(this.htmlTemplate);

            return this;
        }
    }, {
        key: 'setupHandlers',


        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view  
         *
         * @method setupHandlers
         * @public
         * @chainable
         */
        value: function setupHandlers() {

            if (this.$trigger) {
                this.handleTargetClick = this.toggle.bind(this);
            }

            this.handleClickOut = this.clickOut.bind(this);

            this.handleClose = this.close.bind(this);

            return this;
        }
    }, {
        key: 'clickOut',


        /**
         * close if clicking outside of the modal content
         *
         * @method clickOut
         * @public
         * @chainable
         */
        value: function clickOut(e) {
            if (!(0, _jquery2.default)(e.target).closest('.js-modal-content').length) {
                this.close();
            }
            return this;
        }

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {

            return this;
        }
    }, {
        key: 'enable',


        /**
         * Enables the component
         * Performs any event binding to handlers
         *
         * @method enable
         * @public
         * @chainable
         */
        value: function enable() {
            if (this.isEnabled) {
                return this;
            }

            if (this.$trigger) {
                this.$trigger.on('click', this.handleTargetClick);
            }

            this.isEnabled = true;
            return this;
        }
    }, {
        key: 'onEnable',


        /**
         * Attach close handlers
         *
         * @method enable
         * @public
         * @chainable
         */
        value: function onEnable() {
            //close events
            if (this.options.modalClickOut) {
                //click out option enabled
                (0, _jquery2.default)('.js-modal').on('click', this.handleClickOut);
            } else {
                //click out disabled, only close on button click
                (0, _jquery2.default)('.js-modal-close').on('click', this.handleClose);
            }

            //key management events
            (0, _jquery2.default)('.js-modal').on('keydown', function (e) {
                if (e.keyCode === 27) {
                    this.close();
                }
                //tab cylcing - trap focus within the modal
                var currentFocus = (0, _jquery2.default)(e.target);
                var focusableList = (0, _jquery2.default)('.js-modal').find(this.focusableSelectorList);
                var lastFocusableElement = focusableList.last()[0];
                var firstFocusableElement = focusableList.first()[0];

                if (e.keyCode === 9 && !e.shiftKey) {
                    //tab key pressed
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                }
                if (e.keyCode === 9 && e.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            }.bind(this));

            _eventEmitter.eventEmitter.emit('modal-open', this.$template);
        }

        /**
         * toggles modal
         *
         * @method toggleModal
         * @public
         * @chainable
         */

    }, {
        key: 'toggle',
        value: function toggle(e) {
            e.preventDefault();
            if (this.isVisible) {
                this.close();
            } else {
                this.open();
            }
            return this;
        }
    }, {
        key: 'open',


        /**
         * open modal
         *
         * @method open
         * @public
         * @chainable
         */
        value: function open(e) {

            //store focus from before modal is open
            this.oldFocus = (0, _jquery2.default)(':focus');

            // store screen position and set site position so screen does not move
            this.screenPosition = (0, _jquery2.default)(window).scrollTop();

            // freeze the body
            (0, _jquery2.default)('body').addClass('modal-is-active');
            (0, _jquery2.default)('.site').css("top", -this.screenPosition);

            // add modal
            (0, _jquery2.default)('.site').append(this.$template);

            // set focus to first focusable element in modal
            (0, _jquery2.default)('.modal').find(this.focusableSelectorList).eq(0).focus();

            this.onEnable();

            this.isVisible = true;

            return this;
        }
    }, {
        key: 'close',


        /**
         * close modal
         *
         * @method close
         * @public
         * @chainable
         */
        value: function close() {

            //restore original focus on document
            this.oldFocus.focus();

            // unfreeze body
            (0, _jquery2.default)('body').removeClass('modal-is-active');
            (0, _jquery2.default)('.site').css("top", 'auto');
            (0, _jquery2.default)(document).scrollTop(this.screenPosition);

            //remove modal
            (0, _jquery2.default)('.site').find('.js-modal').remove();

            // tear down handlers for this mobile
            this.disable();

            this.isVisible = false;

            return this;
        }
    }, {
        key: 'disable',


        /**
         * Disables the component
         * Tears down any event binding to handlers
         *
         * @method disable
         * @public
         * @chainable
         */
        value: function disable() {
            if (!this.isEnabled) {
                return this;
            }

            (0, _jquery2.default)('.js-modal').off();
            (0, _jquery2.default)('.js-modal-close').off();

            this.isEnabled = false;

            return this;
        }
    }]);
    return ModalView;
}();

exports.default = ModalView;

},{"../global/eventEmitter":175,"../templates/modalTemplate.hbs":185,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],200:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _BaseController2 = require('../core/BaseController');

var _classes = require('../constants/classes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {
    MOBILE_MENU_TRIGGER: '.js-navigationView-mobileTrigger',
    NAV_CONTAINER: '.js-navigationView',
    NAV_PRIMARY: '.js-navigationView-nav',
    NAV_USER_DROPDOWN: '.js-navigationView-userDropdown'
};

/**
 * Navigation functionality across breakpoints
 *
 * @class NavigationView.
 * @constructor
 */

var NavigationView = function (_BaseController) {
    (0, _inherits3.default)(NavigationView, _BaseController);

    function NavigationView($element) {
        (0, _classCallCheck3.default)(this, NavigationView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NavigationView.__proto__ || (0, _getPrototypeOf2.default)(NavigationView)).call(this));

        _this.init($element);
        return _this;
    }

    /**
     * Initializes methods
     *
     * @method init
     * @public
     * @chainable
     */


    (0, _createClass3.default)(NavigationView, [{
        key: 'init',
        value: function init($element) {
            /**
             * A reference to the containing DOM element
             *
             * @property propertyName
             * @type {type}
             * @public
             */
            this.$element = $element;

            /**
             * Tracks if the desktop event binding is enabled
             *
             * @default false
             * @property isDesktopEnabled
             * @type {Boolean}
             * @public
             */
            this.isDesktopEnabled = false;

            /**
             * Tracks if the mobile event binding is enabled
             *
             * @default false
             * @property isMobileEnabled
             * @type {Boolean}
             * @public
             */
            this.isMobileEnabled = false;

            return this.setupHandlers().createChildren().layout().enable();
        }

        /**
         * SetupHandlers
         *
         * @method setupHandlers
         * @public
         * @chainable
         */

    }, {
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onMobileToggleHandler = this.onMobileToggle.bind(this);;
            this.onMobileChildFocusHandler = this.onMobileChildFocus.bind(this);
            this.onMobileChildFocusOutHandler = this.onMobileChildFocusOut.bind(this);
            this.onMobileMenuOffClickHandler = this.onMobileMenuOffClick.bind(this);
            return this;
        }

        /**
         * createChildren
         *
         * @method createChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$primaryNav = this.$element.find(SELECTORS.NAV_PRIMARY);
            this.$tabbableChildren = this.$primaryNav.find('a,button');
            this.currentBreakpoint = this.getCurrentSize();
            this.$mobileToggle = this.$element.find(SELECTORS.MOBILE_MENU_TRIGGER);

            return this;
        }

        /**
         * Creates children specific to mobile
         *
         * @method createMobileChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createMobileChildren',
        value: function createMobileChildren() {
            this.$body = (0, _jquery2.default)('body');

            return this;
        }

        /**
         * Makes nulls out cached mobile elements
         *
         * @method removeMobileChildren
         * @public
         * @chainable
         */

    }, {
        key: 'removeMobileChildren',
        value: function removeMobileChildren() {
            // this.$mobileToggle = null;
            this.$body = null;

            return this;
        }

        /**
         * Layout
         *
         * @method layout
         * @public
         * @chainable
         */

    }, {
        key: 'layout',
        value: function layout() {

            if (!this.isMobile()) {
                this.disableMobile().removeMobileChildren();
                //     .enableDesktop();
            } else {
                // this.disableDesktop()
                this.createMobileChildren().enableMobile();
            }

            return this;
        }

        /**
         * onMobileToggle
         *
         * When the mobile navigation is expanded/toggled
         *
         * @method onMobileToggle
         * @public
         * @chainable
         */

    }, {
        key: 'onMobileToggle',
        value: function onMobileToggle(event) {

            if (this.$element.hasClass(_classes.IS_ACTIVE_CLASS)) {
                this.closeMobileMenu();
            } else {
                this.$element.addClass(_classes.IS_ACTIVE_CLASS);
                this.$mobileToggle.attr('aria-expanded', 'true');
                this.$primaryNav.attr('aria-hidden', 'false');
            }

            return this;
        }

        /**
         * Determines when user is clicking off of the main menu
         * in mobile
         *
         * @method onMobileMenuOffClick
         * @public
         * @chainable
         */

    }, {
        key: 'onMobileMenuOffClick',
        value: function onMobileMenuOffClick(e) {
            if (this.$element.find(e.target).length) {
                return;
            } else {
                this.closeMobileMenu();
            }
        }

        /**
         * Removes all active classes on the main and
         * subnavigation layers
         *
         * @method closeMobileMenu
         * @public
         * @chainable
         */

    }, {
        key: 'closeMobileMenu',
        value: function closeMobileMenu() {
            this.$element.removeClass(_classes.IS_FOCUS_ACTIVE_CLASS).removeClass(_classes.IS_ACTIVE_CLASS);
            this.$mobileToggle.attr('aria-expanded', 'false');
            this.$primaryNav.attr('aria-hidden', 'true');
            return this;
        }

        /**
         * Apply aria when menu 
         * is expanded
         *
         * @method ariaExpanded
         * @public
         * @chainable
         */

    }, {
        key: 'ariaExpanded',
        value: function ariaExpanded() {
            this.$mobileToggle.attr('aria-expanded', 'true');
            this.$primaryNav.attr('aria-hidden', 'false');
            return this;
        }

        /**
         * Apply aria when menu 
         * is collapsed
         *
         * @method ariaCollapsed
         * @public
         * @chainable
         */

    }, {
        key: 'ariaCollapsed',
        value: function ariaCollapsed() {
            this.$mobileToggle.attr('aria-expanded', 'false');
            this.$primaryNav.attr('aria-hidden', 'true');
            return this;
        }

        /**
         * onMobileChildFocus: Handles display of the menu
         * when any tabbable menu item has focus
         *
         * @method onMobileChildFocus
         * @public
         * @chainable
         */

    }, {
        key: 'onMobileChildFocus',
        value: function onMobileChildFocus(e) {
            if (!this.isMobile()) {
                return;
            }
            this.$element.addClass(_classes.IS_FOCUS_ACTIVE_CLASS);
            this.ariaExpanded();
            return this;
        }

        /**
         * onMobileChildFocusOut: Handles hiding of the menu
         * when no menu children have focus
         *
         * @method onMobileChildFocusOut
         * @public
         * @chainable
         */

    }, {
        key: 'onMobileChildFocusOut',
        value: function onMobileChildFocusOut(e) {
            if (!this.isMobile()) {
                return;
            }

            this.$element.removeClass(_classes.IS_FOCUS_ACTIVE_CLASS);

            if (!this.$element.hasClass(_classes.IS_ACTIVE_CLASS)) {
                this.ariaCollapsed();
            }

            return this;
        }

        /**
         * On Breakpoint Change
         *
         * @method onBreakpointChange
         * @public
         * @chainable
         */

    }, {
        key: 'onBreakpointChange',
        value: function onBreakpointChange(breakpoint) {
            /* Update our local property with new breakpoint value */
            this.currentBreakpoint = breakpoint.currentSize;

            this.layout();
        }

        /**
         * Handles resetting
         * the mobile menu aria and
         * active classes
         *
         * @method resetMobile
         * @public
         * @chainable
         */

    }, {
        key: 'resetMobile',
        value: function resetMobile() {
            this.ariaExpanded();
            this.$element.removeClass(_classes.IS_FOCUS_ACTIVE_CLASS).removeClass(_classes.IS_ACTIVE_CLASS);
        }

        /**
         * Handles reestablishing
         * the mobile menu aria and
         * active classes
         *
         * @method setMobileMenu
         * @public
         * @chainable
         */

    }, {
        key: 'setMobile',
        value: function setMobile() {
            this.ariaCollapsed();
            this.$element.removeClass(_classes.IS_FOCUS_ACTIVE_CLASS).removeClass(_classes.IS_ACTIVE_CLASS);
        }

        /**
         * Enable
         *
         * @method enable
         * @public
         * @chainable
         */

    }, {
        key: 'enable',
        value: function enable() {
            this.$tabbableChildren.on('focus', this.onMobileChildFocusHandler);
            this.$tabbableChildren.on('focusout', this.onMobileChildFocusOutHandler);

            return this;
        }

        /**
         * Disable
         *
         * @method disable
         * @public
         * @chainable
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.$tabbableChildren.off('focus', this.onMobileChildFocusHandler);
            this.$tabbableChildren.off('focusout', this.onMobileChildFocusOutHandler);

            return this;
        }

        /**
         * Enabling mobile events when on mobile
         *
         * @method enableMobile
         * @public
         * @chainable
         */

    }, {
        key: 'enableMobile',
        value: function enableMobile() {
            if (this.isMobileEnabled) {
                return this;
            }
            this.$mobileToggle.on('click', this.onMobileToggleHandler);
            this.$body.on('click touchstart', this.onMobileMenuOffClickHandler);

            this.isMobileEnabled = true;
            this.setMobile();

            return this;
        }

        /**
         * Disabling mobile events when on desktop
         *
         * @method methodName
         * @public
         * @chainable
         */

    }, {
        key: 'disableMobile',
        value: function disableMobile() {
            if (!this.isMobileEnabled) {
                this.ariaExpanded();
                return this;
            }

            this.$mobileToggle.off('click', this.onMobileToggleHandler);
            this.$body.off('click', this.onMobileMenuOffClickHandler);

            this.isMobileEnabled = false;
            this.resetMobile();

            return this;
        }
    }]);
    return NavigationView;
}(_BaseController2.BaseController);

exports.default = NavigationView;

},{"../constants/classes":169,"../core/BaseController":173,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"babel-runtime/helpers/inherits":18,"babel-runtime/helpers/possibleConstructorReturn":19,"jquery":"jquery"}],201:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTORS = {
    ACCORDIION_ARROW: '.accordion-arrow',
    ACCORDION_CONTENT: '.accordion-content',
    ACCORDION_TITLE: '.accordion-title',
    ACCORDION_TITLE_TEXT: '.accordion-title-key-text',
    ORDER_DETAILS_MODAL: '.order-details-modalChild',
    ORDER_DETAILS_MODAL_CLOSE: '.order-details-modal-close-icon',
    SERIAL_COLUMN_CONTENT: 'serial_column_content'
};

var CLASSES = {
    ARROW_UP_ACCORDION: 'accordion-arrow-up',
    HIDE_ACCORDION: 'accordion-hide',
    HIDE_MODAL: 'order-details-modal-hide'
};

var OrderHistoryView = function () {
    function OrderHistoryView($element) {
        (0, _classCallCheck3.default)(this, OrderHistoryView);

        return this.init($element);
    }

    (0, _createClass3.default)(OrderHistoryView, [{
        key: 'init',
        value: function init($element) {
            this.$element = $element;

            return this.setupHandlers().createChildren().enable();
        }
    }, {
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onSerialColumnContentClickHandler = this.onSerialColumnContentClick.bind(this);
            this.onOrderDetailsModelCloseClickHandler = this.onOrderDetailsModelCloseClick.bind(this);
            this.onAccordionTitleClickHandler = this.onAccordionTitleClick.bind(this);

            this.onClickOutHandler = this.onClickOut.bind(this);

            return this;
        }
    }, {
        key: 'onSerialColumnContentClick',
        value: function onSerialColumnContentClick(e) {
            this.hideOrderDetailsModals();
            (0, _jquery2.default)(e.currentTarget).next(SELECTORS.ORDER_DETAILS_MODAL).toggleClass(CLASSES.HIDE_MODAL);
        }
    }, {
        key: 'hideOrderDetailsModals',
        value: function hideOrderDetailsModals() {
            (0, _jquery2.default)(SELECTORS.ORDER_DETAILS_MODAL).addClass(CLASSES.HIDE_MODAL);
        }
    }, {
        key: 'onAccordionTitleClick',
        value: function onAccordionTitleClick(e) {
            var target = (0, _jquery2.default)(e.currentTarget);
            var accordionContent = target.next(SELECTORS.ACCORDION_CONTENT);
            var text = accordionContent.hasClass(CLASSES.HIDE_ACCORDION) === true ? 'Hide Details' : 'View Details';
            target.find(SELECTORS.ACCORDION_TITLE_TEXT).text(text);

            target.find(SELECTORS.ACCORDIION_ARROW).toggleClass(CLASSES.ARROW_UP_ACCORDION);
            accordionContent.toggleClass(CLASSES.HIDE_ACCORDION);
        }
    }, {
        key: 'onOrderDetailsModelCloseClick',
        value: function onOrderDetailsModelCloseClick(e) {
            this.hideOrderDetailsModals();
        }
    }, {
        key: 'onClickOut',
        value: function onClickOut(e) {
            e.stopImmediatePropagation();
            if (!this.isClickTarget(e.target, SELECTORS.ORDER_DETAILS_MODAL) && e.target.classList.contains(SELECTORS.SERIAL_COLUMN_CONTENT) === false) {
                this.hideOrderDetailsModals();
            }
        }
    }, {
        key: 'isClickTarget',
        value: function isClickTarget(target, selector) {
            return (0, _jquery2.default)(target).closest(selector).length;
        }
    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$serialColumnContent = this.$element.find('.' + SELECTORS.SERIAL_COLUMN_CONTENT);
            this.$accordionTitle = this.$element.find(SELECTORS.ACCORDION_TITLE);
            this.$orderDetailsModal = this.$element.find(SELECTORS.ORDER_DETAILS_MODAL);
            this.$orderDetailsModalClose = this.$element.find(SELECTORS.ORDER_DETAILS_MODAL_CLOSE);

            return this;
        }
    }, {
        key: 'enable',
        value: function enable() {
            (0, _jquery2.default)(document).on('click', this.onClickOutHandler);
            this.$accordionTitle.on('click', this.onAccordionTitleClickHandler);
            this.$serialColumnContent.on('click', this.onSerialColumnContentClickHandler);
            this.$orderDetailsModalClose.on('click', this.onOrderDetailsModelCloseClickHandler);

            return this;
        }
    }, {
        key: 'disable',
        value: function disable() {
            (0, _jquery2.default)(document).off('click', this.onClickOutHandler);
            this.$accordionTitle.off('click', this.onAccordionTitleClickHandler);
            this.$serialColumnContent.off('click', this.onSerialColumnContentClickHandler);
            this.$orderDetailsModalClose.off('click', this.onOrderDetailsModelCloseClickHandler);

            return this;
        }
    }]);
    return OrderHistoryView;
}();

exports.default = OrderHistoryView;

},{"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],202:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTORS = {
    IMAGE_ITEM: '.js-productCarousel-image',
    CAPTION: '.js-productCarousel-caption',
    CAPTION_HIDE: '.js-productCarousel-captionHide',
    CAPTION_SHOW: '.js-productCarousel-captionShow'
};

var CLASSES = {
    CAPTION_COLLAPSED: 'isCollapsed',
    CAPTION_HIDDEN_CLASS: 'captionHidden',
    HAS_CAPTION_CLASS: 'hasCaption'
};

var TRANSITION_DURATION = 250;

var ProductCarouselView = function () {
    function ProductCarouselView($element) {
        (0, _classCallCheck3.default)(this, ProductCarouselView);

        this.init = function () {
            this.setupHandlers().createChildren().layout().enable();

            return this;
        };

        this.$element = $element;
        this.isEnabled = false;
        this.imageCount;

        this.init();
    }

    (0, _createClass3.default)(ProductCarouselView, [{
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.captionHideHandler = this.hideCaption.bind(this);
            this.captionShowHandler = this.showCaption.bind(this);

            return this;
        }
    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$productImage = this.$element.find(SELECTORS.IMAGE_ITEM);
            this.$productCaption = this.$element.find(SELECTORS.CAPTION);
            this.$productCaptionHide = this.$element.find(SELECTORS.CAPTION_HIDE);
            this.$productCaptionShow = this.$element.find(SELECTORS.CAPTION_SHOW);

            return this;
        }
    }, {
        key: 'layout',
        value: function layout() {
            this.$productImage.each(function () {
                var caption = (0, _jquery2.default)(this).find(SELECTORS.CAPTION);
                if (caption.length !== 0) {
                    (0, _jquery2.default)(this).addClass(CLASSES.HAS_CAPTION_CLASS);
                }

                (0, _jquery2.default)(this).attr('aria-hidden', 'true');
            });

            this.$productCaptionHide.each(function () {
                (0, _jquery2.default)(this).attr('tabindex', '-1');
            });

            return this;
        }
    }, {
        key: 'enable',
        value: function enable() {
            if (this.isEnabled === true) {
                return this;
            }
            this.isEnabled = true;

            this.setupVariables();

            this.$productCaptionHide.on('click', this.captionHideHandler);
            this.$productCaptionShow.on('click', this.captionShowHandler);

            return this;
        }
    }, {
        key: 'setupVariables',
        value: function setupVariables() {
            this.imageCount = this.$productImage.length;
        }
    }, {
        key: 'showCaption',
        value: function showCaption() {
            this.$productCaption.removeClass(CLASSES.CAPTION_COLLAPSED);
            this.$element.removeClass(CLASSES.CAPTION_HIDDEN_CLASS);
        }
    }, {
        key: 'hideCaption',
        value: function hideCaption(e) {
            e.preventDefault();
            this.$productCaption.addClass(CLASSES.CAPTION_COLLAPSED);
            this.$element.addClass(CLASSES.CAPTION_HIDDEN_CLASS);
        }
    }]);
    return ProductCarouselView;
}();

exports.default = ProductCarouselView;
;

},{"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],203:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _eventEmitter = require('../global/eventEmitter');

var _classes = require('../constants/classes');

var _Notifications = require('../global/Notifications');

var _Notifications2 = _interopRequireDefault(_Notifications);

var _TrackingService = require('../services/TrackingService');

var _TrackingService2 = _interopRequireDefault(_TrackingService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {
    PRODUCT_QTY: '.js-pdp-qty',
    FREQUENT_PDT_DESC: '.js-frequent-desc',
    FREQUENT_PDT_DESC_VIEW: '.view-cta',
    PARENT_TOAST: '.parent-toast',
    STEPPER_VALUE: '.js-stepperValue',
    ADD_TO_CART: '.btn_primary',
    TOAST: '.toast',
    MAX_QTY: '.js-max-value',
    INVENTORY_MESSAGE: '.js-inventory-msg',
    PRODUCT_NAME: 'product-name',
    IN_STOCK_QTY: 'data-in-stock',
    MAX_VALUE: 'max-value',
    MAX_VALUE_ATTR: 'data-max-qty',
    TOAST_MSG: '.js-toast-msg',
    STEPPER_INPUT: 'stepper',
    CUSTOM_CHECKBOX: '.js-custom-checkbox',
    DEBRIS_DIVERTER: 'debrisDiverter',
    DEBRIS_DIVERTER_QTY: 'data-qty-available',
    PRODUCT_ITEM_VARIABLE: 'js_productItem'
};

/**
 * Hide Default browser checkbox
 * Control it using label and custom style
 * 
 *
 * @class CheckboxDependenciesView
 * @constructor
 */

var ProductDetailView = function () {
    function ProductDetailView($element) {
        (0, _classCallCheck3.default)(this, ProductDetailView);

        console.log('PDP View JS');
        this.$element = $element;
        this.eventEmitter = _eventEmitter.eventEmitter;
        this.productItem = window[SELECTORS.PRODUCT_ITEM_VARIABLE];

        return this.setupHandlers().createChildren().addQtyChangeListener().enable().trackViewItem().addToCartClicked().inputEntered();
    }

    (0, _createClass3.default)(ProductDetailView, [{
        key: 'addQtyChangeListener',
        value: function addQtyChangeListener() {
            var _this = this;

            this.eventEmitter.on('qty-change', function (param1) {
                _this.onPdpQtyChange(param1);
            });
            return this;
        }

        /**
         * SetupHandlers
         *
         * @method setupHandlers
         * @public
         * @chainable
         */

    }, {
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onPdpQtyChangeHandler = this.onPdpQtyChange.bind(this);
            this.onFrequentPdtDescViewCTAHandler = this.onFrequentPdtDescViewCTA.bind(this);
            this.oncartClickedHandler = this.oncartClicked.bind(this);
            this.onInputEnteredHandler = this.onInputEntered.bind(this);
            return this;
        }

        /**
         * createChildren
         *
         * @method createChildren
         * @public
         * @chainable
         */

    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.$parentToast = this.$element.find(SELECTORS.PARENT_TOAST);
            this.$pdpQty = this.$element.find(SELECTORS.PRODUCT_QTY);
            this.$frequentPdtDesc = this.$element.find(SELECTORS.FREQUENT_PDT_DESC);
            this.$frequentPdtDescView = this.$element.find(SELECTORS.FREQUENT_PDT_DESC_VIEW);
            this.$stepperValue = this.$element.find(SELECTORS.STEPPER_VALUE);
            this.$addToCart = this.$element.find(SELECTORS.ADD_TO_CART);
            this.$closeIcon = this.$element.find(SELECTORS.CLOSE_ICON);
            this.$toast = this.$element.find(SELECTORS.TOAST);
            this.$maxQty = this.$element.find(SELECTORS.MAX_QTY);
            this.$inventoryMessage = this.$element.find(SELECTORS.INVENTORY_MESSAGE);
            this.$maxQtyDiv = document.getElementById(SELECTORS.MAX_VALUE);
            this.$productNameElement = document.getElementById(SELECTORS.PRODUCT_NAME);
            this.$toastMsg = this.$element.find(SELECTORS.TOAST_MSG);
            this.notifications = new _Notifications2.default();
            this.$inputValue = document.getElementById(SELECTORS.STEPPER_INPUT);
            this.$debrisDiverterQty = document.getElementById(SELECTORS.DEBRIS_DIVERTER);
            this.$customCheckbox = this.$element.find(SELECTORS.CUSTOM_CHECKBOX);
            this.trackingService = new _TrackingService2.default();
            return this;
        }

        /**
         * Toggles custom checkbox style
         * Triggers a click on default checkbox
         *
         * @method onParentClick
         * @public
         * @chainable
         */

    }, {
        key: 'onPdpQtyChange',
        value: function onPdpQtyChange(qty) {
            var maxQty = void 0;
            var inStockQty = void 0;
            this.$pdpQty.text(qty);
            inStockQty = this.$productNameElement.getAttribute(SELECTORS.IN_STOCK_QTY);

            if (this.$maxQtyDiv !== null) {
                maxQty = this.$maxQtyDiv.getAttribute(SELECTORS.MAX_VALUE_ATTR);

                if (qty > maxQty && !this.$addToCart.hasClass(_classes.CHECK_CART)) {
                    this.notifications.showErrorNotification(NOTIFICATIONS.MAXIMUM_ALLOWED_QTY_ERROR, _classes.ERROR_MESSAGE_CLASS);

                    this.$stepperValue.addClass(_classes.INPUTERROR);
                    this.$inventoryMessage.addClass(_classes.INPUTERROR);
                    this.$addToCart.prop('disabled', true);
                } else if (qty <= maxQty && !this.$addToCart.hasClass(_classes.CHECK_CART)) {
                    this.notifications.resetMessages();
                    this.$stepperValue.removeClass(_classes.INPUTERROR);
                    this.$inventoryMessage.removeClass(_classes.INPUTERROR);
                    this.$addToCart.prop('disabled', false);
                }
            }
            if (inStockQty !== null || inStockQty !== undefined) {
                if (qty <= inStockQty && this.$addToCart.hasClass(_classes.CHECK_CART)) {
                    this.notifications.resetMessages();
                    this.$stepperValue.removeClass(_classes.INPUTERROR);
                    this.$inventoryMessage.removeClass(_classes.INPUTERROR);
                    this.$addToCart.prop('disabled', false);
                    this.$addToCart.removeClass(_classes.CHECK_CART);
                }
            }

            return this;
        }

        /**
         * When Add To Cart
         * button is clicked
         *
         * @method onCartClicked
         * @public
         * @chainable
         */

    }, {
        key: 'oncartClicked',
        value: function oncartClicked(e) {
            var event = e;
            var inStockQty = void 0;
            var inStockDebrisDiverterQty = void 0;
            var error = false;
            var addAccessory = false;
            inStockQty = this.$productNameElement.getAttribute(SELECTORS.IN_STOCK_QTY);
            if (this.$pdpQty.length) {
                if (this.$customCheckbox.hasClass(_classes.CHECKED)) {
                    addAccessory = true;
                    inStockDebrisDiverterQty = this.$debrisDiverterQty.getAttribute(SELECTORS.DEBRIS_DIVERTER_QTY);
                    if (inStockDebrisDiverterQty !== null && inStockDebrisDiverterQty !== undefined) {
                        if (parseInt(this.$pdpQty.text()) > inStockDebrisDiverterQty && this.$customCheckbox.hasClass(_classes.CHECKED)) {
                            this.notifications.showErrorNotification(NOTIFICATIONS.AVAILABLE_DEBRIS_DIVERTER_QTY, _classes.ERROR_MESSAGE_CLASS);
                            error = true;
                            event.preventDefault();
                        }
                    }
                }

                if (inStockQty !== null && inStockQty !== undefined) {
                    if (parseInt(this.$pdpQty.text()) > parseInt(inStockQty)) {
                        this.notifications.showErrorNotification(NOTIFICATIONS.AVAILABLE_QTY_ERROR, _classes.ERROR_MESSAGE_CLASS);
                        this.$addToCart.addClass(_classes.CHECK_CART);
                        this.$inventoryMessage.addClass(_classes.INPUTERROR);
                        this.$stepperValue.addClass(_classes.INPUTERROR);
                        this.$addToCart.prop('disabled', true);
                        error = true;
                        event.preventDefault();
                    }
                }
            } else {
                if (parseInt(this.$inputValue.value) > parseInt(inStockQty)) {
                    this.notifications.showErrorNotification(NOTIFICATIONS.AVAILABLE_QTY_ERROR, _classes.ERROR_MESSAGE_CLASS);
                    this.$addToCart.addClass(_classes.CHECK_CART);
                    this.$inventoryMessage.addClass(_classes.INPUTERROR);
                    this.$stepperValue.addClass(_classes.INPUTERROR);
                    this.$addToCart.prop('disabled', true);
                    error = true;
                    event.preventDefault();
                }
            }
            if (!error) {
                this.trackAddToCart(parseInt(this.$inputValue.value), addAccessory);
            }
            return this;
        }
    }, {
        key: 'onFrequentPdtDescViewCTA',
        value: function onFrequentPdtDescViewCTA() {
            console.log('View More, View Less');
            if (this.$frequentPdtDesc.hasClass(_classes.TEXTCOLLAPSED)) {
                this.$frequentPdtDesc.removeClass(_classes.TEXTCOLLAPSED);
            } else {
                this.$frequentPdtDesc.addClass(_classes.TEXTCOLLAPSED);
            }
            return this;
        }
        /**
         * When user enters
         * input in qty input box
         *
         * @method onInputEntered
         * @public
         * @chainable
         */

    }, {
        key: 'onInputEntered',
        value: function onInputEntered() {
            console.log('user input entered');
            this.$pdpQty.text(this.$inputValue.value);
            this.onPdpQtyChange(parseInt(this.$inputValue.value));
        }

        /**
         * Ecommerce tracking call - View Item
         *
         * @method trackViewItem
         * @public
         * @chainable
         */

    }, {
        key: 'trackViewItem',
        value: function trackViewItem() {
            this.trackingService.viewItem(this.productItem);
            return this;
        }

        /**
         * Ecommerce tracking call - Add To Cart
         *
         * @method trackAddToCart
         * @public
         */

    }, {
        key: 'trackAddToCart',
        value: function trackAddToCart(quantity, addAccessory) {
            this.productItem.ProductQuantity = quantity;
            if (addAccessory) {
                this.productItem.ProductReference = {
                    ProductCode: this.productItem.ProductReferenceViewModel.ProductCode,
                    ProductName: this.productItem.ProductReferenceViewModel.ProductName,
                    PriceValue: this.productItem.ProductReferenceViewModel.PriceValue
                };
            }
            this.trackingService.addToCart(this.productItem);
            return this;
        }

        /**
         * Enable
         *
         * @method enable
         * @public
         * @chainable
         */

    }, {
        key: 'enable',
        value: function enable() {
            this.$frequentPdtDescView.on('click', this.onFrequentPdtDescViewCTAHandler);
            return this;
        }

        /**
         * Disable
         *
         * @method disable
         * @public
         * @chainable
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.$frequentPdtDescView.off('click', this.onFrequentPdtDescViewCTAHandler);
            return this;
        }

        /**
         * addToCartClicked
         *
         * @method addToCartClicked
         * @public
         * @chainable
         */

    }, {
        key: 'addToCartClicked',
        value: function addToCartClicked() {
            this.$addToCart.on('click', this.oncartClickedHandler);
            return this;
        }

        /**
         * input entered
         *
         * @method inputEntered
         * @public
         * @chainable
         */

    }, {
        key: 'inputEntered',
        value: function inputEntered() {
            this.$stepperValue.on('keyup', this.onInputEnteredHandler);
        }
    }]);
    return ProductDetailView;
}();

exports.default = ProductDetailView;

},{"../constants/classes":169,"../global/Notifications":174,"../global/eventEmitter":175,"../services/TrackingService":182,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}],204:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _TrackingService = require('../services/TrackingService');

var _TrackingService2 = _interopRequireDefault(_TrackingService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {
    SERIES_DATA_VARIABLE: 'js_productSeriesData',
    PRODUCT_DETAIL_LINK: 'js-seriesDetailLink',
    PRODUCT_ADD_TO_CART_LINK: 'js-seriesAddToCart',
    ACCESSORY_ADD_TO_CART_LINK: 'js-seriesAddAccessory'
};

/**
 * 
 * @constructor
 */

var ProductSeriesView = function () {
    function ProductSeriesView($element) {
        (0, _classCallCheck3.default)(this, ProductSeriesView);

        this.$element = $element;
        this.seriesData = window[SELECTORS.SERIES_DATA_VARIABLE];
        this.trackingService = new _TrackingService2.default();

        return this.createChildren().setupHandlers().trackItemListViewed();
    }

    (0, _createClass3.default)(ProductSeriesView, [{
        key: 'createChildren',
        value: function createChildren() {
            this.$detailLinks = this.$element.find("." + SELECTORS.PRODUCT_DETAIL_LINK);
            this.$addToCartLinks = this.$element.find("." + SELECTORS.PRODUCT_ADD_TO_CART_LINK);
            this.$addAccessoryLinks = this.$element.find("." + SELECTORS.ACCESSORY_ADD_TO_CART_LINK);
            return this;
        }
    }, {
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onDetailLinkClickedHandler = this.onDetailLinkClicked.bind(this);
            this.onAddToCartLinkClickedHandler = this.onAddToCartLinkClicked.bind(this);
            this.onAccessoryAddToCartLinkClickedHandler = this.onAccessoryAddToCartLinkClicked.bind(this);
            this.$detailLinks.on('click', this.onDetailLinkClickedHandler);
            this.$addToCartLinks.on('click', this.onAddToCartLinkClickedHandler);
            this.$addAccessoryLinks.on('click', this.onAccessoryAddToCartLinkClickedHandler);
            return this;
        }
    }, {
        key: 'trackItemListViewed',
        value: function trackItemListViewed() {
            this.trackingService.viewItemList(this.seriesData.Name, this.seriesData.Title, this.seriesData.Products);
            return this;
        }
    }, {
        key: 'onDetailLinkClicked',
        value: function onDetailLinkClicked(e) {
            var productCode = e.currentTarget.dataset.productCode;
            var seriesProduct = this.seriesData.Products.filter(function (p) {
                return p.ProductCode == productCode;
            })[0];
            this.trackingService.selectItem(this.seriesData.Name, this.seriesData.Title, seriesProduct);
        }
    }, {
        key: 'onAddToCartLinkClicked',
        value: function onAddToCartLinkClicked(e) {
            var productCode = e.currentTarget.dataset.productCode;
            var seriesProduct = this.seriesData.Products.filter(function (p) {
                return p.ProductCode == productCode;
            })[0];
            seriesProduct.ProductQuantity = 1;
            this.trackingService.addToCart(seriesProduct);

            var diverterCheckbox = document.getElementById(productCode);
            if (diverterCheckbox != null && diverterCheckbox.checked) {
                var accessory = this.seriesData.DebrisDiverter;
                accessory.ProductQuantity = 1;
                this.trackingService.addToCart(accessory);
            }
        }
    }, {
        key: 'onAccessoryAddToCartLinkClicked',
        value: function onAccessoryAddToCartLinkClicked(e) {
            var accessory = this.seriesData.DebrisDiverter;
            accessory.ProductQuantity = 1;
            this.trackingService.addToCart(accessory);
        }
    }]);
    return ProductSeriesView;
}();

exports.default = ProductSeriesView;

},{"../services/TrackingService":182,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16}],205:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _classes = require('../constants/classes');

var _Notifications = require('../global/Notifications');

var _Notifications2 = _interopRequireDefault(_Notifications);

var _orderService = require('../services/orderService');

var _orderService2 = _interopRequireDefault(_orderService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTORS = {
    REORDER_BUTTON: '.js-reorder-button'
};

var ReorderView = function () {
    function ReorderView($element) {
        (0, _classCallCheck3.default)(this, ReorderView);

        return this.init($element);
    }

    (0, _createClass3.default)(ReorderView, [{
        key: 'init',
        value: function init($element) {
            this.$element = $element;

            return this.setupHandlers().createChildren().enable();
        }
    }, {
        key: 'setupHandlers',
        value: function setupHandlers() {
            this.onReorderButtonClickHandler = this.onReorderButtonClick.bind(this);
            return this;
        }
    }, {
        key: 'onReorderButtonClick',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
                var target, orderId, reorderObject, response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                target = (0, _jquery2.default)(e.currentTarget);
                                orderId = target.attr('data-order-id');
                                reorderObject = {
                                    orderId: orderId
                                };


                                target.addClass(_classes.LOADING_CLASS);
                                _context.prev = 4;
                                _context.next = 7;
                                return this.orderService.reorder(reorderObject);

                            case 7:
                                response = _context.sent;

                                if (response.success) {
                                    if (response.redirectUrl) {
                                        window.location = response.redirectUrl;
                                    } else {
                                        this.notifications.showErrorNotification('Success', _classes.SUCCESS_MESSAGE_CLASS);
                                        target.removeClass(_classes.LOADING_CLASS);
                                    }
                                } else {
                                    this.notifications.showErrorNotification(response.errorMessage, _classes.ALERT_MESSAGE_CLASS);
                                    target.removeClass(_classes.LOADING_CLASS);
                                }
                                _context.next = 14;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](4);

                                target.removeClass(_classes.LOADING_CLASS);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[4, 11]]);
            }));

            function onReorderButtonClick(_x) {
                return _ref.apply(this, arguments);
            }

            return onReorderButtonClick;
        }()
    }, {
        key: 'createChildren',
        value: function createChildren() {
            this.notifications = new _Notifications2.default();
            this.orderService = new _orderService2.default();

            this.$reorderButton = this.$element.find(SELECTORS.REORDER_BUTTON);
            return this;
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.$reorderButton.on('click', this.onReorderButtonClickHandler);
            return this;
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.$reorderButton.off('click', this.onReorderButtonClickHandler);
            return this;
        }
    }]);
    return ReorderView;
}();

exports.default = ReorderView;

},{"../constants/classes":169,"../global/Notifications":174,"../services/orderService":183,"babel-runtime/helpers/asyncToGenerator":14,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"babel-runtime/regenerator":21,"jquery":"jquery"}],206:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _classes = require('../constants/classes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An object of selectors used in this view
 * @property SELECTORS
 * @type {Object}
 * @final
 */
var SELECTORS = {
    TOGGLE_TRIGGER: '.js-toggleView-trigger',
    FOCUS_TARGET: '.js-toggleView-focusTarget'
};

/**
 * On event, it finds the toggle target and toggles an active class.
 *
 * @class ToggleView
 * @param {jQuery} [$trigger] Pass in containing dom element
 * @constructor
 */

var ToggleView = function () {
    function ToggleView($element, options) {
        (0, _classCallCheck3.default)(this, ToggleView);

        if (!$element) {
            throw 'Required $element configuration object not passed to ToggleView constructor';
        }

        if (!$element instanceof _jquery2.default) {
            // jshint ignore:line
            throw 'Required $element object passed to ToggleView constructor is the wrong type';
        }
        // If view element isn't on the page
        if (!$element.length) {
            return;
        }
        /**
         * A reference to the containing DOM element
         *
         * @property $element
         * @type {jQuery}
         * @public
         */
        this.$element = $element;

        /**
         * Tracks whether the view is enabled
         *
         * @default false
         * @property isEnabled
         * @type {Boolean}
         * @public
         */
        this.isEnabled = false;
        this.init();
    }

    (0, _createClass3.default)(ToggleView, [{
        key: 'init',


        /**
         * Initializes the UI Component View
         *
         * @method init
         * @public
         * @chainable
         */
        value: function init() {
            this.setupHandlers().createChildren().enable();
            return this;
        }
    }, {
        key: 'setupHandlers',

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @method setupHandlers
         * @public
         * @chainable
         */
        value: function setupHandlers() {
            this.onToggleMouseDownHandler = this.onToggleMouseDown.bind(this);
            this.onDocumentClickHandler = this.onDocumentClick.bind(this);
            this.onChildFocusHandler = this.onChildFocus.bind(this);
            this.onChildFocusOutHandler = this.onChildFocusOut.bind(this);

            return this;
        }
    }, {
        key: 'createChildren',

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @public
         * @chainable
         */
        value: function createChildren() {
            this.$toggleTrigger = this.$element.find(SELECTORS.TOGGLE_TRIGGER);
            this.$toggleTarget = this.determineTarget();
            this.$focusTarget = this.$element.find(SELECTORS.FOCUS_TARGET);

            if (this.$focusTarget.length) {
                this.$focusableChildren = this.$focusTarget.find('a, button, :input, [tabindex], select');
            }

            return this;
        }
    }, {
        key: 'determineTarget',

        /**
         * Determine Target
         *
         * @method determineTarget
         * @public
         * @chainable
         */
        value: function determineTarget() {
            if (this.$toggleTrigger.data('toggleTarget')) {
                return this.$toggleTarget = this.$element.find("." + this.$toggleTrigger.data('toggleTarget'));
            } else {
                return this.$toggleTarget = this.$element;
            }
        }

        /**
         * Clears active class when user clicks
         * off the parent element.
         *
         * @method onDocumentClickHandler
         * @public
         * @chainable
         */

    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            if (this.$element.find(e.target).length === 0) {
                this.$toggleTarget.removeClass(_classes.IS_ACTIVE_CLASS);
                this.$toggleTrigger.attr('aria-expanded', 'false');
                this.$element.find('[aria-hidden]').attr('aria-hidden', 'true');
            }

            return this;
        }

        /**
         * Handles adding focus active class
         * on focusTarget when focusTarget children have focus
         *
         * @method onChildFocus
         * @public
         * @chainable
         */

    }, {
        key: 'onChildFocus',
        value: function onChildFocus() {
            this.$toggleTarget.addClass(_classes.IS_FOCUS_ACTIVE_CLASS);
            if (this.$toggleTrigger.attr('aria-expanded') === 'false') {
                this.$toggleTrigger.attr('aria-expanded', 'true');
                this.$element.find('[aria-hidden]').attr('aria-hidden', 'false');
            }

            return this;
        }

        /**
         * Handles toggling focus active class
         * on focusTarget when focusTarget children have focus
         *
         * @method onChildFocusOut
         * @public
         * @chainable
         */

    }, {
        key: 'onChildFocusOut',
        value: function onChildFocusOut() {
            this.$toggleTarget.removeClass(_classes.IS_FOCUS_ACTIVE_CLASS);
            if (this.$toggleTrigger.attr('aria-expanded') === 'true' && !this.$element.hasClass(_classes.IS_ACTIVE_CLASS)) {
                this.$toggleTrigger.attr('aria-expanded', 'false');
                this.$element.find('[aria-hidden]').attr('aria-hidden', 'true');
            }

            return this;
        }

        /**
         * Enables the component
         * Performs any event binding to handlers
         *
         * @method enable
         * @public
         * @chainable
         */

    }, {
        key: 'enable',
        value: function enable() {
            if (this.isEnabled) {
                return this;
            }

            this.$toggleTrigger.on('click', this.onToggleMouseDownHandler);

            if (this.$element.data('toggleOffClick')) {
                (0, _jquery2.default)(document).on('click touchstart', this.onDocumentClickHandler);
            }

            if (this.$focusTarget.length) {
                this.$focusableChildren.on('focus', this.onChildFocusHandler);
                this.$focusableChildren.on('focusout', this.onChildFocusOutHandler);
            }

            this.isEnabled = true;
            return this;
        }
    }, {
        key: 'disable',

        /**
         * Disables the component
         * Tears down any event binding to handlers
         *
         * @method disable
         * @public
         * @chainable
         */
        value: function disable() {
            if (!this.isEnabled) {
                return this;
            }

            this.$toggleTrigger.off('click', this.onToggleMouseDownHandler);
            this.isEnabled = false;
            return this;
        }
    }, {
        key: 'onToggleMouseDown',


        /**
         * Toggles the active class on either the element
         * that was clicked on, or if specified, a separate
         * element specified by the "data-toggle-target"
         * attribute.
         * 
         * @method onToggleMouseDown
         * @public
         * @param {Object}
         */

        value: function onToggleMouseDown() {
            this.$toggleTarget.toggleClass(_classes.IS_ACTIVE_CLASS);
            if (this.$toggleTrigger.attr('aria-expanded') === 'true' && !this.$element.hasClass(_classes.IS_FOCUS_ACTIVE_CLASS)) {
                this.$toggleTrigger.attr('aria-expanded', 'false');
                this.$element.find('[aria-hidden]').attr('aria-hidden', 'true');
            } else if (this.$toggleTrigger.attr('aria-expanded') === 'false') {
                this.$toggleTrigger.attr('aria-expanded', 'true');
                this.$element.find('[aria-hidden]').attr('aria-hidden', 'false');
            } else {}

            /* Adds focus to an ID value provided by this data attribute */
            if (this.$toggleTrigger.data('focusTo')) {
                var focusToElement = document.getElementById(this.$toggleTrigger.data('focusTo'));
                focusToElement.focus();
            }

            return this;
        }
    }]);
    return ToggleView;
}();

exports.default = ToggleView;

},{"../constants/classes":169,"babel-runtime/helpers/classCallCheck":15,"babel-runtime/helpers/createClass":16,"jquery":"jquery"}]},{},[177])

